!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define(t)
    : ((e = 'undefined' != typeof globalThis ? globalThis : e || self).Swiper = t());
})(this, function () {
  'use strict';
  function s(e) {
    return null !== e && 'object' == typeof e && 'constructor' in e && e.constructor === Object;
  }
  function i(t, a) {
    void 0 === t && (t = {}),
      void 0 === a && (a = {}),
      Object.keys(a).forEach((e) => {
        void 0 === t[e] ? (t[e] = a[e]) : s(a[e]) && s(t[e]) && 0 < Object.keys(a[e]).length && i(t[e], a[e]);
      });
  }
  const t = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: '' },
    querySelector: () => null,
    querySelectorAll: () => [],
    getElementById: () => null,
    createEvent: () => ({ initEvent() {} }),
    createElement: () => ({
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName: () => [],
    }),
    createElementNS: () => ({}),
    importNode: () => null,
    location: { hash: '', host: '', hostname: '', href: '', origin: '', pathname: '', protocol: '', search: '' },
  };
  function L() {
    var e = 'undefined' != typeof document ? document : {};
    return i(e, t), e;
  }
  const P = {
    document: t,
    navigator: { userAgent: '' },
    location: { hash: '', host: '', hostname: '', href: '', origin: '', pathname: '', protocol: '', search: '' },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle: () => ({ getPropertyValue: () => '' }),
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia: () => ({}),
    requestAnimationFrame: (e) => ('undefined' == typeof setTimeout ? (e(), null) : setTimeout(e, 0)),
    cancelAnimationFrame(e) {
      'undefined' != typeof setTimeout && clearTimeout(e);
    },
  };
  function z() {
    var e = 'undefined' != typeof window ? window : {};
    return i(e, P), e;
  }
  function T(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t);
  }
  function g() {
    return Date.now();
  }
  function A(e, t) {
    void 0 === t && (t = 'x');
    const a = z();
    let s, i, r;
    const l = (function (e) {
      const t = z();
      let a;
      return (a =
        (a = !(a = t.getComputedStyle ? t.getComputedStyle(e, null) : a) && e.currentStyle ? e.currentStyle : a) ||
        e.style);
    })(e);
    return (
      a.WebKitCSSMatrix
        ? (6 < (i = l.transform || l.webkitTransform).split(',').length &&
            (i = i
              .split(', ')
              .map((e) => e.replace(',', '.'))
              .join(', ')),
          (r = new a.WebKitCSSMatrix('none' === i ? '' : i)))
        : ((r =
            l.MozTransform ||
            l.OTransform ||
            l.MsTransform ||
            l.msTransform ||
            l.transform ||
            l.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,')),
          (s = r.toString().split(','))),
      'x' === t && (i = a.WebKitCSSMatrix ? r.m41 : 16 === s.length ? parseFloat(s[12]) : parseFloat(s[4])),
      (i = 'y' === t ? (a.WebKitCSSMatrix ? r.m42 : 16 === s.length ? parseFloat(s[13]) : parseFloat(s[5])) : i) || 0
    );
  }
  function p(e) {
    return (
      'object' == typeof e && null !== e && e.constructor && 'Object' === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function h(e) {
    const a = Object(arguments.length <= 0 ? void 0 : e),
      s = ['__proto__', 'constructor', 'prototype'];
    for (let o = 1; o < arguments.length; o += 1) {
      var i = o < 0 || arguments.length <= o ? void 0 : arguments[o];
      if (
        null != i &&
        ((t = i),
        !('undefined' != typeof window && void 0 !== window.HTMLElement
          ? t instanceof HTMLElement
          : t && (1 === t.nodeType || 11 === t.nodeType)))
      ) {
        var r = Object.keys(Object(i)).filter((e) => s.indexOf(e) < 0);
        for (let e = 0, t = r.length; e < t; e += 1) {
          var l = r[e],
            n = Object.getOwnPropertyDescriptor(i, l);
          void 0 !== n &&
            n.enumerable &&
            (p(a[l]) && p(i[l])
              ? i[l].__swiper__
                ? (a[l] = i[l])
                : h(a[l], i[l])
              : !p(a[l]) && p(i[l])
              ? ((a[l] = {}), i[l].__swiper__ ? (a[l] = i[l]) : h(a[l], i[l]))
              : (a[l] = i[l]));
        }
      }
    }
    var t;
    return a;
  }
  function I(e, t, a) {
    e.style.setProperty(t, a);
  }
  function b(e) {
    let { swiper: a, targetPosition: s, side: i } = e;
    const r = z(),
      l = -a.translate;
    let n,
      o = null;
    const d = a.params.speed,
      p =
        ((a.wrapperEl.style.scrollSnapType = 'none'),
        r.cancelAnimationFrame(a.cssModeFrameID),
        s > l ? 'next' : 'prev'),
      c = (e, t) => ('next' === p && t <= e) || ('prev' === p && e <= t),
      u = () => {
        (n = new Date().getTime()), null === o && (o = n);
        var e = Math.max(Math.min((n - o) / d, 1), 0),
          e = 0.5 - Math.cos(e * Math.PI) / 2;
        let t = l + e * (s - l);
        if ((c(t, s) && (t = s), a.wrapperEl.scrollTo({ [i]: t }), c(t, s)))
          return (
            (a.wrapperEl.style.overflow = 'hidden'),
            (a.wrapperEl.style.scrollSnapType = ''),
            setTimeout(() => {
              (a.wrapperEl.style.overflow = ''), a.wrapperEl.scrollTo({ [i]: t });
            }),
            void r.cancelAnimationFrame(a.cssModeFrameID)
          );
        a.cssModeFrameID = r.requestAnimationFrame(u);
      };
    u();
  }
  function n(e) {
    return (
      e.querySelector('.swiper-slide-transform') ||
      (e.shadowEl && e.shadowEl.querySelector('.swiper-slide-transform')) ||
      e
    );
  }
  function k(e, t) {
    return void 0 === t && (t = ''), [...e.children].filter((e) => e.matches(t));
  }
  function O(e, t) {
    void 0 === t && (t = []);
    const a = document.createElement(e);
    return a.classList.add(...(Array.isArray(t) ? t : [t])), a;
  }
  function D(e) {
    var t = z(),
      a = L(),
      s = e.getBoundingClientRect(),
      a = a.body,
      i = e.clientTop || a.clientTop || 0,
      a = e.clientLeft || a.clientLeft || 0,
      r = e === t ? t.scrollY : e.scrollTop,
      t = e === t ? t.scrollX : e.scrollLeft;
    return { top: s.top + r - i, left: s.left + t - a };
  }
  function G(e, t) {
    return z().getComputedStyle(e, null).getPropertyValue(t);
  }
  function E(e) {
    let t,
      a = e;
    if (a) {
      for (t = 0; null !== (a = a.previousSibling); ) 1 === a.nodeType && (t += 1);
      return t;
    }
  }
  function H(e, t) {
    const a = [];
    let s = e.parentElement;
    for (; s; ) (t && !s.matches(t)) || a.push(s), (s = s.parentElement);
    return a;
  }
  function v(a, s) {
    s &&
      a.addEventListener('transitionend', function e(t) {
        t.target === a && (s.call(a, t), a.removeEventListener('transitionend', e));
      });
  }
  function X(e, t, a) {
    const s = z();
    return a
      ? e['width' === t ? 'offsetWidth' : 'offsetHeight'] +
          parseFloat(s.getComputedStyle(e, null).getPropertyValue('width' === t ? 'margin-right' : 'margin-top')) +
          parseFloat(s.getComputedStyle(e, null).getPropertyValue('width' === t ? 'margin-left' : 'margin-bottom'))
      : e.offsetWidth;
  }
  let a, d, c;
  function f() {
    return (a =
      a ||
      ((e = z()),
      {
        smoothScroll:
          (t = L()).documentElement && t.documentElement.style && 'scrollBehavior' in t.documentElement.style,
        touch: !!('ontouchstart' in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
      }));
    var e, t;
  }
  const r = (e, t) => {
      if (e && !e.destroyed && e.params) {
        const a = t.closest(e.isElement ? 'swiper-slide' : '.' + e.params.slideClass);
        if (a) {
          const t = a.querySelector('.' + e.params.lazyPreloaderClass);
          t && t.remove();
        }
      }
    },
    Y = (e, t) => {
      if (e.slides[t]) {
        const a = e.slides[t].querySelector('[loading="lazy"]');
        a && a.removeAttribute('loading');
      }
    },
    u = (s) => {
      if (s && !s.destroyed && s.params) {
        let a = s.params.lazyPreloadPrevNext;
        var i = s.slides.length;
        if (i && a && !(a < 0)) {
          a = Math.min(a, i);
          var e = 'auto' === s.params.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(s.params.slidesPerView),
            r = s.activeIndex,
            l = r + e - 1;
          if (s.params.rewind)
            for (let t = r - a; t <= l + a; t += 1) {
              const e = ((t % i) + i) % i;
              e !== r && e > l && Y(s, e);
            }
          else for (let e = Math.max(l - a, 0); e <= Math.min(l + a, i - 1); e += 1) e !== r && e > l && Y(s, e);
        }
      }
    };
  function B(e) {
    let { swiper: t, runCallbacks: a, direction: s, step: i } = e;
    var { activeIndex: r, previousIndex: l } = t;
    let n = s;
    if (((n = n || (l < r ? 'next' : r < l ? 'prev' : 'reset')), t.emit('transition' + i), a && r !== l)) {
      if ('reset' === n) return t.emit('slideResetTransition' + i);
      t.emit('slideChangeTransition' + i),
        'next' === n ? t.emit('slideNextTransition' + i) : t.emit('slidePrevTransition' + i);
    }
  }
  function $() {
    const e = this,
      { params: t, el: a } = e;
    var s, i, r, l, n;
    (a && 0 === a.offsetWidth) ||
      (t.breakpoints && e.setBreakpoint(),
      ({ allowSlideNext: s, allowSlidePrev: i, snapGrid: r } = e),
      (l = e.virtual && e.params.virtual.enabled),
      (e.allowSlideNext = !0),
      (e.allowSlidePrev = !0),
      e.updateSize(),
      e.updateSlides(),
      e.updateSlidesClasses(),
      (n = l && t.loop),
      !('auto' === t.slidesPerView || 1 < t.slidesPerView) || !e.isEnd || e.isBeginning || e.params.centeredSlides || n
        ? e.params.loop && !l
          ? e.slideToLoop(e.realIndex, 0, !1, !0)
          : e.slideTo(e.activeIndex, 0, !1, !0)
        : e.slideTo(e.slides.length - 1, 0, !1, !0),
      e.autoplay &&
        e.autoplay.running &&
        e.autoplay.paused &&
        (clearTimeout(e.autoplay.resizeTimeout),
        (e.autoplay.resizeTimeout = setTimeout(() => {
          e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
        }, 500))),
      (e.allowSlidePrev = i),
      (e.allowSlideNext = s),
      e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow());
  }
  let N = !1;
  function q() {}
  const R = (e, t) => {
      const a = L(),
        { params: s, el: i, wrapperEl: r, device: l } = e,
        n = !!s.nested,
        o = 'on' === t ? 'addEventListener' : 'removeEventListener',
        d = t;
      i[o]('pointerdown', e.onTouchStart, { passive: !1 }),
        a[o]('pointermove', e.onTouchMove, { passive: !1, capture: n }),
        a[o]('pointerup', e.onTouchEnd, { passive: !0 }),
        a[o]('pointercancel', e.onTouchEnd, { passive: !0 }),
        a[o]('pointerout', e.onTouchEnd, { passive: !0 }),
        a[o]('pointerleave', e.onTouchEnd, { passive: !0 }),
        (s.preventClicks || s.preventClicksPropagation) && i[o]('click', e.onClick, !0),
        s.cssMode && r[o]('scroll', e.onScroll),
        s.updateOnWindowResize
          ? e[d](l.ios || l.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $, !0)
          : e[d]('observerUpdate', $, !0),
        i[o]('load', e.onLoad, { capture: !0 });
    },
    F = (e, t) => e.grid && t.grid && 1 < t.grid.rows;
  var _ = {
    init: !0,
    direction: 'horizontal',
    oneWayMovement: !1,
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    enabled: !0,
    focusableElements: 'input, select, option, textarea, button, video, label',
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: 'slide',
    breakpoints: void 0,
    breakpointsBase: 'window',
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopedSlides: null,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  const l = {
      eventsEmitter: {
        on(e, t, a) {
          const s = this;
          if (!s.eventsListeners || s.destroyed) return s;
          if ('function' != typeof t) return s;
          const i = a ? 'unshift' : 'push';
          return (
            e.split(' ').forEach((e) => {
              s.eventsListeners[e] || (s.eventsListeners[e] = []), s.eventsListeners[e][i](t);
            }),
            s
          );
        },
        once(s, i, e) {
          const r = this;
          return !r.eventsListeners || r.destroyed || 'function' != typeof i
            ? r
            : ((l.__emitterProxy = i), r.on(s, l, e));
          function l() {
            r.off(s, l), l.__emitterProxy && delete l.__emitterProxy;
            for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) t[a] = arguments[a];
            i.apply(r, t);
          }
        },
        onAny(e, t) {
          var a = this;
          if (!a.eventsListeners || a.destroyed) return a;
          if ('function' != typeof e) return a;
          var s = t ? 'unshift' : 'push';
          return a.eventsAnyListeners.indexOf(e) < 0 && a.eventsAnyListeners[s](e), a;
        },
        offAny(e) {
          var t = this;
          if (!t.eventsListeners || t.destroyed) return t;
          if (!t.eventsAnyListeners) return t;
          var a = t.eventsAnyListeners.indexOf(e);
          return 0 <= a && t.eventsAnyListeners.splice(a, 1), t;
        },
        off(e, s) {
          const i = this;
          return (
            !i.eventsListeners ||
              i.destroyed ||
              (i.eventsListeners &&
                e.split(' ').forEach((a) => {
                  void 0 === s
                    ? (i.eventsListeners[a] = [])
                    : i.eventsListeners[a] &&
                      i.eventsListeners[a].forEach((e, t) => {
                        (e === s || (e.__emitterProxy && e.__emitterProxy === s)) && i.eventsListeners[a].splice(t, 1);
                      });
                })),
            i
          );
        },
        emit() {
          const e = this;
          if (!e.eventsListeners || e.destroyed) return e;
          if (!e.eventsListeners) return e;
          let t, a, s;
          for (var i = arguments.length, r = new Array(i), l = 0; l < i; l++) r[l] = arguments[l];
          return (
            (s =
              'string' == typeof r[0] || Array.isArray(r[0])
                ? ((t = r[0]), (a = r.slice(1, r.length)), e)
                : ((t = r[0].events), (a = r[0].data), r[0].context || e)),
            a.unshift(s),
            (Array.isArray(t) ? t : t.split(' ')).forEach((t) => {
              e.eventsAnyListeners &&
                e.eventsAnyListeners.length &&
                e.eventsAnyListeners.forEach((e) => {
                  e.apply(s, [t, ...a]);
                }),
                e.eventsListeners &&
                  e.eventsListeners[t] &&
                  e.eventsListeners[t].forEach((e) => {
                    e.apply(s, a);
                  });
            }),
            e
          );
        },
      },
      update: {
        updateSize: function () {
          var e = this;
          let t, a;
          var s = e.el;
          (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : s.clientWidth),
            (a = void 0 !== e.params.height && null !== e.params.height ? e.params.height : s.clientHeight),
            (0 === t && e.isHorizontal()) ||
              (0 === a && e.isVertical()) ||
              ((t = t - parseInt(G(s, 'padding-left') || 0, 10) - parseInt(G(s, 'padding-right') || 0, 10)),
              (a = a - parseInt(G(s, 'padding-top') || 0, 10) - parseInt(G(s, 'padding-bottom') || 0, 10)),
              Number.isNaN(t) && (t = 0),
              Number.isNaN(a) && (a = 0),
              Object.assign(e, { width: t, height: a, size: e.isHorizontal() ? t : a }));
        },
        updateSlides: function () {
          const s = this;
          function i(e) {
            return s.isHorizontal()
              ? e
              : {
                  width: 'height',
                  'margin-top': 'margin-left',
                  'margin-bottom ': 'margin-right',
                  'margin-left': 'margin-top',
                  'margin-right': 'margin-bottom',
                  'padding-left': 'padding-top',
                  'padding-right': 'padding-bottom',
                  marginRight: 'marginBottom',
                }[e];
          }
          function r(e, t) {
            return parseFloat(e.getPropertyValue(i(t)) || 0);
          }
          const l = s.params,
            { wrapperEl: n, slidesEl: e, size: o, rtlTranslate: d, wrongRTL: p } = s,
            c = s.virtual && l.virtual.enabled,
            u = (c ? s.virtual : s).slides.length,
            m = k(e, `.${s.params.slideClass}, swiper-slide`),
            h = (c ? s.virtual.slides : m).length;
          let f = [];
          const v = [],
            g = [];
          let w = l.slidesOffsetBefore,
            b = ('function' == typeof w && (w = l.slidesOffsetBefore.call(s)), l.slidesOffsetAfter);
          'function' == typeof b && (b = l.slidesOffsetAfter.call(s));
          var y = s.snapGrid.length,
            x = s.slidesGrid.length;
          let E = l.spaceBetween,
            S = -w,
            T = 0,
            M = 0;
          if (void 0 !== o) {
            'string' == typeof E && 0 <= E.indexOf('%')
              ? (E = (parseFloat(E.replace('%', '')) / 100) * o)
              : 'string' == typeof E && (E = parseFloat(E)),
              (s.virtualSize = -E),
              m.forEach((e) => {
                d ? (e.style.marginLeft = '') : (e.style.marginRight = ''),
                  (e.style.marginBottom = ''),
                  (e.style.marginTop = '');
              }),
              l.centeredSlides &&
                l.cssMode &&
                (I(n, '--swiper-centered-offset-before', ''), I(n, '--swiper-centered-offset-after', ''));
            var C = l.grid && 1 < l.grid.rows && s.grid;
            let t;
            C && s.grid.initSlides(h);
            var P =
              'auto' === l.slidesPerView &&
              l.breakpoints &&
              0 < Object.keys(l.breakpoints).filter((e) => void 0 !== l.breakpoints[e].slidesPerView).length;
            for (let a = 0; a < h; a += 1) {
              let e;
              if (
                ((t = 0), m[a] && (e = m[a]), C && s.grid.updateSlide(a, e, h, i), !m[a] || 'none' !== G(e, 'display'))
              ) {
                if ('auto' === l.slidesPerView) {
                  P && (m[a].style[i('width')] = '');
                  const o = getComputedStyle(e),
                    d = e.style.transform,
                    p = e.style.webkitTransform;
                  if ((d && (e.style.transform = 'none'), p && (e.style.webkitTransform = 'none'), l.roundLengths))
                    t = s.isHorizontal() ? X(e, 'width', !0) : X(e, 'height', !0);
                  else {
                    const s = r(o, 'width'),
                      i = r(o, 'padding-left'),
                      l = r(o, 'padding-right'),
                      n = r(o, 'margin-left'),
                      d = r(o, 'margin-right'),
                      p = o.getPropertyValue('box-sizing');
                    if (p && 'border-box' === p) t = s + n + d;
                    else {
                      const { clientWidth: r, offsetWidth: o } = e;
                      t = s + i + l + n + d + (o - r);
                    }
                  }
                  d && (e.style.transform = d),
                    p && (e.style.webkitTransform = p),
                    l.roundLengths && (t = Math.floor(t));
                } else
                  (t = (o - (l.slidesPerView - 1) * E) / l.slidesPerView),
                    l.roundLengths && (t = Math.floor(t)),
                    m[a] && (m[a].style[i('width')] = t + 'px');
                m[a] && (m[a].swiperSlideSize = t),
                  g.push(t),
                  l.centeredSlides
                    ? ((S = S + t / 2 + T / 2 + E),
                      0 === T && 0 !== a && (S = S - o / 2 - E),
                      0 === a && (S = S - o / 2 - E),
                      Math.abs(S) < 0.001 && (S = 0),
                      l.roundLengths && (S = Math.floor(S)),
                      M % l.slidesPerGroup == 0 && f.push(S),
                      v.push(S))
                    : (l.roundLengths && (S = Math.floor(S)),
                      (M - Math.min(s.params.slidesPerGroupSkip, M)) % s.params.slidesPerGroup == 0 && f.push(S),
                      v.push(S),
                      (S = S + t + E)),
                  (s.virtualSize += t + E),
                  (T = t),
                  (M += 1);
              }
            }
            if (
              ((s.virtualSize = Math.max(s.virtualSize, o) + b),
              d &&
                p &&
                ('slide' === l.effect || 'coverflow' === l.effect) &&
                (n.style.width = s.virtualSize + E + 'px'),
              l.setWrapperSize && (n.style[i('width')] = s.virtualSize + E + 'px'),
              C && s.grid.updateWrapperSize(t, f, i),
              !l.centeredSlides)
            ) {
              const i = [];
              for (let t = 0; t < f.length; t += 1) {
                let e = f[t];
                l.roundLengths && (e = Math.floor(e)), f[t] <= s.virtualSize - o && i.push(e);
              }
              (f = i), 1 < Math.floor(s.virtualSize - o) - Math.floor(f[f.length - 1]) && f.push(s.virtualSize - o);
            }
            if (c && l.loop) {
              const i = g[0] + E;
              if (1 < l.slidesPerGroup) {
                const r = Math.ceil((s.virtual.slidesBefore + s.virtual.slidesAfter) / l.slidesPerGroup),
                  n = i * l.slidesPerGroup;
                for (let e = 0; e < r; e += 1) f.push(f[f.length - 1] + n);
              }
              for (let e = 0; e < s.virtual.slidesBefore + s.virtual.slidesAfter; e += 1)
                1 === l.slidesPerGroup && f.push(f[f.length - 1] + i),
                  v.push(v[v.length - 1] + i),
                  (s.virtualSize += i);
            }
            if ((0 === f.length && (f = [0]), 0 !== E)) {
              const r = s.isHorizontal() && d ? 'marginLeft' : i('marginRight');
              m.filter((e, t) => !(l.cssMode && !l.loop) || t !== m.length - 1).forEach((e) => {
                e.style[r] = E + 'px';
              });
            }
            if (l.centeredSlides && l.centeredSlidesBounds) {
              let t = 0;
              g.forEach((e) => {
                t += e + (E || 0);
              });
              const i = (t -= E) - o;
              f = f.map((e) => (e < 0 ? -w : e > i ? i + b : e));
            }
            if (l.centerInsufficientSlides) {
              let t = 0;
              if (
                (g.forEach((e) => {
                  t += e + (E || 0);
                }),
                (t -= E) < o)
              ) {
                const i = (o - t) / 2;
                f.forEach((e, t) => {
                  f[t] = e - i;
                }),
                  v.forEach((e, t) => {
                    v[t] = e + i;
                  });
              }
            }
            if (
              (Object.assign(s, { slides: m, snapGrid: f, slidesGrid: v, slidesSizesGrid: g }),
              l.centeredSlides && l.cssMode && !l.centeredSlidesBounds)
            ) {
              I(n, '--swiper-centered-offset-before', -f[0] + 'px'),
                I(n, '--swiper-centered-offset-after', s.size / 2 - g[g.length - 1] / 2 + 'px');
              const i = -s.snapGrid[0],
                r = -s.slidesGrid[0];
              (s.snapGrid = s.snapGrid.map((e) => e + i)), (s.slidesGrid = s.slidesGrid.map((e) => e + r));
            }
            if (
              (h !== u && s.emit('slidesLengthChange'),
              f.length !== y && (s.params.watchOverflow && s.checkOverflow(), s.emit('snapGridLengthChange')),
              v.length !== x && s.emit('slidesGridLengthChange'),
              l.watchSlidesProgress && s.updateSlidesOffset(),
              !(c || l.cssMode || ('slide' !== l.effect && 'fade' !== l.effect)))
            ) {
              const i = l.containerModifierClass + 'backface-hidden',
                r = s.el.classList.contains(i);
              h <= l.maxBackfaceHiddenSlides ? r || s.el.classList.add(i) : r && s.el.classList.remove(i);
            }
          }
        },
        updateAutoHeight: function (e) {
          const t = this,
            a = [],
            s = t.virtual && t.params.virtual.enabled;
          let i,
            r = 0;
          'number' == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
          var l = (e) => (s ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
          if ('auto' !== t.params.slidesPerView && 1 < t.params.slidesPerView)
            if (t.params.centeredSlides)
              (t.visibleSlides || []).forEach((e) => {
                a.push(e);
              });
            else
              for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
                const e = t.activeIndex + i;
                if (e > t.slides.length && !s) break;
                a.push(l(e));
              }
          else a.push(l(t.activeIndex));
          for (i = 0; i < a.length; i += 1)
            if (void 0 !== a[i]) {
              const e = a[i].offsetHeight;
              r = e > r ? e : r;
            }
          (!r && 0 !== r) || (t.wrapperEl.style.height = r + 'px');
        },
        updateSlidesOffset: function () {
          const e = this,
            t = e.slides,
            a = e.isElement ? (e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop) : 0;
          for (let s = 0; s < t.length; s += 1)
            t[s].swiperSlideOffset =
              (e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop) - a - e.cssOverflowAdjustment();
        },
        updateSlidesProgress: function (e) {
          void 0 === e && (e = (this && this.translate) || 0);
          const i = this,
            r = i.params,
            { slides: l, rtlTranslate: n, snapGrid: o } = i;
          if (0 !== l.length) {
            void 0 === l[0].swiperSlideOffset && i.updateSlidesOffset();
            let t = n ? e : -e,
              a =
                (l.forEach((e) => {
                  e.classList.remove(r.slideVisibleClass);
                }),
                (i.visibleSlidesIndexes = []),
                (i.visibleSlides = []),
                r.spaceBetween);
            'string' == typeof a && 0 <= a.indexOf('%')
              ? (a = (parseFloat(a.replace('%', '')) / 100) * i.size)
              : 'string' == typeof a && (a = parseFloat(a));
            for (let s = 0; s < l.length; s += 1) {
              const m = l[s];
              let e = m.swiperSlideOffset;
              r.cssMode && r.centeredSlides && (e -= l[0].swiperSlideOffset);
              var d = (t + (r.centeredSlides ? i.minTranslate() : 0) - e) / (m.swiperSlideSize + a),
                p = (t - o[0] + (r.centeredSlides ? i.minTranslate() : 0) - e) / (m.swiperSlideSize + a),
                c = -(t - e),
                u = c + i.slidesSizesGrid[s];
              ((0 <= c && c < i.size - 1) || (1 < u && u <= i.size) || (c <= 0 && u >= i.size)) &&
                (i.visibleSlides.push(m), i.visibleSlidesIndexes.push(s), l[s].classList.add(r.slideVisibleClass)),
                (m.progress = n ? -d : d),
                (m.originalProgress = n ? -p : p);
            }
          }
        },
        updateProgress: function (e) {
          var t = this;
          if (void 0 === e) {
            const a = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * a) || 0;
          }
          const a = t.params,
            s = t.maxTranslate() - t.minTranslate();
          let { progress: i, isBeginning: r, isEnd: l, progressLoop: n } = t;
          const o = r,
            d = l;
          if (0 === s) (i = 0), (r = !0), (l = !0);
          else {
            i = (e - t.minTranslate()) / s;
            const a = Math.abs(e - t.minTranslate()) < 1,
              n = Math.abs(e - t.maxTranslate()) < 1;
            (r = a || i <= 0), (l = n || 1 <= i), a && (i = 0), n && (i = 1);
          }
          if (a.loop) {
            const a = t.getSlideIndexByData(0),
              s = t.getSlideIndexByData(t.slides.length - 1),
              i = t.slidesGrid[a],
              r = t.slidesGrid[s],
              l = t.slidesGrid[t.slidesGrid.length - 1],
              o = Math.abs(e);
            1 < (n = o >= i ? (o - i) / l : (o + l - r) / l) && --n;
          }
          Object.assign(t, { progress: i, progressLoop: n, isBeginning: r, isEnd: l }),
            (a.watchSlidesProgress || (a.centeredSlides && a.autoHeight)) && t.updateSlidesProgress(e),
            r && !o && t.emit('reachBeginning toEdge'),
            l && !d && t.emit('reachEnd toEdge'),
            ((o && !r) || (d && !l)) && t.emit('fromEdge'),
            t.emit('progress', i);
        },
        updateSlidesClasses: function () {
          const t = this,
            { slides: a, params: s, slidesEl: i, activeIndex: r } = t,
            e = t.virtual && s.virtual.enabled,
            l = (e) => k(i, `.${s.slideClass}${e}, swiper-slide` + e)[0];
          let n;
          if (
            (a.forEach((e) => {
              e.classList.remove(s.slideActiveClass, s.slideNextClass, s.slidePrevClass);
            }),
            e)
          )
            if (s.loop) {
              let e = r - t.virtual.slidesBefore;
              (e = e < 0 ? t.virtual.slides.length + e : e) >= t.virtual.slides.length &&
                (e -= t.virtual.slides.length),
                (n = l(`[data-swiper-slide-index="${e}"]`));
            } else n = l(`[data-swiper-slide-index="${r}"]`);
          else n = a[r];
          if (n) {
            n.classList.add(s.slideActiveClass);
            let e = (function (e, t) {
                const a = [];
                for (; e.nextElementSibling; ) {
                  const s = e.nextElementSibling;
                  (t && !s.matches(t)) || a.push(s), (e = s);
                }
                return a;
              })(n, `.${s.slideClass}, swiper-slide`)[0],
              t =
                ((e = s.loop && !e ? a[0] : e) && e.classList.add(s.slideNextClass),
                (function (e, t) {
                  const a = [];
                  for (; e.previousElementSibling; ) {
                    const s = e.previousElementSibling;
                    (t && !s.matches(t)) || a.push(s), (e = s);
                  }
                  return a;
                })(n, `.${s.slideClass}, swiper-slide`)[0]);
            (t = s.loop && 0 === !t ? a[a.length - 1] : t) && t.classList.add(s.slidePrevClass);
          }
          t.emitSlidesClasses();
        },
        updateActiveIndex: function (e) {
          const a = this,
            t = a.rtlTranslate ? a.translate : -a.translate,
            { snapGrid: s, params: i, activeIndex: r, realIndex: l, snapIndex: n } = a;
          let o,
            d = e;
          var p = (e) => {
            let t = e - a.virtual.slidesBefore;
            return (
              (t = t < 0 ? a.virtual.slides.length + t : t) >= a.virtual.slides.length &&
                (t -= a.virtual.slides.length),
              t
            );
          };
          if (
            (void 0 === d &&
              (d = (function (e) {
                var { slidesGrid: t, params: a } = e,
                  s = e.rtlTranslate ? e.translate : -e.translate;
                let i;
                for (let r = 0; r < t.length; r += 1)
                  void 0 !== t[r + 1]
                    ? s >= t[r] && s < t[r + 1] - (t[r + 1] - t[r]) / 2
                      ? (i = r)
                      : s >= t[r] && s < t[r + 1] && (i = r + 1)
                    : s >= t[r] && (i = r);
                return (i = a.normalizeSlideIndex && (i < 0 || void 0 === i) ? 0 : i);
              })(a)),
            0 <= s.indexOf(t))
          )
            o = s.indexOf(t);
          else {
            const e = Math.min(i.slidesPerGroupSkip, d);
            o = e + Math.floor((d - e) / i.slidesPerGroup);
          }
          if ((o >= s.length && (o = s.length - 1), d === r))
            return (
              o !== n && ((a.snapIndex = o), a.emit('snapIndexChange')),
              void (a.params.loop && a.virtual && a.params.virtual.enabled && (a.realIndex = p(d)))
            );
          (p =
            a.virtual && i.virtual.enabled && i.loop
              ? p(d)
              : a.slides[d]
              ? parseInt(a.slides[d].getAttribute('data-swiper-slide-index') || d, 10)
              : d),
            Object.assign(a, {
              previousSnapIndex: n,
              snapIndex: o,
              previousRealIndex: l,
              realIndex: p,
              previousIndex: r,
              activeIndex: d,
            }),
            a.initialized && u(a),
            a.emit('activeIndexChange'),
            a.emit('snapIndexChange'),
            l !== p && a.emit('realIndexChange'),
            (a.initialized || a.params.runCallbacksOnInit) && a.emit('slideChange');
        },
        updateClickedSlide: function (e) {
          const t = this,
            a = t.params,
            s = e.closest(`.${a.slideClass}, swiper-slide`);
          let i,
            r = !1;
          if (s)
            for (let e = 0; e < t.slides.length; e += 1)
              if (t.slides[e] === s) {
                (r = !0), (i = e);
                break;
              }
          if (!s || !r) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
          (t.clickedSlide = s),
            t.virtual && t.params.virtual.enabled
              ? (t.clickedIndex = parseInt(s.getAttribute('data-swiper-slide-index'), 10))
              : (t.clickedIndex = i),
            a.slideToClickedSlide &&
              void 0 !== t.clickedIndex &&
              t.clickedIndex !== t.activeIndex &&
              t.slideToClickedSlide();
        },
      },
      translate: {
        getTranslate: function (e) {
          void 0 === e && (e = this.isHorizontal() ? 'x' : 'y');
          var { params: t, rtlTranslate: a, translate: s, wrapperEl: i } = this;
          if (t.virtualTranslate) return a ? -s : s;
          if (t.cssMode) return s;
          let r = A(i, e);
          return (r += this.cssOverflowAdjustment()), (r = a ? -r : r) || 0;
        },
        setTranslate: function (e, t) {
          const a = this,
            { rtlTranslate: s, params: i, wrapperEl: r, progress: l } = a;
          let n = 0,
            o = 0;
          a.isHorizontal() ? (n = s ? -e : e) : (o = e),
            i.roundLengths && ((n = Math.floor(n)), (o = Math.floor(o))),
            (a.previousTranslate = a.translate),
            (a.translate = a.isHorizontal() ? n : o),
            i.cssMode
              ? (r[a.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = a.isHorizontal() ? -n : -o)
              : i.virtualTranslate ||
                (a.isHorizontal() ? (n -= a.cssOverflowAdjustment()) : (o -= a.cssOverflowAdjustment()),
                (r.style.transform = `translate3d(${n}px, ${o}px, 0px)`));
          var d = a.maxTranslate() - a.minTranslate();
          (0 == d ? 0 : (e - a.minTranslate()) / d) !== l && a.updateProgress(e),
            a.emit('setTranslate', a.translate, t);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e, t, a, s, i) {
          void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === a && (a = !0),
            void 0 === s && (s = !0);
          const r = this,
            { params: l, wrapperEl: n } = r;
          if (r.animating && l.preventInteractionOnTransition) return !1;
          var o = r.minTranslate(),
            d = r.maxTranslate(),
            o = s && o < e ? o : s && e < d ? d : e;
          if ((r.updateProgress(o), l.cssMode)) {
            const e = r.isHorizontal();
            if (0 === t) n[e ? 'scrollLeft' : 'scrollTop'] = -o;
            else {
              if (!r.support.smoothScroll) return b({ swiper: r, targetPosition: -o, side: e ? 'left' : 'top' }), !0;
              n.scrollTo({ [e ? 'left' : 'top']: -o, behavior: 'smooth' });
            }
            return !0;
          }
          return (
            0 === t
              ? (r.setTransition(0),
                r.setTranslate(o),
                a && (r.emit('beforeTransitionStart', t, i), r.emit('transitionEnd')))
              : (r.setTransition(t),
                r.setTranslate(o),
                a && (r.emit('beforeTransitionStart', t, i), r.emit('transitionStart')),
                r.animating ||
                  ((r.animating = !0),
                  r.onTranslateToWrapperTransitionEnd ||
                    (r.onTranslateToWrapperTransitionEnd = function (e) {
                      r &&
                        !r.destroyed &&
                        e.target === this &&
                        (r.wrapperEl.removeEventListener('transitionend', r.onTranslateToWrapperTransitionEnd),
                        (r.onTranslateToWrapperTransitionEnd = null),
                        delete r.onTranslateToWrapperTransitionEnd,
                        a && r.emit('transitionEnd'));
                    }),
                  r.wrapperEl.addEventListener('transitionend', r.onTranslateToWrapperTransitionEnd))),
            !0
          );
        },
      },
      transition: {
        setTransition: function (e, t) {
          this.params.cssMode || (this.wrapperEl.style.transitionDuration = e + 'ms'), this.emit('setTransition', e, t);
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0);
          var a = this['params'];
          a.cssMode ||
            (a.autoHeight && this.updateAutoHeight(),
            B({ swiper: this, runCallbacks: e, direction: t, step: 'Start' }));
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0);
          var a = this['params'];
          (this.animating = !1),
            a.cssMode || (this.setTransition(0), B({ swiper: this, runCallbacks: e, direction: t, step: 'End' }));
        },
      },
      slide: {
        slideTo: function (e, t, a, s, i) {
          void 0 === t && (t = this.params.speed),
            void 0 === a && (a = !0),
            'string' == typeof (e = void 0 === e ? 0 : e) && (e = parseInt(e, 10));
          const r = this;
          let l = e;
          l < 0 && (l = 0);
          const {
            params: n,
            snapGrid: o,
            slidesGrid: d,
            previousIndex: p,
            activeIndex: c,
            rtlTranslate: u,
            wrapperEl: m,
            enabled: h,
          } = r;
          if ((r.animating && n.preventInteractionOnTransition) || (!h && !s && !i)) return !1;
          var f = Math.min(r.params.slidesPerGroupSkip, l);
          let v = f + Math.floor((l - f) / r.params.slidesPerGroup);
          var g = -o[(v = v >= o.length ? o.length - 1 : v)];
          if (n.normalizeSlideIndex)
            for (let e = 0; e < d.length; e += 1) {
              const t = -Math.floor(100 * g),
                a = Math.floor(100 * d[e]),
                s = Math.floor(100 * d[e + 1]);
              void 0 !== d[e + 1]
                ? t >= a && t < s - (s - a) / 2
                  ? (l = e)
                  : t >= a && t < s && (l = e + 1)
                : t >= a && (l = e);
            }
          if (r.initialized && l !== c) {
            if (!r.allowSlideNext && g < r.translate && g < r.minTranslate()) return !1;
            if (!r.allowSlidePrev && g > r.translate && g > r.maxTranslate() && (c || 0) !== l) return !1;
          }
          let w;
          if (
            (l !== (p || 0) && a && r.emit('beforeSlideChangeStart'),
            r.updateProgress(g),
            (w = l > c ? 'next' : l < c ? 'prev' : 'reset'),
            (u && -g === r.translate) || (!u && g === r.translate))
          )
            return (
              r.updateActiveIndex(l),
              n.autoHeight && r.updateAutoHeight(),
              r.updateSlidesClasses(),
              'slide' !== n.effect && r.setTranslate(g),
              'reset' != w && (r.transitionStart(a, w), r.transitionEnd(a, w)),
              !1
            );
          if (n.cssMode) {
            const e = r.isHorizontal(),
              a = u ? g : -g;
            if (0 === t) {
              const t = r.virtual && r.params.virtual.enabled;
              t && ((r.wrapperEl.style.scrollSnapType = 'none'), (r._immediateVirtual = !0)),
                t && !r._cssModeVirtualInitialSet && 0 < r.params.initialSlide
                  ? ((r._cssModeVirtualInitialSet = !0),
                    requestAnimationFrame(() => {
                      m[e ? 'scrollLeft' : 'scrollTop'] = a;
                    }))
                  : (m[e ? 'scrollLeft' : 'scrollTop'] = a),
                t &&
                  requestAnimationFrame(() => {
                    (r.wrapperEl.style.scrollSnapType = ''), (r._immediateVirtual = !1);
                  });
            } else {
              if (!r.support.smoothScroll) return b({ swiper: r, targetPosition: a, side: e ? 'left' : 'top' }), !0;
              m.scrollTo({ [e ? 'left' : 'top']: a, behavior: 'smooth' });
            }
            return !0;
          }
          return (
            r.setTransition(t),
            r.setTranslate(g),
            r.updateActiveIndex(l),
            r.updateSlidesClasses(),
            r.emit('beforeTransitionStart', t, s),
            r.transitionStart(a, w),
            0 === t
              ? r.transitionEnd(a, w)
              : r.animating ||
                ((r.animating = !0),
                r.onSlideToWrapperTransitionEnd ||
                  (r.onSlideToWrapperTransitionEnd = function (e) {
                    r &&
                      !r.destroyed &&
                      e.target === this &&
                      (r.wrapperEl.removeEventListener('transitionend', r.onSlideToWrapperTransitionEnd),
                      (r.onSlideToWrapperTransitionEnd = null),
                      delete r.onSlideToWrapperTransitionEnd,
                      r.transitionEnd(a, w));
                  }),
                r.wrapperEl.addEventListener('transitionend', r.onSlideToWrapperTransitionEnd)),
            !0
          );
        },
        slideToLoop: function (e, t, a, s) {
          void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
          var i = this;
          let r = (e = 'string' == typeof (e = void 0 === e ? 0 : e) ? parseInt(e, 10) : e);
          return (
            i.params.loop &&
              (i.virtual && i.params.virtual.enabled ? (r += i.virtual.slidesBefore) : (r = i.getSlideIndexByData(r))),
            i.slideTo(r, t, a, s)
          );
        },
        slideNext: function (e, t, a) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          var s = this,
            { enabled: i, params: r, animating: l } = s;
          if (!i) return s;
          let n = r.slidesPerGroup;
          'auto' === r.slidesPerView &&
            1 === r.slidesPerGroup &&
            r.slidesPerGroupAuto &&
            (n = Math.max(s.slidesPerViewDynamic('current', !0), 1));
          var i = s.activeIndex < r.slidesPerGroupSkip ? 1 : n,
            o = s.virtual && r.virtual.enabled;
          if (r.loop) {
            if (l && !o && r.loopPreventsSliding) return !1;
            s.loopFix({ direction: 'next' }), (s._clientLeft = s.wrapperEl.clientLeft);
          }
          return r.rewind && s.isEnd ? s.slideTo(0, e, t, a) : s.slideTo(s.activeIndex + i, e, t, a);
        },
        slidePrev: function (e, t, a) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          const s = this,
            { params: i, snapGrid: r, slidesGrid: l, rtlTranslate: n, enabled: o, animating: d } = s;
          if (!o) return s;
          var p = s.virtual && i.virtual.enabled;
          if (i.loop) {
            if (d && !p && i.loopPreventsSliding) return !1;
            s.loopFix({ direction: 'prev' }), (s._clientLeft = s.wrapperEl.clientLeft);
          }
          function c(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          const u = c(n ? s.translate : -s.translate),
            m = r.map((e) => c(e));
          let h = r[m.indexOf(u) - 1];
          if (void 0 === h && i.cssMode) {
            let a;
            r.forEach((e, t) => {
              u >= e && (a = t);
            }),
              void 0 !== a && (h = r[0 < a ? a - 1 : a]);
          }
          let f = 0;
          if (
            (void 0 !== h &&
              ((f = l.indexOf(h)) < 0 && (f = s.activeIndex - 1),
              'auto' === i.slidesPerView &&
                1 === i.slidesPerGroup &&
                i.slidesPerGroupAuto &&
                ((f = f - s.slidesPerViewDynamic('previous', !0) + 1), (f = Math.max(f, 0)))),
            i.rewind && s.isBeginning)
          ) {
            const i =
              s.params.virtual && s.params.virtual.enabled && s.virtual
                ? s.virtual.slides.length - 1
                : s.slides.length - 1;
            return s.slideTo(i, e, t, a);
          }
          return s.slideTo(f, e, t, a);
        },
        slideReset: function (e, t, a) {
          return (
            void 0 === e && (e = this.params.speed), this.slideTo(this.activeIndex, e, (t = void 0 === t ? !0 : t), a)
          );
        },
        slideToClosest: function (e, t, a, s) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === s && (s = 0.5);
          var i = this;
          let r = i.activeIndex;
          var l = Math.min(i.params.slidesPerGroupSkip, r),
            l = l + Math.floor((r - l) / i.params.slidesPerGroup),
            n = i.rtlTranslate ? i.translate : -i.translate;
          if (n >= i.snapGrid[l]) {
            const e = i.snapGrid[l];
            n - e > (i.snapGrid[l + 1] - e) * s && (r += i.params.slidesPerGroup);
          } else {
            const e = i.snapGrid[l - 1];
            n - e <= (i.snapGrid[l] - e) * s && (r -= i.params.slidesPerGroup);
          }
          return (r = Math.max(r, 0)), (r = Math.min(r, i.slidesGrid.length - 1)), i.slideTo(r, e, t, a);
        },
        slideToClickedSlide: function () {
          const e = this,
            { params: t, slidesEl: a } = e,
            s = 'auto' === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
          let i,
            r = e.clickedIndex;
          var l = e.isElement ? 'swiper-slide' : '.' + t.slideClass;
          t.loop
            ? e.animating ||
              ((i = parseInt(e.clickedSlide.getAttribute('data-swiper-slide-index'), 10)),
              t.centeredSlides
                ? r < e.loopedSlides - s / 2 || r > e.slides.length - e.loopedSlides + s / 2
                  ? (e.loopFix(),
                    (r = e.getSlideIndex(k(a, l + `[data-swiper-slide-index="${i}"]`)[0])),
                    T(() => {
                      e.slideTo(r);
                    }))
                  : e.slideTo(r)
                : r > e.slides.length - s
                ? (e.loopFix(),
                  (r = e.getSlideIndex(k(a, l + `[data-swiper-slide-index="${i}"]`)[0])),
                  T(() => {
                    e.slideTo(r);
                  }))
                : e.slideTo(r))
            : e.slideTo(r);
        },
      },
      loop: {
        loopCreate: function (e) {
          var { params: t, slidesEl: a } = this;
          !t.loop ||
            (this.virtual && this.params.virtual.enabled) ||
            (k(a, `.${t.slideClass}, swiper-slide`).forEach((e, t) => {
              e.setAttribute('data-swiper-slide-index', t);
            }),
            this.loopFix({ slideRealIndex: e, direction: t.centeredSlides ? void 0 : 'next' }));
        },
        loopFix: function (i) {
          let {
            slideRealIndex: r,
            slideTo: l = !0,
            direction: n,
            setTranslate: o,
            activeSlideIndex: d,
            byController: p,
            byMousewheel: c,
          } = void 0 === i ? {} : i;
          const u = this;
          if (u.params.loop) {
            u.emit('beforeLoopFix');
            const { slides: f, allowSlidePrev: v, allowSlideNext: g, slidesEl: w, params: b } = u;
            if (((u.allowSlidePrev = !0), (u.allowSlideNext = !0), u.virtual && b.virtual.enabled))
              return (
                l &&
                  (b.centeredSlides || 0 !== u.snapIndex
                    ? b.centeredSlides && u.snapIndex < b.slidesPerView
                      ? u.slideTo(u.virtual.slides.length + u.snapIndex, 0, !1, !0)
                      : u.snapIndex === u.snapGrid.length - 1 && u.slideTo(u.virtual.slidesBefore, 0, !1, !0)
                    : u.slideTo(u.virtual.slides.length, 0, !1, !0)),
                (u.allowSlidePrev = v),
                (u.allowSlideNext = g),
                void u.emit('loopFix')
              );
            var m = 'auto' === b.slidesPerView ? u.slidesPerViewDynamic() : Math.ceil(parseFloat(b.slidesPerView, 10));
            let t = b.loopedSlides || m;
            t % b.slidesPerGroup != 0 && (t += b.slidesPerGroup - (t % b.slidesPerGroup)), (u.loopedSlides = t);
            const y = [],
              x = [];
            let e = u.activeIndex;
            void 0 === d
              ? (d = u.getSlideIndex(u.slides.filter((e) => e.classList.contains(b.slideActiveClass))[0]))
              : (e = d);
            var m = 'next' === n || !n,
              h = 'prev' === n || !n;
            let a = 0,
              s = 0;
            if (d < t) {
              a = Math.max(t - d, b.slidesPerGroup);
              for (let e = 0; e < t - d; e += 1) {
                const r = e - Math.floor(e / f.length) * f.length;
                y.push(f.length - r - 1);
              }
            } else if (d > u.slides.length - 2 * t) {
              s = Math.max(d - (u.slides.length - 2 * t), b.slidesPerGroup);
              for (let e = 0; e < s; e += 1) {
                const r = e - Math.floor(e / f.length) * f.length;
                x.push(r);
              }
            }
            if (
              (h &&
                y.forEach((e) => {
                  (u.slides[e].swiperLoopMoveDOM = !0), w.prepend(u.slides[e]), (u.slides[e].swiperLoopMoveDOM = !1);
                }),
              m &&
                x.forEach((e) => {
                  (u.slides[e].swiperLoopMoveDOM = !0), w.append(u.slides[e]), (u.slides[e].swiperLoopMoveDOM = !1);
                }),
              u.recalcSlides(),
              'auto' === b.slidesPerView && u.updateSlides(),
              b.watchSlidesProgress && u.updateSlidesOffset(),
              l)
            )
              if (0 < y.length && h)
                if (void 0 === r) {
                  const i = u.slidesGrid[e],
                    r = u.slidesGrid[e + a] - i;
                  c
                    ? u.setTranslate(u.translate - r)
                    : (u.slideTo(e + a, 0, !1, !0), o && (u.touches[u.isHorizontal() ? 'startX' : 'startY'] += r));
                } else o && u.slideToLoop(r, 0, !1, !0);
              else if (0 < x.length && m)
                if (void 0 === r) {
                  const i = u.slidesGrid[e],
                    r = u.slidesGrid[e - s] - i;
                  c
                    ? u.setTranslate(u.translate - r)
                    : (u.slideTo(e - s, 0, !1, !0), o && (u.touches[u.isHorizontal() ? 'startX' : 'startY'] += r));
                } else u.slideToLoop(r, 0, !1, !0);
            if (((u.allowSlidePrev = v), (u.allowSlideNext = g), u.controller && u.controller.control && !p)) {
              const i = {
                slideRealIndex: r,
                slideTo: !1,
                direction: n,
                setTranslate: o,
                activeSlideIndex: d,
                byController: !0,
              };
              Array.isArray(u.controller.control)
                ? u.controller.control.forEach((e) => {
                    !e.destroyed && e.params.loop && e.loopFix(i);
                  })
                : u.controller.control instanceof u.constructor &&
                  u.controller.control.params.loop &&
                  u.controller.control.loopFix(i);
            }
            u.emit('loopFix');
          }
        },
        loopDestroy: function () {
          const e = this,
            { params: t, slidesEl: a } = e;
          if (!(!t.loop || (e.virtual && e.params.virtual.enabled))) {
            e.recalcSlides();
            const s = [];
            e.slides.forEach((e) => {
              var t = void 0 === e.swiperSlideIndex ? +e.getAttribute('data-swiper-slide-index') : e.swiperSlideIndex;
              s[t] = e;
            }),
              e.slides.forEach((e) => {
                e.removeAttribute('data-swiper-slide-index');
              }),
              s.forEach((e) => {
                a.append(e);
              }),
              e.recalcSlides(),
              e.slideTo(e.realIndex, 0);
          }
        },
      },
      grabCursor: {
        setGrabCursor: function (e) {
          const t = this;
          if (!(!t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode)) {
            const a = 'container' === t.params.touchEventsTarget ? t.el : t.wrapperEl;
            t.isElement && (t.__preventObserver__ = !0),
              (a.style.cursor = 'move'),
              (a.style.cursor = e ? 'grabbing' : 'grab'),
              t.isElement &&
                requestAnimationFrame(() => {
                  t.__preventObserver__ = !1;
                });
          }
        },
        unsetGrabCursor: function () {
          const e = this;
          (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.isElement && (e.__preventObserver__ = !0),
            (e['container' === e.params.touchEventsTarget ? 'el' : 'wrapperEl'].style.cursor = ''),
            e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
              }));
        },
      },
      events: {
        attachEvents: function () {
          const e = this,
            t = L(),
            a = e['params'];
          (e.onTouchStart = function (s) {
            const i = this,
              r = L(),
              l = z(),
              n = i.touchEventsData,
              { params: o, touches: d, enabled: e } = (n.evCache.push(s), i);
            if (
              e &&
              (o.simulateTouch || 'mouse' !== s.pointerType) &&
              (!i.animating || !o.preventInteractionOnTransition)
            ) {
              !i.animating && o.cssMode && o.loop && i.loopFix();
              let t = s,
                a = (t = t.originalEvent ? t.originalEvent : t).target;
              if (
                ('wrapper' !== o.touchEventsTarget || i.wrapperEl.contains(a)) &&
                !(('which' in t && 3 === t.which) || ('button' in t && 0 < t.button) || (n.isTouched && n.isMoved))
              ) {
                var p = !!o.noSwipingClass && '' !== o.noSwipingClass,
                  c = s.composedPath ? s.composedPath() : s.path,
                  p =
                    (p && t.target && t.target.shadowRoot && c && (a = c[0]),
                    o.noSwipingSelector || '.' + o.noSwipingClass),
                  c = !(!t.target || !t.target.shadowRoot);
                if (
                  o.noSwiping &&
                  (c
                    ? (function (s, e) {
                        return (function e(t) {
                          if (!t || t === L() || t === z()) return null;
                          var a = (t = t.assignedSlot ? t.assignedSlot : t).closest(s);
                          return a || t.getRootNode ? a || e(t.getRootNode().host) : null;
                        })((e = void 0 === a ? this : e));
                      })(p, a)
                    : a.closest(p))
                )
                  i.allowClick = !0;
                else if (!o.swipeHandler || a.closest(o.swipeHandler)) {
                  (d.currentX = t.pageX), (d.currentY = t.pageY);
                  var c = d.currentX,
                    p = d.currentY,
                    u = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection,
                    m = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
                  if (u && (c <= m || c >= l.innerWidth - m)) {
                    if ('prevent' !== u) return;
                    s.preventDefault();
                  }
                  Object.assign(n, {
                    isTouched: !0,
                    isMoved: !1,
                    allowTouchCallbacks: !0,
                    isScrolling: void 0,
                    startMoving: void 0,
                  }),
                    (d.startX = c),
                    (d.startY = p),
                    (n.touchStartTime = g()),
                    (i.allowClick = !0),
                    i.updateSize(),
                    (i.swipeDirection = void 0),
                    0 < o.threshold && (n.allowThresholdMove = !1);
                  let e = !0;
                  a.matches(n.focusableElements) && ((e = !1), 'SELECT' === a.nodeName && (n.isTouched = !1)),
                    r.activeElement &&
                      r.activeElement.matches(n.focusableElements) &&
                      r.activeElement !== a &&
                      r.activeElement.blur();
                  m = e && i.allowTouchMove && o.touchStartPreventDefault;
                  (!o.touchStartForcePreventDefault && !m) || a.isContentEditable || t.preventDefault(),
                    i.params.freeMode &&
                      i.params.freeMode.enabled &&
                      i.freeMode &&
                      i.animating &&
                      !o.cssMode &&
                      i.freeMode.onTouchStart(),
                    i.emit('touchStart', t);
                }
              }
            }
          }.bind(e)),
            (e.onTouchMove = function (l) {
              const e = L(),
                n = this,
                o = n.touchEventsData,
                { params: d, touches: p, rtlTranslate: c, enabled: t } = n;
              if (t && (d.simulateTouch || 'mouse' !== l.pointerType)) {
                let r = l;
                if ((r.originalEvent && (r = r.originalEvent), o.isTouched)) {
                  var u = o.evCache.findIndex((e) => e.pointerId === r.pointerId),
                    u = (0 <= u && (o.evCache[u] = r), 1 < o.evCache.length ? o.evCache[0] : r),
                    m = u.pageX,
                    u = u.pageY;
                  if (r.preventedByNestedSwiper) return (p.startX = m), void (p.startY = u);
                  if (!n.allowTouchMove)
                    return (
                      r.target.matches(o.focusableElements) || (n.allowClick = !1),
                      void (
                        o.isTouched &&
                        (Object.assign(p, {
                          startX: m,
                          startY: u,
                          prevX: n.touches.currentX,
                          prevY: n.touches.currentY,
                          currentX: m,
                          currentY: u,
                        }),
                        (o.touchStartTime = g()))
                      )
                    );
                  if (d.touchReleaseOnEdges && !d.loop)
                    if (n.isVertical()) {
                      if (
                        (u < p.startY && n.translate <= n.maxTranslate()) ||
                        (u > p.startY && n.translate >= n.minTranslate())
                      )
                        return (o.isTouched = !1), void (o.isMoved = !1);
                    } else if (
                      (m < p.startX && n.translate <= n.maxTranslate()) ||
                      (m > p.startX && n.translate >= n.minTranslate())
                    )
                      return;
                  if (e.activeElement && r.target === e.activeElement && r.target.matches(o.focusableElements))
                    return (o.isMoved = !0), void (n.allowClick = !1);
                  if (
                    (o.allowTouchCallbacks && n.emit('touchMove', r), !(r.targetTouches && 1 < r.targetTouches.length))
                  ) {
                    (p.currentX = m), (p.currentY = u);
                    (m = p.currentX - p.startX), (u = p.currentY - p.startY);
                    if (!(n.params.threshold && Math.sqrt(m ** 2 + u ** 2) < n.params.threshold))
                      if (
                        (void 0 === o.isScrolling &&
                          ((n.isHorizontal() && p.currentY === p.startY) || (n.isVertical() && p.currentX === p.startX)
                            ? (o.isScrolling = !1)
                            : 25 <= m * m + u * u &&
                              ((h = (180 * Math.atan2(Math.abs(u), Math.abs(m))) / Math.PI),
                              (o.isScrolling = n.isHorizontal() ? h > d.touchAngle : 90 - h > d.touchAngle))),
                        o.isScrolling && n.emit('touchMoveOpposite', r),
                        void 0 !== o.startMoving ||
                          (p.currentX === p.startX && p.currentY === p.startY) ||
                          (o.startMoving = !0),
                        o.isScrolling || (n.zoom && n.params.zoom && n.params.zoom.enabled && 1 < o.evCache.length))
                      )
                        o.isTouched = !1;
                      else if (o.startMoving) {
                        (n.allowClick = !1),
                          !d.cssMode && r.cancelable && r.preventDefault(),
                          d.touchMoveStopPropagation && !d.nested && r.stopPropagation();
                        let e = n.isHorizontal() ? m : u,
                          t = n.isHorizontal() ? p.currentX - p.previousX : p.currentY - p.previousY;
                        d.oneWayMovement && ((e = Math.abs(e) * (c ? 1 : -1)), (t = Math.abs(t) * (c ? 1 : -1))),
                          (p.diff = e),
                          (e *= d.touchRatio),
                          c && ((e = -e), (t = -t));
                        var h = n.touchesDirection,
                          m =
                            ((n.swipeDirection = 0 < e ? 'prev' : 'next'),
                            (n.touchesDirection = 0 < t ? 'prev' : 'next'),
                            n.params.loop && !d.cssMode);
                        if (!o.isMoved) {
                          if (
                            (m && n.loopFix({ direction: n.swipeDirection }),
                            (o.startTranslate = n.getTranslate()),
                            n.setTransition(0),
                            n.animating)
                          ) {
                            const l = new window.CustomEvent('transitionend', { bubbles: !0, cancelable: !0 });
                            n.wrapperEl.dispatchEvent(l);
                          }
                          (o.allowMomentumBounce = !1),
                            !d.grabCursor ||
                              (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) ||
                              n.setGrabCursor(!0),
                            n.emit('sliderFirstMove', r);
                        }
                        let a,
                          s =
                            (o.isMoved &&
                              h !== n.touchesDirection &&
                              m &&
                              1 <= Math.abs(e) &&
                              (n.loopFix({ direction: n.swipeDirection, setTranslate: !0 }), (a = !0)),
                            n.emit('sliderMove', r),
                            (o.isMoved = !0),
                            (o.currentTranslate = e + o.startTranslate),
                            !0),
                          i = d.resistanceRatio;
                        if (
                          (d.touchReleaseOnEdges && (i = 0),
                          0 < e
                            ? (m &&
                                !a &&
                                o.currentTranslate >
                                  (d.centeredSlides ? n.minTranslate() - n.size / 2 : n.minTranslate()) &&
                                n.loopFix({ direction: 'prev', setTranslate: !0, activeSlideIndex: 0 }),
                              o.currentTranslate > n.minTranslate() &&
                                ((s = !1),
                                d.resistance &&
                                  (o.currentTranslate =
                                    n.minTranslate() - 1 + (-n.minTranslate() + o.startTranslate + e) ** i)))
                            : e < 0 &&
                              (m &&
                                !a &&
                                o.currentTranslate <
                                  (d.centeredSlides ? n.maxTranslate() + n.size / 2 : n.maxTranslate()) &&
                                n.loopFix({
                                  direction: 'next',
                                  setTranslate: !0,
                                  activeSlideIndex:
                                    n.slides.length -
                                    ('auto' === d.slidesPerView
                                      ? n.slidesPerViewDynamic()
                                      : Math.ceil(parseFloat(d.slidesPerView, 10))),
                                }),
                              o.currentTranslate < n.maxTranslate() &&
                                ((s = !1),
                                d.resistance &&
                                  (o.currentTranslate =
                                    n.maxTranslate() + 1 - (n.maxTranslate() - o.startTranslate - e) ** i))),
                          s && (r.preventedByNestedSwiper = !0),
                          !n.allowSlideNext &&
                            'next' === n.swipeDirection &&
                            o.currentTranslate < o.startTranslate &&
                            (o.currentTranslate = o.startTranslate),
                          !n.allowSlidePrev &&
                            'prev' === n.swipeDirection &&
                            o.currentTranslate > o.startTranslate &&
                            (o.currentTranslate = o.startTranslate),
                          n.allowSlidePrev || n.allowSlideNext || (o.currentTranslate = o.startTranslate),
                          0 < d.threshold)
                        ) {
                          if (!(Math.abs(e) > d.threshold || o.allowThresholdMove))
                            return void (o.currentTranslate = o.startTranslate);
                          if (!o.allowThresholdMove)
                            return (
                              (o.allowThresholdMove = !0),
                              (p.startX = p.currentX),
                              (p.startY = p.currentY),
                              (o.currentTranslate = o.startTranslate),
                              void (p.diff = n.isHorizontal() ? p.currentX - p.startX : p.currentY - p.startY)
                            );
                        }
                        d.followFinger &&
                          !d.cssMode &&
                          (((d.freeMode && d.freeMode.enabled && n.freeMode) || d.watchSlidesProgress) &&
                            (n.updateActiveIndex(), n.updateSlidesClasses()),
                          n.params.freeMode && d.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(),
                          n.updateProgress(o.currentTranslate),
                          n.setTranslate(o.currentTranslate));
                      }
                  }
                } else o.startMoving && o.isScrolling && n.emit('touchMoveOpposite', r);
              }
            }.bind(e)),
            (e.onTouchEnd = function (t) {
              const l = this,
                e = l.touchEventsData,
                a = e.evCache.findIndex((e) => e.pointerId === t.pointerId);
              if (
                (0 <= a && e.evCache.splice(a, 1),
                !['pointercancel', 'pointerout', 'pointerleave'].includes(t.type) ||
                  ('pointercancel' === t.type && (l.browser.isSafari || l.browser.isWebView)))
              ) {
                var { params: n, touches: o, rtlTranslate: s, slidesGrid: d, enabled: p } = l;
                if (p && (n.simulateTouch || 'mouse' !== t.pointerType)) {
                  let r = t;
                  if (
                    (r.originalEvent && (r = r.originalEvent),
                    e.allowTouchCallbacks && l.emit('touchEnd', r),
                    (e.allowTouchCallbacks = !1),
                    !e.isTouched)
                  )
                    return (
                      e.isMoved && n.grabCursor && l.setGrabCursor(!1), (e.isMoved = !1), void (e.startMoving = !1)
                    );
                  n.grabCursor &&
                    e.isMoved &&
                    e.isTouched &&
                    (!0 === l.allowSlideNext || !0 === l.allowSlidePrev) &&
                    l.setGrabCursor(!1);
                  var c,
                    p = g(),
                    u = p - e.touchStartTime;
                  if (l.allowClick) {
                    const t = r.path || (r.composedPath && r.composedPath());
                    l.updateClickedSlide((t && t[0]) || r.target),
                      l.emit('tap click', r),
                      u < 300 && p - e.lastClickTime < 300 && l.emit('doubleTap doubleClick', r);
                  }
                  if (
                    ((e.lastClickTime = g()),
                    T(() => {
                      l.destroyed || (l.allowClick = !0);
                    }),
                    !e.isTouched ||
                      !e.isMoved ||
                      !l.swipeDirection ||
                      0 === o.diff ||
                      e.currentTranslate === e.startTranslate)
                  )
                    return (e.isTouched = !1), (e.isMoved = !1), void (e.startMoving = !1);
                  if (
                    ((e.isTouched = !1),
                    (e.isMoved = !1),
                    (e.startMoving = !1),
                    (c = n.followFinger ? (s ? l.translate : -l.translate) : -e.currentTranslate),
                    !n.cssMode)
                  )
                    if (l.params.freeMode && n.freeMode.enabled) l.freeMode.onTouchEnd({ currentPos: c });
                    else {
                      let e = 0,
                        t = l.slidesSizesGrid[0];
                      for (let i = 0; i < d.length; i += i < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup) {
                        const l = i < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup;
                        void 0 !== d[i + l]
                          ? c >= d[i] && c < d[i + l] && ((e = i), (t = d[i + l] - d[i]))
                          : c >= d[i] && ((e = i), (t = d[d.length - 1] - d[d.length - 2]));
                      }
                      let a = null,
                        s = null;
                      n.rewind &&
                        (l.isBeginning
                          ? (s =
                              l.params.virtual && l.params.virtual.enabled && l.virtual
                                ? l.virtual.slides.length - 1
                                : l.slides.length - 1)
                          : l.isEnd && (a = 0));
                      (p = (c - d[e]) / t), (o = e < n.slidesPerGroupSkip - 1 ? 1 : n.slidesPerGroup);
                      u > n.longSwipesMs
                        ? n.longSwipes
                          ? ('next' === l.swipeDirection &&
                              (p >= n.longSwipesRatio ? l.slideTo(n.rewind && l.isEnd ? a : e + o) : l.slideTo(e)),
                            'prev' === l.swipeDirection &&
                              (p > 1 - n.longSwipesRatio
                                ? l.slideTo(e + o)
                                : null !== s && p < 0 && Math.abs(p) > n.longSwipesRatio
                                ? l.slideTo(s)
                                : l.slideTo(e)))
                          : l.slideTo(l.activeIndex)
                        : n.shortSwipes
                        ? !l.navigation || (r.target !== l.navigation.nextEl && r.target !== l.navigation.prevEl)
                          ? ('next' === l.swipeDirection && l.slideTo(null !== a ? a : e + o),
                            'prev' === l.swipeDirection && l.slideTo(null !== s ? s : e))
                          : r.target === l.navigation.nextEl
                          ? l.slideTo(e + o)
                          : l.slideTo(e)
                        : l.slideTo(l.activeIndex);
                    }
                }
              }
            }.bind(e)),
            a.cssMode &&
              (e.onScroll = function () {
                var e = this,
                  { wrapperEl: t, rtlTranslate: a, enabled: s } = e;
                s &&
                  ((e.previousTranslate = e.translate),
                  e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop),
                  0 === e.translate && (e.translate = 0),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses(),
                  (0 == (s = e.maxTranslate() - e.minTranslate()) ? 0 : (e.translate - e.minTranslate()) / s) !==
                    e.progress && e.updateProgress(a ? -e.translate : e.translate),
                  e.emit('setTranslate', e.translate, !1));
              }.bind(e)),
            (e.onClick = function (e) {
              var t = this;
              t.enabled &&
                !t.allowClick &&
                (t.params.preventClicks && e.preventDefault(),
                t.params.preventClicksPropagation &&
                  t.animating &&
                  (e.stopPropagation(), e.stopImmediatePropagation()));
            }.bind(e)),
            (e.onLoad = function (e) {
              var t = this;
              r(t, e.target),
                t.params.cssMode || ('auto' !== t.params.slidesPerView && !t.params.autoHeight) || t.update();
            }.bind(e)),
            N || (t.addEventListener('touchstart', q), (N = !0)),
            R(e, 'on');
        },
        detachEvents: function () {
          R(this, 'off');
        },
      },
      breakpoints: {
        setBreakpoint: function () {
          const s = this,
            { realIndex: e, initialized: t, params: i, el: a } = s,
            r = i.breakpoints;
          if (r && 0 !== Object.keys(r).length) {
            var l = s.getBreakpoint(r, s.params.breakpointsBase, s.el);
            if (l && s.currentBreakpoint !== l) {
              const d = (l in r ? r[l] : void 0) || s.originalParams,
                p = F(s, i),
                c = F(s, d),
                u = i.enabled;
              p && !c
                ? (a.classList.remove(i.containerModifierClass + 'grid', i.containerModifierClass + 'grid-column'),
                  s.emitContainerClasses())
                : !p &&
                  c &&
                  (a.classList.add(i.containerModifierClass + 'grid'),
                  ((d.grid.fill && 'column' === d.grid.fill) || (!d.grid.fill && 'column' === i.grid.fill)) &&
                    a.classList.add(i.containerModifierClass + 'grid-column'),
                  s.emitContainerClasses()),
                ['navigation', 'pagination', 'scrollbar'].forEach((e) => {
                  var t = i[e] && i[e].enabled,
                    a = d[e] && d[e].enabled;
                  t && !a && s[e].disable(), !t && a && s[e].enable();
                });
              var n = d.direction && d.direction !== i.direction,
                o = i.loop && (d.slidesPerView !== i.slidesPerView || n),
                n = (n && t && s.changeDirection(), h(s.params, d), s.params.enabled);
              Object.assign(s, {
                allowTouchMove: s.params.allowTouchMove,
                allowSlideNext: s.params.allowSlideNext,
                allowSlidePrev: s.params.allowSlidePrev,
              }),
                u && !n ? s.disable() : !u && n && s.enable(),
                (s.currentBreakpoint = l),
                s.emit('_beforeBreakpoint', d),
                o && t && (s.loopDestroy(), s.loopCreate(e), s.updateSlides()),
                s.emit('breakpoint', d);
            }
          }
        },
        getBreakpoint: function (a, s, i) {
          if ((void 0 === s && (s = 'window'), a && ('container' !== s || i))) {
            let e = !1;
            const r = z(),
              l = 'window' === s ? r.innerHeight : i.clientHeight,
              n = Object.keys(a).map((e) => {
                var t;
                return 'string' == typeof e && 0 === e.indexOf('@')
                  ? ((t = parseFloat(e.substr(1))), { value: l * t, point: e })
                  : { value: e, point: e };
              });
            n.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
            for (let t = 0; t < n.length; t += 1) {
              const { point: z, value: l } = n[t];
              'window' === s ? r.matchMedia(`(min-width: ${l}px)`).matches && (e = z) : l <= i.clientWidth && (e = z);
            }
            return e || 'max';
          }
        },
      },
      checkOverflow: {
        checkOverflow: function () {
          const e = this,
            { isLocked: t, params: a } = e,
            s = a['slidesOffsetBefore'];
          if (s) {
            const t = e.slides.length - 1,
              a = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * s;
            e.isLocked = e.size > a;
          } else e.isLocked = 1 === e.snapGrid.length;
          !0 === a.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === a.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? 'lock' : 'unlock');
        },
      },
      classes: {
        addClasses: function () {
          const { classNames: e, params: t, rtl: a, el: s, device: i } = this,
            r = (function (e, a) {
              const s = [];
              return (
                e.forEach((t) => {
                  'object' == typeof t
                    ? Object.keys(t).forEach((e) => {
                        t[e] && s.push(a + e);
                      })
                    : 'string' == typeof t && s.push(a + t);
                }),
                s
              );
            })(
              [
                'initialized',
                t.direction,
                { 'free-mode': this.params.freeMode && t.freeMode.enabled },
                { autoheight: t.autoHeight },
                { rtl: a },
                { grid: t.grid && 1 < t.grid.rows },
                { 'grid-column': t.grid && 1 < t.grid.rows && 'column' === t.grid.fill },
                { android: i.android },
                { ios: i.ios },
                { 'css-mode': t.cssMode },
                { centered: t.cssMode && t.centeredSlides },
                { 'watch-progress': t.watchSlidesProgress },
              ],
              t.containerModifierClass
            );
          e.push(...r), s.classList.add(...e), this.emitContainerClasses();
        },
        removeClasses: function () {
          const { el: e, classNames: t } = this;
          e.classList.remove(...t), this.emitContainerClasses();
        },
      },
    },
    w = {};
  class y {
    constructor() {
      let a, r;
      for (var m, e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];
      1 === t.length && t[0].constructor && 'Object' === Object.prototype.toString.call(t[0]).slice(8, -1)
        ? (r = t[0])
        : ([a, r] = t),
        (r = h({}, (r = r || {}))),
        a && !r.el && (r.el = a);
      const i = L();
      if (r.el && 'string' == typeof r.el && 1 < i.querySelectorAll(r.el).length) {
        const a = [];
        return (
          i.querySelectorAll(r.el).forEach((e) => {
            var t = h({}, r, { el: e });
            a.push(new y(t));
          }),
          a
        );
      }
      const l = this,
        n =
          ((l.__swiper__ = !0),
          (l.support = f()),
          (l.device =
            (void 0 === (m = { userAgent: r.userAgent }) && (m = {}),
            (d =
              d ||
              (function () {
                var e = (void 0 === m ? {} : m)['userAgent'];
                const t = f(),
                  a = z(),
                  s = a.navigator.platform,
                  i = e || a.navigator.userAgent,
                  r = { ios: !1, android: !1 },
                  l = a.screen.width,
                  n = a.screen.height,
                  o = i.match(/(Android);?[\s\/]+([\d.]+)?/);
                let d = i.match(/(iPad).*OS\s([\d_]+)/);
                var e = i.match(/(iPod)(.*OS\s([\d_]+))?/),
                  p = !d && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                  c = 'Win32' === s;
                let u = 'MacIntel' === s;
                return (
                  !d &&
                    u &&
                    t.touch &&
                    0 <=
                      [
                        '1024x1366',
                        '1366x1024',
                        '834x1194',
                        '1194x834',
                        '834x1112',
                        '1112x834',
                        '768x1024',
                        '1024x768',
                        '820x1180',
                        '1180x820',
                        '810x1080',
                        '1080x810',
                      ].indexOf(l + 'x' + n) &&
                    ((d = (d = i.match(/(Version)\/([\d.]+)/)) || [0, 1, '13_0_0']), (u = !1)),
                  o && !c && ((r.os = 'android'), (r.android = !0)),
                  (d || p || e) && ((r.os = 'ios'), (r.ios = !0)),
                  r
                );
              })()))),
          (l.browser = c =
            c ||
            (function () {
              const t = z();
              let e = !1;
              function a() {
                const e = t.navigator.userAgent.toLowerCase();
                return 0 <= e.indexOf('safari') && e.indexOf('chrome') < 0 && e.indexOf('android') < 0;
              }
              if (a()) {
                const a = String(t.navigator.userAgent);
                if (a.includes('Version/')) {
                  const [t, s] = a
                    .split('Version/')[1]
                    .split(' ')[0]
                    .split('.')
                    .map((e) => Number(e));
                  e = t < 16 || (16 === t && s < 2);
                }
              }
              return {
                isSafari: e || a(),
                needPerspectiveFix: e,
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent),
              };
            })()),
          (l.eventsListeners = {}),
          (l.eventsAnyListeners = []),
          (l.modules = [...l.__modules__]),
          r.modules && Array.isArray(r.modules) && l.modules.push(...r.modules),
          {});
      l.modules.forEach((e) => {
        var s, i;
        e({
          params: r,
          swiper: l,
          extendParams:
            ((s = r),
            (i = n),
            function (e) {
              void 0 === e && (e = {});
              var t = Object.keys(e)[0],
                a = e[t];
              'object' == typeof a &&
                null !== a &&
                (0 <= ['navigation', 'pagination', 'scrollbar'].indexOf(t) && !0 === s[t] && (s[t] = { auto: !0 }),
                t in s &&
                  'enabled' in a &&
                  (!0 === s[t] && (s[t] = { enabled: !0 }),
                  'object' != typeof s[t] || 'enabled' in s[t] || (s[t].enabled = !0),
                  s[t] || (s[t] = { enabled: !1 }))),
                h(i, e);
            }),
          on: l.on.bind(l),
          once: l.once.bind(l),
          off: l.off.bind(l),
          emit: l.emit.bind(l),
        });
      });
      var o = h({}, _, n);
      return (
        (l.params = h({}, o, w, r)),
        (l.originalParams = h({}, l.params)),
        (l.passedParams = h({}, r)),
        l.params &&
          l.params.on &&
          Object.keys(l.params.on).forEach((e) => {
            l.on(e, l.params.on[e]);
          }),
        l.params && l.params.onAny && l.onAny(l.params.onAny),
        Object.assign(l, {
          enabled: l.params.enabled,
          el: a,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => 'horizontal' === l.params.direction,
          isVertical: () => 'vertical' === l.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          allowSlideNext: l.params.allowSlideNext,
          allowSlidePrev: l.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: l.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            evCache: [],
          },
          allowClick: !0,
          allowTouchMove: l.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        l.emit('_swiper'),
        l.params.init && l.init(),
        l
      );
    }
    getSlideIndex(e) {
      var { slidesEl: t, params: a } = this,
        t = E(k(t, `.${a.slideClass}, swiper-slide`)[0]);
      return E(e) - t;
    }
    getSlideIndexByData(t) {
      return this.getSlideIndex(this.slides.filter((e) => +e.getAttribute('data-swiper-slide-index') === t)[0]);
    }
    recalcSlides() {
      var { slidesEl: e, params: t } = this;
      this.slides = k(e, `.${t.slideClass}, swiper-slide`);
    }
    enable() {
      var e = this;
      e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit('enable'));
    }
    disable() {
      var e = this;
      e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit('disable'));
    }
    setProgress(e, t) {
      var a = this,
        s = ((e = Math.min(Math.max(e, 0), 1)), a.minTranslate()),
        s = (a.maxTranslate() - s) * e + s;
      a.translateTo(s, void 0 === t ? 0 : t), a.updateActiveIndex(), a.updateSlidesClasses();
    }
    emitContainerClasses() {
      const t = this;
      if (t.params._emitClasses && t.el) {
        const e = t.el.className
          .split(' ')
          .filter((e) => 0 === e.indexOf('swiper') || 0 === e.indexOf(t.params.containerModifierClass));
        t.emit('_containerClasses', e.join(' '));
      }
    }
    getSlideClasses(e) {
      const t = this;
      return t.destroyed
        ? ''
        : e.className
            .split(' ')
            .filter((e) => 0 === e.indexOf('swiper-slide') || 0 === e.indexOf(t.params.slideClass))
            .join(' ');
    }
    emitSlidesClasses() {
      const a = this;
      if (a.params._emitClasses && a.el) {
        const s = [];
        a.slides.forEach((e) => {
          var t = a.getSlideClasses(e);
          s.push({ slideEl: e, classNames: t }), a.emit('_slideClass', e, t);
        }),
          a.emit('_slideClasses', s);
      }
    }
    slidesPerViewDynamic(a, s) {
      void 0 === a && (a = 'current'), void 0 === s && (s = !1);
      var { params: e, slides: i, slidesGrid: r, slidesSizesGrid: l, size: n, activeIndex: o } = this;
      let d = 1;
      if (e.centeredSlides) {
        let e,
          t = i[o].swiperSlideSize;
        for (let a = o + 1; a < i.length; a += 1)
          i[a] && !e && ((t += i[a].swiperSlideSize), (d += 1), t > n && (e = !0));
        for (let s = o - 1; 0 <= s; --s) i[s] && !e && ((t += i[s].swiperSlideSize), (d += 1), t > n && (e = !0));
      } else if ('current' === a)
        for (let e = o + 1; e < i.length; e += 1) (s ? r[e] + l[e] - r[o] < n : r[e] - r[o] < n) && (d += 1);
      else for (let t = o - 1; 0 <= t; --t) r[o] - r[t] < n && (d += 1);
      return d;
    }
    update() {
      const t = this;
      if (t && !t.destroyed) {
        const { snapGrid: s, params: i } = t;
        let e;
        if (
          (i.breakpoints && t.setBreakpoint(),
          [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
            e.complete && r(t, e);
          }),
          t.updateSize(),
          t.updateSlides(),
          t.updateProgress(),
          t.updateSlidesClasses(),
          t.params.freeMode && t.params.freeMode.enabled)
        )
          a(), t.params.autoHeight && t.updateAutoHeight();
        else {
          if (
            ('auto' === t.params.slidesPerView || 1 < t.params.slidesPerView) &&
            t.isEnd &&
            !t.params.centeredSlides
          ) {
            const s = (t.virtual && t.params.virtual.enabled ? t.virtual : t).slides;
            e = t.slideTo(s.length - 1, 0, !1, !0);
          } else e = t.slideTo(t.activeIndex, 0, !1, !0);
          e || a();
        }
        function a() {
          var e = t.rtlTranslate ? -1 * t.translate : t.translate,
            e = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
          t.setTranslate(e), t.updateActiveIndex(), t.updateSlidesClasses();
        }
        i.watchOverflow && s !== t.snapGrid && t.checkOverflow(), t.emit('update');
      }
    }
    changeDirection(t, e) {
      void 0 === e && (e = !0);
      var a = this,
        s = a.params.direction;
      return (
        (t = t || ('horizontal' === s ? 'vertical' : 'horizontal')) === s ||
          ('horizontal' !== t && 'vertical' !== t) ||
          (a.el.classList.remove('' + a.params.containerModifierClass + s),
          a.el.classList.add('' + a.params.containerModifierClass + t),
          a.emitContainerClasses(),
          (a.params.direction = t),
          a.slides.forEach((e) => {
            'vertical' === t ? (e.style.width = '') : (e.style.height = '');
          }),
          a.emit('changeDirection'),
          e && a.update()),
        a
      );
    }
    changeLanguageDirection(e) {
      var t = this;
      (t.rtl && 'rtl' === e) ||
        (!t.rtl && 'ltr' === e) ||
        ((t.rtl = 'rtl' === e),
        (t.rtlTranslate = 'horizontal' === t.params.direction && t.rtl),
        t.rtl
          ? (t.el.classList.add(t.params.containerModifierClass + 'rtl'), (t.el.dir = 'rtl'))
          : (t.el.classList.remove(t.params.containerModifierClass + 'rtl'), (t.el.dir = 'ltr')),
        t.update());
    }
    mount(e) {
      const t = this;
      if (t.mounted) return !0;
      let a = e || t.params.el;
      if (!(a = 'string' == typeof a ? document.querySelector(a) : a)) return !1;
      (a.swiper = t), a.shadowEl && (t.isElement = !0);
      const s = () => '.' + (t.params.wrapperClass || '').trim().split(' ').join('.');
      let i = a && a.shadowRoot && a.shadowRoot.querySelector ? a.shadowRoot.querySelector(s()) : k(a, s())[0];
      return (
        !i &&
          t.params.createElements &&
          ((i = O('div', t.params.wrapperClass)),
          a.append(i),
          k(a, '.' + t.params.slideClass).forEach((e) => {
            i.append(e);
          })),
        Object.assign(t, {
          el: a,
          wrapperEl: i,
          slidesEl: t.isElement ? a : i,
          mounted: !0,
          rtl: 'rtl' === a.dir.toLowerCase() || 'rtl' === G(a, 'direction'),
          rtlTranslate:
            'horizontal' === t.params.direction && ('rtl' === a.dir.toLowerCase() || 'rtl' === G(a, 'direction')),
          wrongRTL: '-webkit-box' === G(i, 'display'),
        }),
        !0
      );
    }
    init(e) {
      const t = this;
      return (
        t.initialized ||
          (!1 !== t.mount(e) &&
            (t.emit('beforeInit'),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.enabled && t.setGrabCursor(),
            t.params.loop && t.virtual && t.params.virtual.enabled
              ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0)
              : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
            t.params.loop && t.loopCreate(),
            t.attachEvents(),
            [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
              e.complete
                ? r(t, e)
                : e.addEventListener('load', (e) => {
                    r(t, e.target);
                  });
            }),
            u(t),
            (t.initialized = !0),
            u(t),
            t.emit('init'),
            t.emit('afterInit'))),
        t
      );
    }
    destroy(e, t) {
      void 0 === e && (e = !0), void 0 === t && (t = !0);
      const a = this,
        { params: s, el: i, wrapperEl: r, slides: l } = a;
      if (void 0 !== a.params && !a.destroyed) {
        if (
          (a.emit('beforeDestroy'),
          (a.initialized = !1),
          a.detachEvents(),
          s.loop && a.loopDestroy(),
          t &&
            (a.removeClasses(),
            i.removeAttribute('style'),
            r.removeAttribute('style'),
            l &&
              l.length &&
              l.forEach((e) => {
                e.classList.remove(s.slideVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass),
                  e.removeAttribute('style'),
                  e.removeAttribute('data-swiper-slide-index');
              })),
          a.emit('destroy'),
          Object.keys(a.eventsListeners).forEach((e) => {
            a.off(e);
          }),
          !1 !== e)
        ) {
          a.el.swiper = null;
          {
            const n = a;
            Object.keys(n).forEach((e) => {
              try {
                n[e] = null;
              } catch (e) {}
              try {
                delete n[e];
              } catch (e) {}
            });
          }
        }
        a.destroyed = !0;
      }
      return null;
    }
    static extendDefaults(e) {
      h(w, e);
    }
    static get extendedDefaults() {
      return w;
    }
    static get defaults() {
      return _;
    }
    static installModule(e) {
      y.prototype.__modules__ || (y.prototype.__modules__ = []);
      const t = y.prototype.__modules__;
      'function' == typeof e && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
      return Array.isArray(e) ? e.forEach((e) => y.installModule(e)) : y.installModule(e), y;
    }
  }
  function M(a, s, i, r) {
    return (
      a.params.createElements &&
        Object.keys(r).forEach((t) => {
          if (!i[t] && !0 === i.auto) {
            let e = k(a.el, '.' + r[t])[0];
            e || (((e = O('div', r[t])).className = r[t]), a.el.append(e)), (i[t] = e), (s[t] = e);
          }
        }),
      i
    );
  }
  function S(e) {
    return (
      '.' +
      (e = void 0 === e ? '' : e)
        .trim()
        .replace(/([\.:!+\/])/g, '\\$1')
        .replace(/ /g, '.')
    );
  }
  function o(e) {
    const {
      effect: a,
      swiper: s,
      on: t,
      setTranslate: i,
      setTransition: r,
      overwriteParams: l,
      perspective: n,
      recreateShadows: o,
      getEffectParams: d,
    } = e;
    let p;
    t('beforeInit', () => {
      var e;
      s.params.effect === a &&
        (s.classNames.push('' + s.params.containerModifierClass + a),
        n && n() && s.classNames.push(s.params.containerModifierClass + '3d'),
        (e = l ? l() : {}),
        Object.assign(s.params, e),
        Object.assign(s.originalParams, e));
    }),
      t('setTranslate', () => {
        s.params.effect === a && i();
      }),
      t('setTransition', (e, t) => {
        s.params.effect === a && r(t);
      }),
      t('transitionEnd', () => {
        s.params.effect === a &&
          o &&
          d &&
          d().slideShadows &&
          (s.slides.forEach((e) => {
            e.querySelectorAll(
              '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
            ).forEach((e) => e.remove());
          }),
          o());
      }),
      t('virtualUpdate', () => {
        s.params.effect === a &&
          (s.slides.length || (p = !0),
          requestAnimationFrame(() => {
            p && s.slides && s.slides.length && (i(), (p = !1));
          }));
      });
  }
  function x(e, t) {
    const a = n(t);
    return a !== t && ((a.style.backfaceVisibility = 'hidden'), (a.style['-webkit-backface-visibility'] = 'hidden')), a;
  }
  function m(e) {
    let { swiper: s, duration: t, transformElements: a, allSlides: i } = e;
    const r = s['activeIndex'];
    if (s.params.virtualTranslate && 0 !== t) {
      let e,
        t = !1;
      (e = i
        ? a
        : a.filter((e) => {
            var t,
              a = e.classList.contains('swiper-slide-transform')
                ? (t = e).parentElement || s.slides.filter((e) => e.shadowEl && e.shadowEl === t.parentNode)[0]
                : e;
            return s.getSlideIndex(a) === r;
          })).forEach((e) => {
        v(e, () => {
          var e;
          t ||
            (s &&
              !s.destroyed &&
              ((t = !0),
              (s.animating = !1),
              (e = new window.CustomEvent('transitionend', { bubbles: !0, cancelable: !0 })),
              s.wrapperEl.dispatchEvent(e)));
        });
      });
    }
  }
  function C(e, t, a) {
    const s = 'swiper-slide-shadow' + (a ? '-' + a : ''),
      i = n(t);
    let r = i.querySelector('.' + s);
    return r || ((r = O('div', 'swiper-slide-shadow' + (a ? '-' + a : ''))), i.append(r)), r;
  }
  return (
    Object.keys(l).forEach((t) => {
      Object.keys(l[t]).forEach((e) => {
        y.prototype[e] = l[t][e];
      });
    }),
    y.use([
      function (e) {
        let { swiper: l, on: t, emit: a } = e;
        const s = z();
        let i = null,
          r = null;
        const n = () => {
            l && !l.destroyed && l.initialized && (a('beforeResize'), a('resize'));
          },
          o = () => {
            l && !l.destroyed && l.initialized && a('orientationchange');
          };
        t('init', () => {
          l.params.resizeObserver && void 0 !== s.ResizeObserver
            ? l &&
              !l.destroyed &&
              l.initialized &&
              (i = new ResizeObserver((a) => {
                r = s.requestAnimationFrame(() => {
                  var { width: e, height: t } = l;
                  let i = e,
                    r = t;
                  a.forEach((e) => {
                    var { contentBoxSize: t, contentRect: a, target: s } = e;
                    (s && s !== l.el) ||
                      ((i = a ? a.width : (t[0] || t).inlineSize), (r = a ? a.height : (t[0] || t).blockSize));
                  }),
                    (i === e && r === t) || n();
                });
              })).observe(l.el)
            : (s.addEventListener('resize', n), s.addEventListener('orientationchange', o));
        }),
          t('destroy', () => {
            r && s.cancelAnimationFrame(r),
              i && i.unobserve && l.el && (i.unobserve(l.el), (i = null)),
              s.removeEventListener('resize', n),
              s.removeEventListener('orientationchange', o);
          });
      },
      function (e) {
        let { swiper: s, extendParams: t, on: a, emit: i } = e;
        function r(e, t) {
          void 0 === t && (t = {});
          const a = new (n.MutationObserver || n.WebkitMutationObserver)((e) => {
            var t;
            s.__preventObserver__ ||
              (1 === e.length
                ? i('observerUpdate', e[0])
                : ((t = function () {
                    i('observerUpdate', e[0]);
                  }),
                  n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0)));
          });
          a.observe(e, {
            attributes: void 0 === t.attributes || t.attributes,
            childList: void 0 === t.childList || t.childList,
            characterData: void 0 === t.characterData || t.characterData,
          }),
            l.push(a);
        }
        const l = [],
          n = z();
        t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          a('init', () => {
            if (s.params.observer) {
              if (s.params.observeParents) {
                var t = H(s.el);
                for (let e = 0; e < t.length; e += 1) r(t[e]);
              }
              r(s.el, { childList: s.params.observeSlideChildren }), r(s.wrapperEl, { attributes: !1 });
            }
          }),
          a('destroy', () => {
            l.forEach((e) => {
              e.disconnect();
            }),
              l.splice(0, l.length);
          });
      },
    ]),
    y.use([
      function (e) {
        let t,
          { swiper: M, extendParams: a, on: s, emit: C } = e;
        a({
          virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: !0,
            addSlidesBefore: 0,
            addSlidesAfter: 0,
          },
        });
        const i = L(),
          r =
            ((M.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] }),
            i.createElement('div'));
        function P(e, t) {
          const a = M.params.virtual;
          if (a.cache && M.virtual.cache[t]) return M.virtual.cache[t];
          let s;
          return (
            a.renderSlide
              ? 'string' == typeof (s = a.renderSlide.call(M, e, t)) && ((r.innerHTML = s), (s = r.children[0]))
              : (s = M.isElement ? O('swiper-slide') : O('div', M.params.slideClass)),
            s.setAttribute('data-swiper-slide-index', t),
            a.renderSlide || (s.innerHTML = e),
            a.cache && (M.virtual.cache[t] = s),
            s
          );
        }
        function l(t) {
          const { slidesPerView: a, slidesPerGroup: e, centeredSlides: s, loop: i } = M.params,
            { addSlidesBefore: r, addSlidesAfter: l } = M.params.virtual,
            { from: n, to: o, slides: d, slidesGrid: p, offset: c } = M.virtual;
          M.params.cssMode || M.updateActiveIndex();
          var u = M.activeIndex || 0;
          let m,
            h,
            f,
            v =
              ((m = M.rtlTranslate ? 'right' : M.isHorizontal() ? 'left' : 'top'),
              u -
                (f = s
                  ? ((h = Math.floor(a / 2) + e + l), Math.floor(a / 2) + e + r)
                  : ((h = a + (e - 1) + l), (i ? a : e) + r))),
            g = u + h,
            w =
              (i || ((v = Math.max(v, 0)), (g = Math.min(g, d.length - 1))),
              (M.slidesGrid[v] || 0) - (M.slidesGrid[0] || 0));
          function b() {
            M.updateSlides(), M.updateProgress(), M.updateSlidesClasses(), C('virtualUpdate');
          }
          if (
            (i && u >= f
              ? ((v -= f), s || (w += M.slidesGrid[0]))
              : i && u < f && ((v = -f), s && (w += M.slidesGrid[0])),
            Object.assign(M.virtual, {
              from: v,
              to: g,
              offset: w,
              slidesGrid: M.slidesGrid,
              slidesBefore: f,
              slidesAfter: h,
            }),
            n === v && o === g && !t)
          )
            return (
              M.slidesGrid !== p &&
                w !== c &&
                M.slides.forEach((e) => {
                  e.style[m] = w - Math.abs(M.cssOverflowAdjustment()) + 'px';
                }),
              M.updateProgress(),
              void C('virtualUpdate')
            );
          if (M.params.virtual.renderExternal)
            return (
              M.params.virtual.renderExternal.call(M, {
                offset: w,
                from: v,
                to: g,
                slides: (function () {
                  const e = [];
                  for (let t = v; t <= g; t += 1) e.push(d[t]);
                  return e;
                })(),
              }),
              void (M.params.virtual.renderExternalUpdate ? b() : C('virtualUpdate'))
            );
          const y = [],
            x = [],
            E = (e) => {
              let t = e;
              return e < 0 ? (t = d.length + e) : t >= d.length && (t -= d.length), t;
            };
          if (t)
            M.slidesEl.querySelectorAll(`.${M.params.slideClass}, swiper-slide`).forEach((e) => {
              e.remove();
            });
          else
            for (let e = n; e <= o; e += 1)
              if (e < v || e > g) {
                const a = E(e);
                M.slidesEl
                  .querySelectorAll(
                    `.${M.params.slideClass}[data-swiper-slide-index="${a}"], swiper-slide[data-swiper-slide-index="${a}"]`
                  )
                  .forEach((e) => {
                    e.remove();
                  });
              }
          var u = i ? -d.length : 0,
            S = i ? 2 * d.length : d.length;
          for (let T = u; T < S; T += 1)
            if (T >= v && T <= g) {
              const M = E(T);
              void 0 === o || t ? x.push(M) : (T > o && x.push(M), T < n && y.push(M));
            }
          if (
            (x.forEach((e) => {
              M.slidesEl.append(P(d[e], e));
            }),
            i)
          )
            for (let e = y.length - 1; 0 <= e; --e) {
              const a = y[e];
              M.slidesEl.prepend(P(d[a], a));
            }
          else
            y.sort((e, t) => t - e),
              y.forEach((e) => {
                M.slidesEl.prepend(P(d[e], e));
              });
          k(M.slidesEl, '.swiper-slide, swiper-slide').forEach((e) => {
            e.style[m] = w - Math.abs(M.cssOverflowAdjustment()) + 'px';
          }),
            b();
        }
        s('beforeInit', () => {
          if (M.params.virtual.enabled) {
            let e;
            if (void 0 === M.passedParams.virtual.slides) {
              const t = [...M.slidesEl.children].filter((e) => e.matches(`.${M.params.slideClass}, swiper-slide`));
              t &&
                t.length &&
                ((M.virtual.slides = [...t]),
                (e = !0),
                t.forEach((e, t) => {
                  e.setAttribute('data-swiper-slide-index', t), (M.virtual.cache[t] = e).remove();
                }));
            }
            e || (M.virtual.slides = M.params.virtual.slides),
              M.classNames.push(M.params.containerModifierClass + 'virtual'),
              (M.params.watchSlidesProgress = !0),
              (M.originalParams.watchSlidesProgress = !0),
              M.params.initialSlide || l();
          }
        }),
          s('setTranslate', () => {
            M.params.virtual.enabled &&
              (M.params.cssMode && !M._immediateVirtual
                ? (clearTimeout(t),
                  (t = setTimeout(() => {
                    l();
                  }, 100)))
                : l());
          }),
          s('init update resize', () => {
            M.params.virtual.enabled &&
              M.params.cssMode &&
              I(M.wrapperEl, '--swiper-virtual-size', M.virtualSize + 'px');
          }),
          Object.assign(M.virtual, {
            appendSlide: function (t) {
              if ('object' == typeof t && 'length' in t)
                for (let e = 0; e < t.length; e += 1) t[e] && M.virtual.slides.push(t[e]);
              else M.virtual.slides.push(t);
              l(!0);
            },
            prependSlide: function (s) {
              const i = M.activeIndex;
              let t = i + 1,
                r = 1;
              if (Array.isArray(s)) {
                for (let e = 0; e < s.length; e += 1) s[e] && M.virtual.slides.unshift(s[e]);
                (t = i + s.length), (r = s.length);
              } else M.virtual.slides.unshift(s);
              if (M.params.virtual.cache) {
                const s = M.virtual.cache,
                  i = {};
                Object.keys(s).forEach((e) => {
                  const t = s[e],
                    a = t.getAttribute('data-swiper-slide-index');
                  a && t.setAttribute('data-swiper-slide-index', parseInt(a, 10) + r), (i[parseInt(e, 10) + r] = t);
                }),
                  (M.virtual.cache = i);
              }
              l(!0), M.slideTo(t, 0);
            },
            removeSlide: function (a) {
              if (null != a) {
                let t = M.activeIndex;
                if (Array.isArray(a))
                  for (let e = a.length - 1; 0 <= e; --e)
                    M.virtual.slides.splice(a[e], 1),
                      M.params.virtual.cache && delete M.virtual.cache[a[e]],
                      a[e] < t && --t,
                      (t = Math.max(t, 0));
                else
                  M.virtual.slides.splice(a, 1),
                    M.params.virtual.cache && delete M.virtual.cache[a],
                    a < t && --t,
                    (t = Math.max(t, 0));
                l(!0), M.slideTo(t, 0);
              }
            },
            removeAllSlides: function () {
              (M.virtual.slides = []), M.params.virtual.cache && (M.virtual.cache = {}), l(!0), M.slideTo(0, 0);
            },
            update: l,
          });
      },
      function (e) {
        let { swiper: c, extendParams: t, on: a, emit: u } = e;
        const m = L(),
          h = z();
        function s(t) {
          if (c.enabled) {
            const s = c['rtlTranslate'];
            let e = t;
            const i = (e = e.originalEvent ? e.originalEvent : e).keyCode || e.charCode,
              r = c.params.keyboard.pageUpDown,
              l = r && 33 === i,
              n = r && 34 === i,
              a = 37 === i,
              o = 39 === i,
              d = 38 === i,
              p = 40 === i;
            if (!c.allowSlideNext && ((c.isHorizontal() && o) || (c.isVertical() && p) || n)) return !1;
            if (!c.allowSlidePrev && ((c.isHorizontal() && a) || (c.isVertical() && d) || l)) return !1;
            if (
              !(
                e.shiftKey ||
                e.altKey ||
                e.ctrlKey ||
                e.metaKey ||
                (m.activeElement &&
                  m.activeElement.nodeName &&
                  ('input' === m.activeElement.nodeName.toLowerCase() ||
                    'textarea' === m.activeElement.nodeName.toLowerCase()))
              )
            ) {
              if (c.params.keyboard.onlyInViewport && (l || n || a || o || d || p)) {
                let e = !1;
                if (
                  0 < H(c.el, `.${c.params.slideClass}, swiper-slide`).length &&
                  0 === H(c.el, '.' + c.params.slideActiveClass).length
                )
                  return;
                const t = c.el,
                  i = t.clientWidth,
                  r = t.clientHeight,
                  u = h.innerWidth,
                  m = h.innerHeight,
                  l = D(t),
                  n =
                    (s && (l.left -= t.scrollLeft),
                    [
                      [l.left, l.top],
                      [l.left + i, l.top],
                      [l.left, l.top + r],
                      [l.left + i, l.top + r],
                    ]);
                for (let a = 0; a < n.length; a += 1) {
                  const s = n[a];
                  0 <= s[0] && s[0] <= u && 0 <= s[1] && s[1] <= m && ((0 === s[0] && 0 === s[1]) || (e = !0));
                }
                if (!e) return;
              }
              c.isHorizontal()
                ? ((l || n || a || o) && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1)),
                  (((n || o) && !s) || ((l || a) && s)) && c.slideNext(),
                  (((l || a) && !s) || ((n || o) && s)) && c.slidePrev())
                : ((l || n || d || p) && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1)),
                  (n || p) && c.slideNext(),
                  (l || d) && c.slidePrev()),
                u('keyPress', i);
            }
          }
        }
        function i() {
          c.keyboard.enabled || (m.addEventListener('keydown', s), (c.keyboard.enabled = !0));
        }
        function r() {
          c.keyboard.enabled && (m.removeEventListener('keydown', s), (c.keyboard.enabled = !1));
        }
        (c.keyboard = { enabled: !1 }),
          t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
          a('init', () => {
            c.params.keyboard.enabled && i();
          }),
          a('destroy', () => {
            c.keyboard.enabled && r();
          }),
          Object.assign(c.keyboard, { enable: i, disable: r });
      },
      function (e) {
        let { swiper: p, extendParams: t, on: a, emit: c } = e;
        const s = z();
        let u;
        t({
          mousewheel: {
            enabled: !1,
            releaseOnEdges: !1,
            invert: !1,
            forceToAxis: !1,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel',
          },
        }),
          (p.mousewheel = { enabled: !1 });
        let m,
          i = g();
        const h = [];
        function r() {
          p.enabled && (p.mouseEntered = !0);
        }
        function l() {
          p.enabled && (p.mouseEntered = !1);
        }
        function f(e) {
          (p.params.mousewheel.thresholdDelta && e.delta < p.params.mousewheel.thresholdDelta) ||
            (p.params.mousewheel.thresholdTime && g() - i < p.params.mousewheel.thresholdTime) ||
            (6 <= e.delta && g() - i < 60) ||
            (e.direction < 0
              ? (p.isEnd && !p.params.loop) || p.animating || (p.slideNext(), c('scroll', e.raw))
              : (p.isBeginning && !p.params.loop) || p.animating || (p.slidePrev(), c('scroll', e.raw)),
            (i = new s.Date().getTime()));
        }
        function n(s) {
          let i = s,
            r = !0;
          if (p.enabled && !s.target.closest('.' + p.params.mousewheel.noMousewheelClass)) {
            var l = p.params.mousewheel;
            p.params.cssMode && i.preventDefault();
            let e = p.el;
            const d =
              (e =
                'container' !== p.params.mousewheel.eventsTarget
                  ? document.querySelector(p.params.mousewheel.eventsTarget)
                  : e) && e.contains(i.target);
            if (!p.mouseEntered && !d && !l.releaseOnEdges) return !0;
            i.originalEvent && (i = i.originalEvent);
            let a = 0;
            var n = p.rtlTranslate ? -1 : 1,
              o = (function (e) {
                let t = 0,
                  a = 0,
                  s = 0,
                  i = 0;
                return (
                  'detail' in e && (a = e.detail),
                  'wheelDelta' in e && (a = -e.wheelDelta / 120),
                  'wheelDeltaY' in e && (a = -e.wheelDeltaY / 120),
                  'wheelDeltaX' in e && (t = -e.wheelDeltaX / 120),
                  'axis' in e && e.axis === e.HORIZONTAL_AXIS && ((t = a), (a = 0)),
                  (s = 10 * t),
                  (i = 10 * a),
                  'deltaY' in e && (i = e.deltaY),
                  'deltaX' in e && (s = e.deltaX),
                  e.shiftKey && !s && ((s = i), (i = 0)),
                  (s || i) && e.deltaMode && (1 === e.deltaMode ? ((s *= 40), (i *= 40)) : ((s *= 800), (i *= 800))),
                  s && !t && (t = s < 1 ? -1 : 1),
                  i && !a && (a = i < 1 ? -1 : 1),
                  { spinX: t, spinY: a, pixelX: s, pixelY: i }
                );
              })(i);
            if (l.forceToAxis)
              if (p.isHorizontal()) {
                if (!(Math.abs(o.pixelX) > Math.abs(o.pixelY))) return !0;
                a = -o.pixelX * n;
              } else {
                if (!(Math.abs(o.pixelY) > Math.abs(o.pixelX))) return !0;
                a = -o.pixelY;
              }
            else a = Math.abs(o.pixelX) > Math.abs(o.pixelY) ? -o.pixelX * n : -o.pixelY;
            if (0 === a) return !0;
            l.invert && (a = -a);
            let t = p.getTranslate() + a * l.sensitivity;
            if (
              ((t = t >= p.minTranslate() ? p.minTranslate() : t) <= p.maxTranslate() && (t = p.maxTranslate()),
              (r = !!p.params.loop || !(t === p.minTranslate() || t === p.maxTranslate())) &&
                p.params.nested &&
                i.stopPropagation(),
              p.params.freeMode && p.params.freeMode.enabled)
            ) {
              const s = { time: g(), delta: Math.abs(a), direction: Math.sign(a) },
                r = m && s.time < m.time + 500 && s.delta <= m.delta && s.direction === m.direction;
              if (!r) {
                m = void 0;
                let e = p.getTranslate() + a * l.sensitivity;
                const t = p.isBeginning,
                  d = p.isEnd;
                if (
                  ((e = e >= p.minTranslate() ? p.minTranslate() : e) <= p.maxTranslate() && (e = p.maxTranslate()),
                  p.setTransition(0),
                  p.setTranslate(e),
                  p.updateProgress(),
                  p.updateActiveIndex(),
                  p.updateSlidesClasses(),
                  ((!t && p.isBeginning) || (!d && p.isEnd)) && p.updateSlidesClasses(),
                  p.params.loop && p.loopFix({ direction: s.direction < 0 ? 'next' : 'prev', byMousewheel: !0 }),
                  p.params.freeMode.sticky)
                ) {
                  clearTimeout(u), (u = void 0), 15 <= h.length && h.shift();
                  const i = h.length ? h[h.length - 1] : void 0,
                    r = h[0];
                  if ((h.push(s), i && (s.delta > i.delta || s.direction !== i.direction))) h.splice(0);
                  else if (15 <= h.length && s.time - r.time < 500 && 1 <= r.delta - s.delta && s.delta <= 6) {
                    const i = 0 < a ? 0.8 : 0.2;
                    (m = s),
                      h.splice(0),
                      (u = T(() => {
                        p.slideToClosest(p.params.speed, !0, void 0, i);
                      }, 0));
                  }
                  u =
                    u ||
                    T(() => {
                      (m = s), h.splice(0), p.slideToClosest(p.params.speed, !0, void 0, 0.5);
                    }, 500);
                }
                if (
                  (r || c('scroll', i),
                  p.params.autoplay && p.params.autoplayDisableOnInteraction && p.autoplay.stop(),
                  e === p.minTranslate() || e === p.maxTranslate())
                )
                  return !0;
              }
            } else {
              const i = { time: g(), delta: Math.abs(a), direction: Math.sign(a), raw: s },
                r = (2 <= h.length && h.shift(), h.length ? h[h.length - 1] : void 0);
              if (
                (h.push(i),
                (!r || i.direction !== r.direction || i.delta > r.delta || i.time > r.time + 150) && f(i),
                (function (e) {
                  var t = p.params.mousewheel;
                  if (e.direction < 0) {
                    if (p.isEnd && !p.params.loop && t.releaseOnEdges) return 1;
                  } else if (p.isBeginning && !p.params.loop && t.releaseOnEdges) return 1;
                })(i))
              )
                return !0;
            }
            return i.preventDefault ? i.preventDefault() : (i.returnValue = !1), !1;
          }
        }
        function o(e) {
          let t = p.el;
          (t =
            'container' !== p.params.mousewheel.eventsTarget
              ? document.querySelector(p.params.mousewheel.eventsTarget)
              : t)[e]('mouseenter', r),
            t[e]('mouseleave', l),
            t[e]('wheel', n);
        }
        function d() {
          return p.params.cssMode
            ? (p.wrapperEl.removeEventListener('wheel', n), !0)
            : !p.mousewheel.enabled && (o('addEventListener'), (p.mousewheel.enabled = !0));
        }
        function v() {
          return p.params.cssMode
            ? (p.wrapperEl.addEventListener(event, n), !0)
            : !!p.mousewheel.enabled && (o('removeEventListener'), !(p.mousewheel.enabled = !1));
        }
        a('init', () => {
          !p.params.mousewheel.enabled && p.params.cssMode && v(), p.params.mousewheel.enabled && d();
        }),
          a('destroy', () => {
            p.params.cssMode && d(), p.mousewheel.enabled && v();
          }),
          Object.assign(p.mousewheel, { enable: d, disable: v });
      },
      function (e) {
        let { swiper: r, extendParams: t, on: a, emit: l } = e;
        t({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled',
          },
        }),
          (r.navigation = { nextEl: null, prevEl: null });
        const n = (e) => (e = Array.isArray(e) ? e : [e].filter((e) => !!e));
        function i(e) {
          let t;
          return e && 'string' == typeof e && r.isElement && (t = r.el.shadowRoot.querySelector(e))
            ? t
            : (e &&
                ('string' == typeof e && (t = [...document.querySelectorAll(e)]),
                r.params.uniqueNavElements &&
                  'string' == typeof e &&
                  1 < t.length &&
                  1 === r.el.querySelectorAll(e).length &&
                  (t = r.el.querySelector(e))),
              e && !t ? e : t);
        }
        function s(e, t) {
          const a = r.params.navigation;
          (e = n(e)).forEach((e) => {
            e &&
              (e.classList[t ? 'add' : 'remove'](...a.disabledClass.split(' ')),
              'BUTTON' === e.tagName && (e.disabled = t),
              r.params.watchOverflow && r.enabled && e.classList[r.isLocked ? 'add' : 'remove'](a.lockClass));
          });
        }
        function o() {
          var { nextEl: e, prevEl: t } = r.navigation;
          if (r.params.loop) return s(t, !1), void s(e, !1);
          s(t, r.isBeginning && !r.params.rewind), s(e, r.isEnd && !r.params.rewind);
        }
        function d(e) {
          e.preventDefault(),
            (r.isBeginning && !r.params.loop && !r.params.rewind) || (r.slidePrev(), l('navigationPrev'));
        }
        function p(e) {
          e.preventDefault(), (r.isEnd && !r.params.loop && !r.params.rewind) || (r.slideNext(), l('navigationNext'));
        }
        function c() {
          const a = r.params.navigation;
          if (
            ((r.params.navigation = M(r, r.originalParams.navigation, r.params.navigation, {
              nextEl: 'swiper-button-next',
              prevEl: 'swiper-button-prev',
            })),
            a.nextEl || a.prevEl)
          ) {
            let e = i(a.nextEl),
              t = i(a.prevEl);
            Object.assign(r.navigation, { nextEl: e, prevEl: t }), (e = n(e)), (t = n(t));
            const s = (e, t) => {
              e && e.addEventListener('click', 'next' === t ? p : d),
                !r.enabled && e && e.classList.add(...a.lockClass.split(' '));
            };
            e.forEach((e) => s(e, 'next')), t.forEach((e) => s(e, 'prev'));
          }
        }
        function u() {
          let { nextEl: e, prevEl: t } = r.navigation;
          (e = n(e)), (t = n(t));
          const a = (e, t) => {
            e.removeEventListener('click', 'next' === t ? p : d),
              e.classList.remove(...r.params.navigation.disabledClass.split(' '));
          };
          e.forEach((e) => a(e, 'next')), t.forEach((e) => a(e, 'prev'));
        }
        a('init', () => {
          !1 === r.params.navigation.enabled ? m() : (c(), o());
        }),
          a('toEdge fromEdge lock unlock', () => {
            o();
          }),
          a('destroy', () => {
            u();
          }),
          a('enable disable', () => {
            var { nextEl: e, prevEl: t } = r.navigation,
              e = n(e),
              t = n(t);
            [...e, ...t]
              .filter((e) => !!e)
              .forEach((e) => e.classList[r.enabled ? 'remove' : 'add'](r.params.navigation.lockClass));
          }),
          a('click', (e, t) => {
            let { nextEl: a, prevEl: s } = r.navigation;
            (a = n(a)), (s = n(s));
            var i = t.target;
            if (
              r.params.navigation.hideOnClick &&
              !s.includes(i) &&
              !a.includes(i) &&
              (!(r.pagination && r.params.pagination && r.params.pagination.clickable) ||
                (r.pagination.el !== i && !r.pagination.el.contains(i)))
            ) {
              let e;
              a.length
                ? (e = a[0].classList.contains(r.params.navigation.hiddenClass))
                : s.length && (e = s[0].classList.contains(r.params.navigation.hiddenClass)),
                l(!0 === e ? 'navigationShow' : 'navigationHide'),
                [...a, ...s].filter((e) => !!e).forEach((e) => e.classList.toggle(r.params.navigation.hiddenClass));
            }
          });
        const m = () => {
          r.el.classList.add(...r.params.navigation.navigationDisabledClass.split(' ')), u();
        };
        Object.assign(r.navigation, {
          enable: () => {
            r.el.classList.remove(...r.params.navigation.navigationDisabledClass.split(' ')), c(), o();
          },
          disable: m,
          update: o,
          init: c,
          destroy: u,
        });
      },
      function (e) {
        let { swiper: d, extendParams: t, on: a, emit: p } = e;
        var s = 'swiper-pagination';
        let c,
          u =
            (t({
              pagination: {
                el: null,
                bulletElement: 'span',
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: 'bullets',
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: (e) => e,
                formatFractionTotal: (e) => e,
                bulletClass: s + '-bullet',
                bulletActiveClass: s + '-bullet-active',
                modifierClass: s + '-',
                currentClass: s + '-current',
                totalClass: s + '-total',
                hiddenClass: s + '-hidden',
                progressbarFillClass: s + '-progressbar-fill',
                progressbarOppositeClass: s + '-progressbar-opposite',
                clickableClass: s + '-clickable',
                lockClass: s + '-lock',
                horizontalClass: s + '-horizontal',
                verticalClass: s + '-vertical',
                paginationDisabledClass: s + '-disabled',
              },
            }),
            (d.pagination = { el: null, bullets: [] }),
            0);
        const m = (e) => (e = Array.isArray(e) ? e : [e].filter((e) => !!e));
        function r() {
          return (
            !d.params.pagination.el ||
            !d.pagination.el ||
            (Array.isArray(d.pagination.el) && 0 === d.pagination.el.length)
          );
        }
        function h(e, t) {
          var a = d.params.pagination['bulletActiveClass'];
          (e = e && e[('prev' === t ? 'previous' : 'next') + 'ElementSibling']) &&
            (e.classList.add(a + '-' + t),
            (e = e[('prev' === t ? 'previous' : 'next') + 'ElementSibling']) && e.classList.add(a + `-${t}-` + t));
        }
        function i(e) {
          const t = e.target.closest(S(d.params.pagination.bulletClass));
          if (t) {
            e.preventDefault();
            var a = E(t) * d.params.slidesPerGroup;
            if (d.params.loop) {
              if (d.realIndex !== a) {
                const e = d.getSlideIndexByData(a),
                  t = d.getSlideIndexByData(d.realIndex);
                e > d.slides.length - d.loopedSlides &&
                  d.loopFix({ direction: e > t ? 'next' : 'prev', activeSlideIndex: e, slideTo: !1 }),
                  d.slideToLoop(a);
              }
            } else d.slideTo(a);
          }
        }
        function l() {
          const l = d.rtl,
            n = d.params.pagination;
          if (!r()) {
            let r,
              e,
              t = d.pagination.el;
            t = m(t);
            const a = (d.virtual && d.params.virtual.enabled ? d.virtual : d).slides.length,
              o = d.params.loop ? Math.ceil(a / d.params.slidesPerGroup) : d.snapGrid.length;
            if (
              (d.params.loop
                ? ((e = d.previousRealIndex || 0),
                  (r = 1 < d.params.slidesPerGroup ? Math.floor(d.realIndex / d.params.slidesPerGroup) : d.realIndex))
                : void 0 !== d.snapIndex
                ? ((r = d.snapIndex), (e = d.previousSnapIndex))
                : ((e = d.previousIndex || 0), (r = d.activeIndex || 0)),
              'bullets' === n.type && d.pagination.bullets && 0 < d.pagination.bullets.length)
            ) {
              const p = d.pagination.bullets;
              let a, s, i;
              if (
                (n.dynamicBullets &&
                  ((c = X(p[0], d.isHorizontal() ? 'width' : 'height', !0)),
                  t.forEach((e) => {
                    e.style[d.isHorizontal() ? 'width' : 'height'] = c * (n.dynamicMainBullets + 4) + 'px';
                  }),
                  1 < n.dynamicMainBullets &&
                    void 0 !== e &&
                    ((u += r - (e || 0)) > n.dynamicMainBullets - 1
                      ? (u = n.dynamicMainBullets - 1)
                      : u < 0 && (u = 0)),
                  (a = Math.max(r - u, 0)),
                  (s = a + (Math.min(p.length, n.dynamicMainBullets) - 1)),
                  (i = (s + a) / 2)),
                p.forEach((e) => {
                  var t = [
                    ...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(
                      (e) => '' + n.bulletActiveClass + e
                    ),
                  ]
                    .map((e) => ('string' == typeof e && e.includes(' ') ? e.split(' ') : e))
                    .flat();
                  e.classList.remove(...t);
                }),
                1 < t.length)
              )
                p.forEach((e) => {
                  var t = E(e);
                  t === r && e.classList.add(...n.bulletActiveClass.split(' ')),
                    n.dynamicBullets &&
                      (t >= a && t <= s && e.classList.add(...(n.bulletActiveClass + '-main').split(' ')),
                      t === a && h(e, 'prev'),
                      t === s && h(e, 'next'));
                });
              else {
                const l = p[r];
                if ((l && l.classList.add(...n.bulletActiveClass.split(' ')), n.dynamicBullets)) {
                  const l = p[a],
                    d = p[s];
                  for (let e = a; e <= s; e += 1)
                    p[e] && p[e].classList.add(...(n.bulletActiveClass + '-main').split(' '));
                  h(l, 'prev'), h(d, 'next');
                }
              }
              if (n.dynamicBullets) {
                const e = Math.min(p.length, n.dynamicMainBullets + 4),
                  t = (c * e - c) / 2 - i * c,
                  u = l ? 'right' : 'left';
                p.forEach((e) => {
                  e.style[d.isHorizontal() ? u : 'top'] = t + 'px';
                });
              }
            }
            t.forEach((e, s) => {
              if (
                ('fraction' === n.type &&
                  (e.querySelectorAll(S(n.currentClass)).forEach((e) => {
                    e.textContent = n.formatFractionCurrent(r + 1);
                  }),
                  e.querySelectorAll(S(n.totalClass)).forEach((e) => {
                    e.textContent = n.formatFractionTotal(o);
                  })),
                'progressbar' === n.type)
              ) {
                var i = n.progressbarOpposite
                  ? d.isHorizontal()
                    ? 'vertical'
                    : 'horizontal'
                  : d.isHorizontal()
                  ? 'horizontal'
                  : 'vertical';
                const s = (r + 1) / o;
                let t = 1,
                  a = 1;
                'horizontal' == i ? (t = s) : (a = s),
                  e.querySelectorAll(S(n.progressbarFillClass)).forEach((e) => {
                    (e.style.transform = `translate3d(0,0,0) scaleX(${t}) scaleY(${a})`),
                      (e.style.transitionDuration = d.params.speed + 'ms');
                  });
              }
              'custom' === n.type && n.renderCustom
                ? ((e.innerHTML = n.renderCustom(d, r + 1, o)), 0 === s && p('paginationRender', e))
                : (0 === s && p('paginationRender', e), p('paginationUpdate', e)),
                d.params.watchOverflow && d.enabled && e.classList[d.isLocked ? 'add' : 'remove'](n.lockClass);
            });
          }
        }
        function n() {
          const s = d.params.pagination;
          if (!r()) {
            var i = (d.virtual && d.params.virtual.enabled ? d.virtual : d).slides.length;
            let e = d.pagination.el,
              a = ((e = m(e)), '');
            if ('bullets' === s.type) {
              let e = d.params.loop ? Math.ceil(i / d.params.slidesPerGroup) : d.snapGrid.length;
              d.params.freeMode && d.params.freeMode.enabled && e > i && (e = i);
              for (let t = 0; t < e; t += 1)
                s.renderBullet
                  ? (a += s.renderBullet.call(d, t, s.bulletClass))
                  : (a += `<${s.bulletElement} class="${s.bulletClass}"></${s.bulletElement}>`);
            }
            'fraction' === s.type &&
              (a = s.renderFraction
                ? s.renderFraction.call(d, s.currentClass, s.totalClass)
                : `<span class="${s.currentClass}"></span> / <span class="${s.totalClass}"></span>`),
              'progressbar' === s.type &&
                (a = s.renderProgressbar
                  ? s.renderProgressbar.call(d, s.progressbarFillClass)
                  : `<span class="${s.progressbarFillClass}"></span>`),
              (d.pagination.bullets = []),
              e.forEach((e) => {
                'custom' !== s.type && (e.innerHTML = a || ''),
                  'bullets' === s.type && d.pagination.bullets.push(...e.querySelectorAll(S(s.bulletClass)));
              }),
              'custom' !== s.type && p('paginationRender', e[0]);
          }
        }
        function o() {
          d.params.pagination = M(d, d.originalParams.pagination, d.params.pagination, { el: 'swiper-pagination' });
          const t = d.params.pagination;
          if (t.el) {
            let e;
            (e =
              (e =
                (e = 'string' == typeof t.el && d.isElement ? d.el.shadowRoot.querySelector(t.el) : e) ||
                'string' != typeof t.el
                  ? e
                  : [...document.querySelectorAll(t.el)]) || t.el) &&
              0 !== e.length &&
              (d.params.uniqueNavElements &&
                'string' == typeof t.el &&
                Array.isArray(e) &&
                1 < e.length &&
                1 < (e = [...d.el.querySelectorAll(t.el)]).length &&
                (e = e.filter((e) => H(e, '.swiper')[0] === d.el)[0]),
              Array.isArray(e) && 1 === e.length && (e = e[0]),
              Object.assign(d.pagination, { el: e }),
              (e = m(e)).forEach((e) => {
                'bullets' === t.type && t.clickable && e.classList.add(t.clickableClass),
                  e.classList.add(t.modifierClass + t.type),
                  e.classList.add(d.isHorizontal() ? t.horizontalClass : t.verticalClass),
                  'bullets' === t.type &&
                    t.dynamicBullets &&
                    (e.classList.add('' + t.modifierClass + t.type + '-dynamic'),
                    (u = 0),
                    t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                  'progressbar' === t.type && t.progressbarOpposite && e.classList.add(t.progressbarOppositeClass),
                  t.clickable && e.addEventListener('click', i),
                  d.enabled || e.classList.add(t.lockClass);
              }));
          }
        }
        function f() {
          const t = d.params.pagination;
          if (!r()) {
            let e = d.pagination.el;
            e &&
              (e = m(e)).forEach((e) => {
                e.classList.remove(t.hiddenClass),
                  e.classList.remove(t.modifierClass + t.type),
                  e.classList.remove(d.isHorizontal() ? t.horizontalClass : t.verticalClass),
                  t.clickable && e.removeEventListener('click', i);
              }),
              d.pagination.bullets &&
                d.pagination.bullets.forEach((e) => e.classList.remove(...t.bulletActiveClass.split(' ')));
          }
        }
        a('changeDirection', () => {
          if (d.pagination && d.pagination.el) {
            const t = d.params.pagination;
            let e = d.pagination['el'];
            (e = m(e)).forEach((e) => {
              e.classList.remove(t.horizontalClass, t.verticalClass),
                e.classList.add(d.isHorizontal() ? t.horizontalClass : t.verticalClass);
            });
          }
        }),
          a('init', () => {
            !1 === d.params.pagination.enabled ? v() : (o(), n(), l());
          }),
          a('activeIndexChange', () => {
            void 0 === d.snapIndex && l();
          }),
          a('snapIndexChange', () => {
            l();
          }),
          a('snapGridLengthChange', () => {
            n(), l();
          }),
          a('destroy', () => {
            f();
          }),
          a('enable disable', () => {
            let e = d.pagination['el'];
            e && (e = m(e)).forEach((e) => e.classList[d.enabled ? 'remove' : 'add'](d.params.pagination.lockClass));
          }),
          a('lock unlock', () => {
            l();
          }),
          a('click', (e, t) => {
            const a = t.target;
            let s = d.pagination['el'];
            if (
              (Array.isArray(s) || (s = [s].filter((e) => !!e)),
              d.params.pagination.el &&
                d.params.pagination.hideOnClick &&
                s &&
                0 < s.length &&
                !a.classList.contains(d.params.pagination.bulletClass) &&
                (!d.navigation ||
                  !(
                    (d.navigation.nextEl && a === d.navigation.nextEl) ||
                    (d.navigation.prevEl && a === d.navigation.prevEl)
                  )))
            ) {
              const e = s[0].classList.contains(d.params.pagination.hiddenClass);
              p(!0 === e ? 'paginationShow' : 'paginationHide'),
                s.forEach((e) => e.classList.toggle(d.params.pagination.hiddenClass));
            }
          });
        const v = () => {
          d.el.classList.add(d.params.pagination.paginationDisabledClass);
          let e = d.pagination['el'];
          e && (e = m(e)).forEach((e) => e.classList.add(d.params.pagination.paginationDisabledClass)), f();
        };
        Object.assign(d.pagination, {
          enable: () => {
            d.el.classList.remove(d.params.pagination.paginationDisabledClass);
            let e = d.pagination['el'];
            e && (e = m(e)).forEach((e) => e.classList.remove(d.params.pagination.paginationDisabledClass)),
              o(),
              n(),
              l();
          },
          disable: v,
          render: n,
          update: l,
          init: o,
          destroy: f,
        });
      },
      function (e) {
        let { swiper: o, extendParams: t, on: a, emit: l } = e;
        const n = L();
        let d,
          p,
          c,
          s,
          u = !1,
          m = null,
          h = null;
        function i() {
          if (o.params.scrollbar.el && o.scrollbar.el) {
            const { scrollbar: a, rtlTranslate: s } = o,
              { dragEl: i, el: r } = a,
              l = o.params.scrollbar,
              n = o.params.loop ? o.progressLoop : o.progress;
            let e = p,
              t = (c - p) * n;
            s
              ? 0 < (t = -t)
                ? ((e = p - t), (t = 0))
                : -t + p > c && (e = c + t)
              : t < 0
              ? ((e = p + t), (t = 0))
              : t + p > c && (e = c - t),
              o.isHorizontal()
                ? ((i.style.transform = `translate3d(${t}px, 0, 0)`), (i.style.width = e + 'px'))
                : ((i.style.transform = `translate3d(0px, ${t}px, 0)`), (i.style.height = e + 'px')),
              l.hide &&
                (clearTimeout(m),
                (r.style.opacity = 1),
                (m = setTimeout(() => {
                  (r.style.opacity = 0), (r.style.transitionDuration = '400ms');
                }, 1e3)));
          }
        }
        function r() {
          if (o.params.scrollbar.el && o.scrollbar.el) {
            const e = o['scrollbar'],
              { dragEl: t, el: a } = e;
            (t.style.width = ''),
              (t.style.height = ''),
              (c = o.isHorizontal() ? a.offsetWidth : a.offsetHeight),
              (s =
                o.size / (o.virtualSize + o.params.slidesOffsetBefore - (o.params.centeredSlides ? o.snapGrid[0] : 0))),
              (p = 'auto' === o.params.scrollbar.dragSize ? c * s : parseInt(o.params.scrollbar.dragSize, 10)),
              o.isHorizontal() ? (t.style.width = p + 'px') : (t.style.height = p + 'px'),
              (a.style.display = 1 <= s ? 'none' : ''),
              o.params.scrollbar.hide && (a.style.opacity = 0),
              o.params.watchOverflow &&
                o.enabled &&
                e.el.classList[o.isLocked ? 'add' : 'remove'](o.params.scrollbar.lockClass);
          }
        }
        function f(e) {
          return o.isHorizontal() ? e.clientX : e.clientY;
        }
        function v(e) {
          var { scrollbar: t, rtlTranslate: a } = o,
            t = t['el'];
          let s;
          (s = (f(e) - D(t)[o.isHorizontal() ? 'left' : 'top'] - (null !== d ? d : p / 2)) / (c - p)),
            (s = Math.max(Math.min(s, 1), 0)),
            a && (s = 1 - s);
          t = o.minTranslate() + (o.maxTranslate() - o.minTranslate()) * s;
          o.updateProgress(t), o.setTranslate(t), o.updateActiveIndex(), o.updateSlidesClasses();
        }
        function g(e) {
          const t = o.params.scrollbar,
            { scrollbar: a, wrapperEl: s } = o,
            { el: i, dragEl: r } = a;
          (u = !0),
            (d = e.target === r ? f(e) - e.target.getBoundingClientRect()[o.isHorizontal() ? 'left' : 'top'] : null),
            e.preventDefault(),
            e.stopPropagation(),
            (s.style.transitionDuration = '100ms'),
            (r.style.transitionDuration = '100ms'),
            v(e),
            clearTimeout(h),
            (i.style.transitionDuration = '0ms'),
            t.hide && (i.style.opacity = 1),
            o.params.cssMode && (o.wrapperEl.style['scroll-snap-type'] = 'none'),
            l('scrollbarDragStart', e);
        }
        function w(e) {
          const { scrollbar: t, wrapperEl: a } = o,
            { el: s, dragEl: i } = t;
          u &&
            (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
            v(e),
            (a.style.transitionDuration = '0ms'),
            (s.style.transitionDuration = '0ms'),
            (i.style.transitionDuration = '0ms'),
            l('scrollbarDragMove', e));
        }
        function b(e) {
          const t = o.params.scrollbar,
            { scrollbar: a, wrapperEl: s } = o,
            i = a['el'];
          u &&
            ((u = !1),
            o.params.cssMode && ((o.wrapperEl.style['scroll-snap-type'] = ''), (s.style.transitionDuration = '')),
            t.hide &&
              (clearTimeout(h),
              (h = T(() => {
                (i.style.opacity = 0), (i.style.transitionDuration = '400ms');
              }, 1e3))),
            l('scrollbarDragEnd', e),
            t.snapOnRelease && o.slideToClosest());
        }
        function y(e) {
          var { scrollbar: t, params: a } = o,
            t = t.el;
          if (t) {
            const s = t,
              i = !!a.passiveListeners && { passive: !1, capture: !1 },
              r = !!a.passiveListeners && { passive: !0, capture: !1 };
            s &&
              ((t = 'on' === e ? 'addEventListener' : 'removeEventListener'),
              s[t]('pointerdown', g, i),
              n[t]('pointermove', w, i),
              n[t]('pointerup', b, r));
          }
        }
        function x() {
          const { scrollbar: a, el: s } = o;
          o.params.scrollbar = M(o, o.originalParams.scrollbar, o.params.scrollbar, { el: 'swiper-scrollbar' });
          var i = o.params.scrollbar;
          if (i.el) {
            let e, t;
            (e =
              (e = 'string' == typeof i.el && o.isElement ? o.el.shadowRoot.querySelector(i.el) : e) ||
              'string' != typeof i.el
                ? e || i.el
                : n.querySelectorAll(i.el)),
              (e =
                0 <
                (e =
                  o.params.uniqueNavElements &&
                  'string' == typeof i.el &&
                  1 < e.length &&
                  1 === s.querySelectorAll(i.el).length
                    ? s.querySelector(i.el)
                    : e).length
                  ? e[0]
                  : e).classList.add(o.isHorizontal() ? i.horizontalClass : i.verticalClass),
              e &&
                ((t = e.querySelector('.' + o.params.scrollbar.dragClass)) ||
                  ((t = O('div', o.params.scrollbar.dragClass)), e.append(t))),
              Object.assign(a, { el: e, dragEl: t }),
              i.draggable && o.params.scrollbar.el && o.scrollbar.el && y('on'),
              e && e.classList[o.enabled ? 'remove' : 'add'](o.params.scrollbar.lockClass);
          }
        }
        function E() {
          const e = o.params.scrollbar,
            t = o.scrollbar.el;
          t && t.classList.remove(o.isHorizontal() ? e.horizontalClass : e.verticalClass),
            o.params.scrollbar.el && o.scrollbar.el && y('off');
        }
        t({
          scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: 'swiper-scrollbar-horizontal',
            verticalClass: 'swiper-scrollbar-vertical',
          },
        }),
          (o.scrollbar = { el: null, dragEl: null }),
          a('init', () => {
            !1 === o.params.scrollbar.enabled ? S() : (x(), r(), i());
          }),
          a('update resize observerUpdate lock unlock', () => {
            r();
          }),
          a('setTranslate', () => {
            i();
          }),
          a('setTransition', (e, t) => {
            (t = t),
              o.params.scrollbar.el && o.scrollbar.el && (o.scrollbar.dragEl.style.transitionDuration = t + 'ms');
          }),
          a('enable disable', () => {
            const e = o.scrollbar['el'];
            e && e.classList[o.enabled ? 'remove' : 'add'](o.params.scrollbar.lockClass);
          }),
          a('destroy', () => {
            E();
          });
        const S = () => {
          o.el.classList.add(o.params.scrollbar.scrollbarDisabledClass),
            o.scrollbar.el && o.scrollbar.el.classList.add(o.params.scrollbar.scrollbarDisabledClass),
            E();
        };
        Object.assign(o.scrollbar, {
          enable: () => {
            o.el.classList.remove(o.params.scrollbar.scrollbarDisabledClass),
              o.scrollbar.el && o.scrollbar.el.classList.remove(o.params.scrollbar.scrollbarDisabledClass),
              x(),
              r(),
              i();
          },
          disable: S,
          updateSize: r,
          setTranslate: i,
          init: x,
          destroy: E,
        });
      },
      function (e) {
        let { swiper: p, extendParams: t, on: a } = e;
        t({ parallax: { enabled: !1 } });
        const r = (e, t) => {
            var a = p['rtl'],
              a = a ? -1 : 1,
              s = e.getAttribute('data-swiper-parallax') || '0';
            let i = e.getAttribute('data-swiper-parallax-x'),
              r = e.getAttribute('data-swiper-parallax-y');
            var l = e.getAttribute('data-swiper-parallax-scale'),
              n = e.getAttribute('data-swiper-parallax-opacity'),
              o = e.getAttribute('data-swiper-parallax-rotate');
            if (
              (i || r
                ? ((i = i || '0'), (r = r || '0'))
                : p.isHorizontal()
                ? ((i = s), (r = '0'))
                : ((r = s), (i = '0')),
              (i = 0 <= i.indexOf('%') ? parseInt(i, 10) * t * a + '%' : i * t * a + 'px'),
              (r = 0 <= r.indexOf('%') ? parseInt(r, 10) * t + '%' : r * t + 'px'),
              null != n)
            ) {
              const p = n - (n - 1) * (1 - Math.abs(t));
              e.style.opacity = p;
            }
            let d = `translate3d(${i}, ${r}, 0px)`;
            null != l && (d += ` scale(${l - (l - 1) * (1 - Math.abs(t))})`),
              o && null != o && (d += ` rotate(${o * t * -1}deg)`),
              (e.style.transform = d);
          },
          s = () => {
            const { el: e, slides: t, progress: s, snapGrid: i } = p;
            k(
              e,
              '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]'
            ).forEach((e) => {
              r(e, s);
            }),
              t.forEach((e, t) => {
                let a = e.progress;
                1 < p.params.slidesPerGroup &&
                  'auto' !== p.params.slidesPerView &&
                  (a += Math.ceil(t / 2) - s * (i.length - 1)),
                  (a = Math.min(Math.max(a, -1), 1)),
                  e
                    .querySelectorAll(
                      '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]'
                    )
                    .forEach((e) => {
                      r(e, a);
                    });
              });
          };
        a('beforeInit', () => {
          p.params.parallax.enabled &&
            ((p.params.watchSlidesProgress = !0), (p.originalParams.watchSlidesProgress = !0));
        }),
          a('init', () => {
            p.params.parallax.enabled && s();
          }),
          a('setTranslate', () => {
            p.params.parallax.enabled && s();
          }),
          a('setTransition', (e, t) => {
            if (p.params.parallax.enabled) {
              var a = t;
              void 0 === a && (a = p.params.speed);
              const s = p['el'];
              s.querySelectorAll(
                '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]'
              ).forEach((e) => {
                let t = parseInt(e.getAttribute('data-swiper-parallax-duration'), 10) || a;
                0 === a && (t = 0), (e.style.transitionDuration = t + 'ms');
              });
            }
          });
      },
      function (e) {
        let { swiper: E, extendParams: t, on: a, emit: s } = e;
        const S = z();
        t({
          zoom: {
            enabled: !1,
            maxRatio: 3,
            minRatio: 1,
            toggle: !0,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed',
          },
        }),
          (E.zoom = { enabled: !1 });
        let i,
          r,
          T = 1,
          l = !1;
        const n = [],
          M = {
            originX: 0,
            originY: 0,
            slideEl: void 0,
            slideWidth: void 0,
            slideHeight: void 0,
            imageEl: void 0,
            imageWrapEl: void 0,
            maxRatio: 3,
          },
          C = {
            isTouched: void 0,
            isMoved: void 0,
            currentX: void 0,
            currentY: void 0,
            minX: void 0,
            minY: void 0,
            maxX: void 0,
            maxY: void 0,
            width: void 0,
            height: void 0,
            startX: void 0,
            startY: void 0,
            touchesStart: {},
            touchesCurrent: {},
          },
          o = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
        let d = 1;
        function p() {
          if (n.length < 2) return 1;
          var e = n[0].pageX,
            t = n[0].pageY,
            a = n[1].pageX,
            s = n[1].pageY;
          return Math.sqrt((a - e) ** 2 + (s - t) ** 2);
        }
        function c(t) {
          var e = E.isElement ? 'swiper-slide' : '.' + E.params.slideClass;
          return t.target.matches(e) || 0 < E.slides.filter((e) => e.contains(t.target)).length;
        }
        function u(t) {
          if (('mouse' === t.pointerType && n.splice(0, n.length), c(t))) {
            var a = E.params.zoom;
            if (((i = !1), (r = !1), n.push(t), !(n.length < 2))) {
              if (((i = !0), (M.scaleStart = p()), !M.slideEl)) {
                (M.slideEl = t.target.closest(`.${E.params.slideClass}, swiper-slide`)),
                  M.slideEl || (M.slideEl = E.slides[E.activeIndex]);
                let e = M.slideEl.querySelector('.' + a.containerClass);
                if (
                  ((e = e && e.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0]),
                  (M.imageEl = e),
                  (M.imageWrapEl = e ? H(M.imageEl, '.' + a.containerClass)[0] : void 0),
                  !M.imageWrapEl)
                )
                  return void (M.imageEl = void 0);
                M.maxRatio = M.imageWrapEl.getAttribute('data-swiper-zoom') || a.maxRatio;
              }
              if (M.imageEl) {
                const [t, E] = (function () {
                  if (n.length < 2) return { x: null, y: null };
                  var e = M.imageEl.getBoundingClientRect();
                  return [
                    (n[0].pageX + (n[1].pageX - n[0].pageX) / 2 - e.x) / T,
                    (n[0].pageY + (n[1].pageY - n[0].pageY) / 2 - e.y) / T,
                  ];
                })();
                (M.originX = t), (M.originY = E), (M.imageEl.style.transitionDuration = '0ms');
              }
              l = !0;
            }
          }
        }
        function m(t) {
          if (c(t)) {
            const e = E.params.zoom,
              a = E.zoom,
              s = n.findIndex((e) => e.pointerId === t.pointerId);
            0 <= s && (n[s] = t),
              n.length < 2 ||
                ((r = !0),
                (M.scaleMove = p()),
                M.imageEl &&
                  ((a.scale = (M.scaleMove / M.scaleStart) * T),
                  a.scale > M.maxRatio && (a.scale = M.maxRatio - 1 + (a.scale - M.maxRatio + 1) ** 0.5),
                  a.scale < e.minRatio && (a.scale = e.minRatio + 1 - (e.minRatio - a.scale + 1) ** 0.5),
                  (M.imageEl.style.transform = `translate3d(0,0,0) scale(${a.scale})`)));
          }
        }
        function h(t) {
          if (c(t) && ('mouse' !== t.pointerType || 'pointerout' !== t.type)) {
            const e = E.params.zoom,
              a = E.zoom,
              s = n.findIndex((e) => e.pointerId === t.pointerId);
            0 <= s && n.splice(s, 1),
              i &&
                r &&
                ((i = !1),
                (r = !1),
                M.imageEl &&
                  ((a.scale = Math.max(Math.min(a.scale, M.maxRatio), e.minRatio)),
                  (M.imageEl.style.transitionDuration = E.params.speed + 'ms'),
                  (M.imageEl.style.transform = `translate3d(0,0,0) scale(${a.scale})`),
                  (T = a.scale),
                  (l = !1),
                  1 < a.scale && M.slideEl
                    ? M.slideEl.classList.add('' + e.zoomedSlideClass)
                    : a.scale <= 1 && M.slideEl && M.slideEl.classList.remove('' + e.zoomedSlideClass),
                  1 === a.scale && ((M.originX = 0), (M.originY = 0), (M.slideEl = void 0))));
          }
        }
        function f(e) {
          if (
            c(e) &&
            ((t = e),
            (a = '.' + E.params.zoom.containerClass),
            t.target.matches(a) || 0 < [...E.el.querySelectorAll(a)].filter((e) => e.contains(t.target)).length)
          ) {
            var t,
              a = E.zoom;
            if (M.imageEl && C.isTouched && M.slideEl) {
              C.isMoved ||
                ((C.width = M.imageEl.offsetWidth),
                (C.height = M.imageEl.offsetHeight),
                (C.startX = A(M.imageWrapEl, 'x') || 0),
                (C.startY = A(M.imageWrapEl, 'y') || 0),
                (M.slideWidth = M.slideEl.offsetWidth),
                (M.slideHeight = M.slideEl.offsetHeight),
                (M.imageWrapEl.style.transitionDuration = '0ms'));
              var s = C.width * a.scale,
                i = C.height * a.scale;
              if (!(s < M.slideWidth && i < M.slideHeight)) {
                if (
                  ((C.minX = Math.min(M.slideWidth / 2 - s / 2, 0)),
                  (C.maxX = -C.minX),
                  (C.minY = Math.min(M.slideHeight / 2 - i / 2, 0)),
                  (C.maxY = -C.minY),
                  (C.touchesCurrent.x = (0 < n.length ? n[0] : e).pageX),
                  (C.touchesCurrent.y = (0 < n.length ? n[0] : e).pageY),
                  5 <
                    Math.max(
                      Math.abs(C.touchesCurrent.x - C.touchesStart.x),
                      Math.abs(C.touchesCurrent.y - C.touchesStart.y)
                    ) && (E.allowClick = !1),
                  !C.isMoved && !l)
                ) {
                  if (
                    E.isHorizontal() &&
                    ((Math.floor(C.minX) === Math.floor(C.startX) && C.touchesCurrent.x < C.touchesStart.x) ||
                      (Math.floor(C.maxX) === Math.floor(C.startX) && C.touchesCurrent.x > C.touchesStart.x))
                  )
                    return void (C.isTouched = !1);
                  if (
                    !E.isHorizontal() &&
                    ((Math.floor(C.minY) === Math.floor(C.startY) && C.touchesCurrent.y < C.touchesStart.y) ||
                      (Math.floor(C.maxY) === Math.floor(C.startY) && C.touchesCurrent.y > C.touchesStart.y))
                  )
                    return void (C.isTouched = !1);
                }
                e.cancelable && e.preventDefault(), e.stopPropagation(), (C.isMoved = !0);
                var s = (a.scale - T) / (M.maxRatio - E.params.zoom.minRatio),
                  { originX: i, originY: a } = M;
                (C.currentX = C.touchesCurrent.x - C.touchesStart.x + C.startX + s * (C.width - 2 * i)),
                  (C.currentY = C.touchesCurrent.y - C.touchesStart.y + C.startY + s * (C.height - 2 * a)),
                  C.currentX < C.minX && (C.currentX = C.minX + 1 - (C.minX - C.currentX + 1) ** 0.8),
                  C.currentX > C.maxX && (C.currentX = C.maxX - 1 + (C.currentX - C.maxX + 1) ** 0.8),
                  C.currentY < C.minY && (C.currentY = C.minY + 1 - (C.minY - C.currentY + 1) ** 0.8),
                  C.currentY > C.maxY && (C.currentY = C.maxY - 1 + (C.currentY - C.maxY + 1) ** 0.8),
                  o.prevPositionX || (o.prevPositionX = C.touchesCurrent.x),
                  o.prevPositionY || (o.prevPositionY = C.touchesCurrent.y),
                  o.prevTime || (o.prevTime = Date.now()),
                  (o.x = (C.touchesCurrent.x - o.prevPositionX) / (Date.now() - o.prevTime) / 2),
                  (o.y = (C.touchesCurrent.y - o.prevPositionY) / (Date.now() - o.prevTime) / 2),
                  Math.abs(C.touchesCurrent.x - o.prevPositionX) < 2 && (o.x = 0),
                  Math.abs(C.touchesCurrent.y - o.prevPositionY) < 2 && (o.y = 0),
                  (o.prevPositionX = C.touchesCurrent.x),
                  (o.prevPositionY = C.touchesCurrent.y),
                  (o.prevTime = Date.now()),
                  (M.imageWrapEl.style.transform = `translate3d(${C.currentX}px, ${C.currentY}px,0)`);
              }
            }
          }
        }
        function v() {
          const e = E.zoom;
          M.slideEl &&
            E.activeIndex !== E.slides.indexOf(M.slideEl) &&
            (M.imageEl && (M.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
            M.imageWrapEl && (M.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
            M.slideEl.classList.remove('' + E.params.zoom.zoomedSlideClass),
            (e.scale = 1),
            (T = 1),
            (M.slideEl = void 0),
            (M.imageEl = void 0),
            (M.imageWrapEl = void 0),
            (M.originX = 0),
            (M.originY = 0));
        }
        function g(w) {
          const b = E.zoom,
            y = E.params.zoom;
          if (!M.slideEl) {
            w && w.target && (M.slideEl = w.target.closest(`.${E.params.slideClass}, swiper-slide`)),
              M.slideEl ||
                (E.params.virtual && E.params.virtual.enabled && E.virtual
                  ? (M.slideEl = k(E.slidesEl, '.' + E.params.slideActiveClass)[0])
                  : (M.slideEl = E.slides[E.activeIndex]));
            let e = M.slideEl.querySelector('.' + y.containerClass);
            (e = e && e.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0]),
              (M.imageEl = e),
              (M.imageWrapEl = e ? H(M.imageEl, '.' + y.containerClass)[0] : void 0);
          }
          if (M.imageEl && M.imageWrapEl) {
            let e, t, a, s, i, r, l, n, o, d, p, c, u, m, h, f, v, g;
            E.params.cssMode && ((E.wrapperEl.style.overflow = 'hidden'), (E.wrapperEl.style.touchAction = 'none')),
              M.slideEl.classList.add('' + y.zoomedSlideClass),
              (t =
                void 0 === C.touchesStart.x && w
                  ? ((e = w.pageX), w.pageY)
                  : ((e = C.touchesStart.x), C.touchesStart.y));
            var x = 'number' == typeof w ? w : null;
            1 === T && x && ((e = void 0), (t = void 0)),
              (b.scale = x || M.imageWrapEl.getAttribute('data-swiper-zoom') || y.maxRatio),
              (T = x || M.imageWrapEl.getAttribute('data-swiper-zoom') || y.maxRatio),
              !w || (1 === T && x)
                ? ((l = 0), (n = 0))
                : ((v = M.slideEl.offsetWidth),
                  (g = M.slideEl.offsetHeight),
                  (a = D(M.slideEl).left + S.scrollX),
                  (s = D(M.slideEl).top + S.scrollY),
                  (i = a + v / 2 - e),
                  (r = s + g / 2 - t),
                  (o = M.imageEl.offsetWidth),
                  (d = M.imageEl.offsetHeight),
                  (p = o * b.scale),
                  (c = d * b.scale),
                  (h = -(u = Math.min(v / 2 - p / 2, 0))),
                  (f = -(m = Math.min(g / 2 - c / 2, 0))),
                  (l = i * b.scale),
                  (n = r * b.scale),
                  (l = l < u ? u : l) > h && (l = h),
                  (n = n < m ? m : n) > f && (n = f)),
              x && 1 === b.scale && ((M.originX = 0), (M.originY = 0)),
              (M.imageWrapEl.style.transitionDuration = '300ms'),
              (M.imageWrapEl.style.transform = `translate3d(${l}px, ${n}px,0)`),
              (M.imageEl.style.transitionDuration = '300ms'),
              (M.imageEl.style.transform = `translate3d(0,0,0) scale(${b.scale})`);
          }
        }
        function w() {
          const e = E.zoom,
            t = E.params.zoom;
          if (!M.slideEl) {
            E.params.virtual && E.params.virtual.enabled && E.virtual
              ? (M.slideEl = k(E.slidesEl, '.' + E.params.slideActiveClass)[0])
              : (M.slideEl = E.slides[E.activeIndex]);
            let e = M.slideEl.querySelector('.' + t.containerClass);
            (e = e && e.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0]),
              (M.imageEl = e),
              (M.imageWrapEl = e ? H(M.imageEl, '.' + t.containerClass)[0] : void 0);
          }
          M.imageEl &&
            M.imageWrapEl &&
            (E.params.cssMode && ((E.wrapperEl.style.overflow = ''), (E.wrapperEl.style.touchAction = '')),
            (e.scale = 1),
            (T = 1),
            (M.imageWrapEl.style.transitionDuration = '300ms'),
            (M.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
            (M.imageEl.style.transitionDuration = '300ms'),
            (M.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
            M.slideEl.classList.remove('' + t.zoomedSlideClass),
            (M.slideEl = void 0),
            (M.originX = 0),
            (M.originY = 0));
        }
        function b(e) {
          var t = E.zoom;
          t.scale && 1 !== t.scale ? w() : g(e);
        }
        function y() {
          return {
            passiveListener: !!E.params.passiveListeners && { passive: !0, capture: !1 },
            activeListenerWithCapture: !E.params.passiveListeners || { passive: !1, capture: !0 },
          };
        }
        function x() {
          const e = E.zoom;
          if (!e.enabled) {
            e.enabled = !0;
            const { passiveListener: t, activeListenerWithCapture: a } = y();
            E.wrapperEl.addEventListener('pointerdown', u, t),
              E.wrapperEl.addEventListener('pointermove', m, a),
              ['pointerup', 'pointercancel', 'pointerout'].forEach((e) => {
                E.wrapperEl.addEventListener(e, h, t);
              }),
              E.wrapperEl.addEventListener('pointermove', f, a);
          }
        }
        function P() {
          const e = E.zoom;
          if (e.enabled) {
            e.enabled = !1;
            const { passiveListener: t, activeListenerWithCapture: a } = y();
            E.wrapperEl.removeEventListener('pointerdown', u, t),
              E.wrapperEl.removeEventListener('pointermove', m, a),
              ['pointerup', 'pointercancel', 'pointerout'].forEach((e) => {
                E.wrapperEl.removeEventListener(e, h, t);
              }),
              E.wrapperEl.removeEventListener('pointermove', f, a);
          }
        }
        Object.defineProperty(E.zoom, 'scale', {
          get: () => d,
          set(e) {
            var t, a;
            d !== e && ((t = M.imageEl), (a = M.slideEl), s('zoomChange', e, t, a)), (d = e);
          },
        }),
          a('init', () => {
            E.params.zoom.enabled && x();
          }),
          a('destroy', () => {
            P();
          }),
          a('touchStart', (e, t) => {
            var a;
            E.zoom.enabled &&
              ((t = t),
              (a = E.device),
              M.imageEl &&
                !C.isTouched &&
                (a.android && t.cancelable && t.preventDefault(),
                (C.isTouched = !0),
                (a = 0 < n.length ? n[0] : t),
                (C.touchesStart.x = a.pageX),
                (C.touchesStart.y = a.pageY)));
          }),
          a('touchEnd', (e, t) => {
            if (E.zoom.enabled) {
              var a = E.zoom;
              if (M.imageEl) {
                if (!C.isTouched || !C.isMoved) return void ((C.isTouched = !1), (C.isMoved = !1));
                (C.isTouched = !1), (C.isMoved = !1);
                let e = 300,
                  t = 300;
                var s = o.x * e,
                  s = C.currentX + s,
                  i = o.y * t,
                  i = C.currentY + i,
                  r =
                    (0 !== o.x && (e = Math.abs((s - C.currentX) / o.x)),
                    0 !== o.y && (t = Math.abs((i - C.currentY) / o.y)),
                    Math.max(e, t)),
                  s = ((C.currentX = s), (C.currentY = i), C.width * a.scale),
                  i = C.height * a.scale;
                (C.minX = Math.min(M.slideWidth / 2 - s / 2, 0)),
                  (C.maxX = -C.minX),
                  (C.minY = Math.min(M.slideHeight / 2 - i / 2, 0)),
                  (C.maxY = -C.minY),
                  (C.currentX = Math.max(Math.min(C.currentX, C.maxX), C.minX)),
                  (C.currentY = Math.max(Math.min(C.currentY, C.maxY), C.minY)),
                  (M.imageWrapEl.style.transitionDuration = r + 'ms'),
                  (M.imageWrapEl.style.transform = `translate3d(${C.currentX}px, ${C.currentY}px,0)`);
              }
            }
          }),
          a('doubleTap', (e, t) => {
            !E.animating && E.params.zoom.enabled && E.zoom.enabled && E.params.zoom.toggle && b(t);
          }),
          a('transitionEnd', () => {
            E.zoom.enabled && E.params.zoom.enabled && v();
          }),
          a('slideChange', () => {
            E.zoom.enabled && E.params.zoom.enabled && E.params.cssMode && v();
          }),
          Object.assign(E.zoom, { enable: x, disable: P, in: g, out: w, toggle: b });
      },
      function (e) {
        let { swiper: n, extendParams: t, on: a } = e;
        function o(e, t) {
          const a = (function () {
            let a, s, i;
            return (e, t) => {
              for (s = -1, a = e.length; 1 < a - s; ) e[(i = (a + s) >> 1)] <= t ? (s = i) : (a = i);
              return a;
            };
          })();
          let s, i;
          return (
            (this.x = e),
            (this.y = t),
            (this.lastIndex = e.length - 1),
            (this.interpolate = function (e) {
              return e
                ? ((i = a(this.x, e)),
                  (s = i - 1),
                  ((e - this.x[s]) * (this.y[i] - this.y[s])) / (this.x[i] - this.x[s]) + this.y[s])
                : 0;
            }),
            this
          );
        }
        function s() {
          n.controller.control && n.controller.spline && ((n.controller.spline = void 0), delete n.controller.spline);
        }
        t({ controller: { control: void 0, inverse: !1, by: 'slide' } }),
          (n.controller = { control: void 0 }),
          a('beforeInit', () => {
            if (
              'undefined' != typeof window &&
              ('string' == typeof n.params.controller.control || n.params.controller.control instanceof HTMLElement)
            ) {
              const t = document.querySelector(n.params.controller.control);
              if (t && t.swiper) n.controller.control = t.swiper;
              else if (t) {
                const a = (e) => {
                  (n.controller.control = e.detail[0]), n.update(), t.removeEventListener('init', a);
                };
                t.addEventListener('init', a);
              }
            } else n.controller.control = n.params.controller.control;
          }),
          a('update', () => {
            s();
          }),
          a('resize', () => {
            s();
          }),
          a('observerUpdate', () => {
            s();
          }),
          a('setTranslate', (e, t, a) => {
            n.controller.control && !n.controller.control.destroyed && n.controller.setTranslate(t, a);
          }),
          a('setTransition', (e, t, a) => {
            n.controller.control && !n.controller.control.destroyed && n.controller.setTransition(t, a);
          }),
          Object.assign(n.controller, {
            setTranslate: function (e, t) {
              var a = n.controller.control;
              let s, i;
              var r = n.constructor;
              function l(e) {
                var t, a;
                e.destroyed ||
                  ((t = n.rtlTranslate ? -n.translate : n.translate),
                  'slide' === n.params.controller.by &&
                    ((a = e),
                    (n.controller.spline = n.params.loop
                      ? new o(n.slidesGrid, a.slidesGrid)
                      : new o(n.snapGrid, a.snapGrid)),
                    (i = -n.controller.spline.interpolate(-t))),
                  (i && 'container' !== n.params.controller.by) ||
                    ((s = (e.maxTranslate() - e.minTranslate()) / (n.maxTranslate() - n.minTranslate())),
                    (!Number.isNaN(s) && Number.isFinite(s)) || (s = 1),
                    (i = (t - n.minTranslate()) * s + e.minTranslate())),
                  n.params.controller.inverse && (i = e.maxTranslate() - i),
                  e.updateProgress(i),
                  e.setTranslate(i, n),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses());
              }
              if (Array.isArray(a)) for (let e = 0; e < a.length; e += 1) a[e] !== t && a[e] instanceof r && l(a[e]);
              else a instanceof r && t !== a && l(a);
            },
            setTransition: function (t, e) {
              const a = n.constructor,
                s = n.controller.control;
              let i;
              function r(e) {
                e.destroyed ||
                  (e.setTransition(t, n),
                  0 !== t &&
                    (e.transitionStart(),
                    e.params.autoHeight &&
                      T(() => {
                        e.updateAutoHeight();
                      }),
                    v(e.wrapperEl, () => {
                      s && e.transitionEnd();
                    })));
              }
              if (Array.isArray(s)) for (i = 0; i < s.length; i += 1) s[i] !== e && s[i] instanceof a && r(s[i]);
              else s instanceof a && e !== s && r(s);
            },
          });
      },
      function (e) {
        let { swiper: d, extendParams: t, on: a } = e,
          p =
            (t({
              a11y: {
                enabled: !0,
                notificationClass: 'swiper-notification',
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}',
                containerMessage: null,
                containerRoleDescriptionMessage: null,
                itemRoleDescriptionMessage: null,
                slideRole: 'group',
                id: null,
              },
            }),
            (d.a11y = { clicked: !1 }),
            null);
        function s(e) {
          const t = p;
          0 !== t.length && ((t.innerHTML = ''), (t.innerHTML = e));
        }
        const c = (e) => (e = Array.isArray(e) ? e : [e].filter((e) => !!e));
        function i(e) {
          (e = c(e)).forEach((e) => {
            e.setAttribute('tabIndex', '0');
          });
        }
        function r(e) {
          (e = c(e)).forEach((e) => {
            e.setAttribute('tabIndex', '-1');
          });
        }
        function l(e, t) {
          (e = c(e)).forEach((e) => {
            e.setAttribute('role', t);
          });
        }
        function u(e, t) {
          (e = c(e)).forEach((e) => {
            e.setAttribute('aria-roledescription', t);
          });
        }
        function m(e, t) {
          (e = c(e)).forEach((e) => {
            e.setAttribute('aria-label', t);
          });
        }
        function n(e) {
          (e = c(e)).forEach((e) => {
            e.setAttribute('aria-disabled', !0);
          });
        }
        function o(e) {
          (e = c(e)).forEach((e) => {
            e.setAttribute('aria-disabled', !1);
          });
        }
        function h(e) {
          if (13 === e.keyCode || 32 === e.keyCode) {
            const t = d.params.a11y,
              a = e.target;
            (d.pagination &&
              d.pagination.el &&
              (a === d.pagination.el || d.pagination.el.contains(e.target)) &&
              !e.target.matches(S(d.params.pagination.bulletClass))) ||
              (d.navigation &&
                d.navigation.nextEl &&
                a === d.navigation.nextEl &&
                ((d.isEnd && !d.params.loop) || d.slideNext(), d.isEnd ? s(t.lastSlideMessage) : s(t.nextSlideMessage)),
              d.navigation &&
                d.navigation.prevEl &&
                a === d.navigation.prevEl &&
                ((d.isBeginning && !d.params.loop) || d.slidePrev(),
                d.isBeginning ? s(t.firstSlideMessage) : s(t.prevSlideMessage)),
              d.pagination && a.matches(S(d.params.pagination.bulletClass)) && a.click());
          }
        }
        function f() {
          return d.pagination && d.pagination.bullets && d.pagination.bullets.length;
        }
        function v() {
          return f() && d.params.pagination.clickable;
        }
        const g = (e, t, a) => {
            var s;
            i(e),
              'BUTTON' !== e.tagName && (l(e, 'button'), e.addEventListener('keydown', h)),
              m(e, a),
              (a = e),
              (s = t),
              (a = c(a)).forEach((e) => {
                e.setAttribute('aria-controls', s);
              });
          },
          w = () => {
            d.a11y.clicked = !0;
          },
          b = () => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                d.destroyed || (d.a11y.clicked = !1);
              });
            });
          },
          y = (e) => {
            var t, a, s;
            d.a11y.clicked ||
              ((t = e.target.closest(`.${d.params.slideClass}, swiper-slide`)) &&
                d.slides.includes(t) &&
                ((a = d.slides.indexOf(t) === d.activeIndex),
                (s = d.params.watchSlidesProgress && d.visibleSlides && d.visibleSlides.includes(t)),
                a ||
                  s ||
                  (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) ||
                  (d.isHorizontal() ? (d.el.scrollLeft = 0) : (d.el.scrollTop = 0),
                  d.slideTo(d.slides.indexOf(t), 0))));
          },
          x = () => {
            const s = d.params.a11y,
              i =
                (s.itemRoleDescriptionMessage && u(d.slides, s.itemRoleDescriptionMessage),
                s.slideRole && l(d.slides, s.slideRole),
                d.slides.length);
            s.slideLabelMessage &&
              d.slides.forEach((e, t) => {
                var a = d.params.loop ? parseInt(e.getAttribute('data-swiper-slide-index'), 10) : t;
                m(e, s.slideLabelMessage.replace(/\{\{index\}\}/, a + 1).replace(/\{\{slidesLength\}\}/, i));
              });
          };
        a('beforeInit', () => {
          (p = O('span', d.params.a11y.notificationClass)).setAttribute('aria-live', 'assertive'),
            p.setAttribute('aria-atomic', 'true');
        }),
          a('afterInit', () => {
            if (d.params.a11y.enabled) {
              const l = d.params.a11y;
              (d.isElement ? d.el.shadowEl : d.el).append(p);
              var a = d.el;
              l.containerRoleDescriptionMessage && u(a, l.containerRoleDescriptionMessage),
                l.containerMessage && m(a, l.containerMessage);
              const n = d.wrapperEl,
                o =
                  l.id ||
                  n.getAttribute('id') ||
                  'swiper-wrapper-' +
                    'x'
                      .repeat((a = void 0 === (a = 16) ? 16 : a))
                      .replace(/x/g, () => Math.round(16 * Math.random()).toString(16));
              var s,
                i,
                a = d.params.autoplay && d.params.autoplay.enabled ? 'off' : 'polite',
                r = o;
              c(n).forEach((e) => {
                e.setAttribute('id', r);
              }),
                (s = n),
                (i = a),
                (s = c(s)).forEach((e) => {
                  e.setAttribute('aria-live', i);
                }),
                x();
              let { nextEl: e, prevEl: t } = d.navigation || {};
              (e = c(e)),
                (t = c(t)),
                e && e.forEach((e) => g(e, o, l.nextSlideMessage)),
                t && t.forEach((e) => g(e, o, l.prevSlideMessage)),
                v() &&
                  (Array.isArray(d.pagination.el) ? d.pagination.el : [d.pagination.el]).forEach((e) => {
                    e.addEventListener('keydown', h);
                  }),
                d.el.addEventListener('focus', y, !0),
                d.el.addEventListener('pointerdown', w, !0),
                d.el.addEventListener('pointerup', b, !0);
            }
          }),
          a('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
            d.params.a11y.enabled && x();
          }),
          a('fromEdge toEdge afterInit lock unlock', () => {
            var e, t;
            d.params.a11y.enabled &&
              !d.params.loop &&
              !d.params.rewind &&
              d.navigation &&
              (({ nextEl: e, prevEl: t } = d.navigation),
              t && (d.isBeginning ? (n(t), r(t)) : (o(t), i(t))),
              e && (d.isEnd ? (n(e), r(e)) : (o(e), i(e))));
          }),
          a('paginationUpdate', () => {
            if (d.params.a11y.enabled) {
              const t = d.params.a11y;
              f() &&
                d.pagination.bullets.forEach((e) => {
                  d.params.pagination.clickable &&
                    (i(e),
                    d.params.pagination.renderBullet ||
                      (l(e, 'button'), m(e, t.paginationBulletMessage.replace(/\{\{index\}\}/, E(e) + 1)))),
                    e.matches(S(d.params.pagination.bulletActiveClass))
                      ? e.setAttribute('aria-current', 'true')
                      : e.removeAttribute('aria-current');
                });
            }
          }),
          a('destroy', () => {
            if (d.params.a11y.enabled) {
              p && p.remove();
              let { nextEl: e, prevEl: t } = d.navigation || {};
              (e = c(e)),
                (t = c(t)),
                e && e.forEach((e) => e.removeEventListener('keydown', h)),
                t && t.forEach((e) => e.removeEventListener('keydown', h)),
                v() &&
                  (Array.isArray(d.pagination.el) ? d.pagination.el : [d.pagination.el]).forEach((e) => {
                    e.removeEventListener('keydown', h);
                  }),
                d.el.removeEventListener('focus', y, !0),
                d.el.removeEventListener('pointerdown', w, !0),
                d.el.removeEventListener('pointerup', b, !0);
            }
          });
      },
      function (e) {
        let { swiper: n, extendParams: t, on: a } = e,
          o = (t({ history: { enabled: !1, root: '', replaceState: !1, key: 'slides', keepQuery: !1 } }), !1),
          s = {};
        const d = (e) =>
            e
              .toString()
              .replace(/\s+/g, '-')
              .replace(/[^\w-]+/g, '')
              .replace(/--+/g, '-')
              .replace(/^-+/, '')
              .replace(/-+$/, ''),
          i = (e) => {
            var t = z();
            let a;
            var t = (a = e ? new URL(e) : t.location).pathname
                .slice(1)
                .split('/')
                .filter((e) => '' !== e),
              s = t.length;
            return { key: t[s - 2], value: t[s - 1] };
          },
          r = (a, s) => {
            const i = z();
            if (o && n.params.history.enabled) {
              let e;
              e = n.params.url ? new URL(n.params.url) : i.location;
              const l = n.slides[s];
              let t = d(l.getAttribute('data-history'));
              if (0 < n.params.history.root.length) {
                let e = n.params.history.root;
                '/' === e[e.length - 1] && (e = e.slice(0, e.length - 1)), (t = e + '/' + (a ? a + '/' : '') + t);
              } else e.pathname.includes(a) || (t = (a ? a + '/' : '') + t);
              n.params.history.keepQuery && (t += e.search);
              var r = i.history.state;
              (r && r.value === t) ||
                (n.params.history.replaceState
                  ? i.history.replaceState({ value: t }, null, t)
                  : i.history.pushState({ value: t }, null, t));
            }
          },
          l = (a, s, i) => {
            if (s)
              for (let e = 0, t = n.slides.length; e < t; e += 1) {
                const r = n.slides[e];
                if (d(r.getAttribute('data-history')) === s) {
                  const s = n.getSlideIndex(r);
                  n.slideTo(s, a, i);
                }
              }
            else n.slideTo(0, a, i);
          },
          p = () => {
            (s = i(n.params.url)), l(n.params.speed, s.value, !1);
          };
        a('init', () => {
          if (n.params.history.enabled) {
            const e = z();
            if (n.params.history) {
              if (!e.history || !e.history.pushState)
                return void ((n.params.history.enabled = !1), (n.params.hashNavigation.enabled = !0));
              (o = !0),
                ((s = i(n.params.url)).key || s.value) && l(0, s.value, n.params.runCallbacksOnInit),
                n.params.history.replaceState || e.addEventListener('popstate', p);
            }
          }
        }),
          a('destroy', () => {
            if (n.params.history.enabled) {
              const e = z();
              n.params.history.replaceState || e.removeEventListener('popstate', p);
            }
          }),
          a('transitionEnd _freeModeNoMomentumRelease', () => {
            o && r(n.params.history.key, n.activeIndex);
          }),
          a('slideChange', () => {
            o && n.params.cssMode && r(n.params.history.key, n.activeIndex);
          });
      },
      function (e) {
        let { swiper: a, extendParams: t, emit: s, on: i } = e,
          r = !1;
        const l = L(),
          n = z(),
          o =
            (t({
              hashNavigation: {
                enabled: !1,
                replaceState: !1,
                watchState: !1,
                getSlideIndex(e, t) {
                  if (a.virtual && a.params.virtual.enabled) {
                    const e = a.slides.filter((e) => e.getAttribute('data-hash') === t)[0];
                    return e ? parseInt(e.getAttribute('data-swiper-slide-index'), 10) : 0;
                  }
                  return a.getSlideIndex(
                    k(a.slidesEl, `.${a.params.slideClass}[data-hash="${t}"], swiper-slide[data-hash="${t}"]`)[0]
                  );
                },
              },
            }),
            () => {
              s('hashChange');
              const e = l.location.hash.replace('#', ''),
                t = a.slidesEl.querySelector(`[data-swiper-slide-index="${a.activeIndex}"]`);
              if (e !== (t ? t.getAttribute('data-hash') : '')) {
                const t = a.params.hashNavigation.getSlideIndex(a, e);
                void 0 === t || Number.isNaN(t) || a.slideTo(t);
              }
            }),
          d = () => {
            if (r && a.params.hashNavigation.enabled) {
              const e = a.slidesEl.querySelector(`[data-swiper-slide-index="${a.activeIndex}"]`),
                t = e ? e.getAttribute('data-hash') || e.getAttribute('data-history') : '';
              a.params.hashNavigation.replaceState && n.history && n.history.replaceState
                ? n.history.replaceState(null, null, '#' + t || '')
                : (l.location.hash = t || ''),
                s('hashSet');
            }
          };
        i('init', () => {
          var e;
          !a.params.hashNavigation.enabled ||
            !a.params.hashNavigation.enabled ||
            (a.params.history && a.params.history.enabled) ||
            ((r = !0),
            (e = l.location.hash.replace('#', '')) &&
              ((e = a.params.hashNavigation.getSlideIndex(a, e)),
              a.slideTo(e || 0, 0, a.params.runCallbacksOnInit, !0)),
            a.params.hashNavigation.watchState && n.addEventListener('hashchange', o));
        }),
          i('destroy', () => {
            a.params.hashNavigation.enabled &&
              a.params.hashNavigation.watchState &&
              n.removeEventListener('hashchange', o);
          }),
          i('transitionEnd _freeModeNoMomentumRelease', () => {
            r && d();
          }),
          i('slideChange', () => {
            r && a.params.cssMode && d();
          });
      },
      function (e) {
        let r,
          l,
          { swiper: n, extendParams: t, on: a, emit: o, params: s } = e;
        (n.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
          t({
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
              pauseOnMouseEnter: !1,
            },
          });
        let d,
          i,
          p,
          c,
          u,
          m,
          h,
          f = s && s.autoplay ? s.autoplay.delay : 3e3,
          v = s && s.autoplay ? s.autoplay.delay : 3e3,
          g = new Date().getTime;
        function w(e) {
          n &&
            !n.destroyed &&
            n.wrapperEl &&
            e.target === n.wrapperEl &&
            (n.wrapperEl.removeEventListener('transitionend', w), T());
        }
        const b = () => {
            var e;
            !n.destroyed &&
              n.autoplay.running &&
              (n.autoplay.paused ? (i = !0) : i && ((v = d), (i = !1)),
              (e = n.autoplay.paused ? d : g + v - new Date().getTime()),
              (n.autoplay.timeLeft = e),
              o('autoplayTimeLeft', e, e / f),
              (l = requestAnimationFrame(() => {
                b();
              })));
          },
          y = (t) => {
            if (!n.destroyed && n.autoplay.running) {
              cancelAnimationFrame(l), b();
              let e = void 0 === t ? n.params.autoplay.delay : t;
              (f = n.params.autoplay.delay), (v = n.params.autoplay.delay);
              var a = (() => {
                let e;
                if (
                  (e =
                    n.virtual && n.params.virtual.enabled
                      ? n.slides.filter((e) => e.classList.contains('swiper-slide-active'))[0]
                      : n.slides[n.activeIndex])
                )
                  return parseInt(e.getAttribute('data-swiper-autoplay'), 10);
              })();
              !Number.isNaN(a) && 0 < a && void 0 === t && ((e = a), (f = a), (v = a)), (d = e);
              const s = n.params.speed,
                i = () => {
                  n &&
                    !n.destroyed &&
                    (n.params.autoplay.reverseDirection
                      ? !n.isBeginning || n.params.loop || n.params.rewind
                        ? (n.slidePrev(s, !0, !0), o('autoplay'))
                        : n.params.autoplay.stopOnLastSlide ||
                          (n.slideTo(n.slides.length - 1, s, !0, !0), o('autoplay'))
                      : !n.isEnd || n.params.loop || n.params.rewind
                      ? (n.slideNext(s, !0, !0), o('autoplay'))
                      : n.params.autoplay.stopOnLastSlide || (n.slideTo(0, s, !0, !0), o('autoplay')),
                    n.params.cssMode &&
                      ((g = new Date().getTime()),
                      requestAnimationFrame(() => {
                        y();
                      })));
                };
              return (
                0 < e
                  ? (clearTimeout(r),
                    (r = setTimeout(() => {
                      i();
                    }, e)))
                  : requestAnimationFrame(() => {
                      i();
                    }),
                e
              );
            }
          },
          x = () => {
            (n.autoplay.running = !0), y(), o('autoplayStart');
          },
          E = () => {
            (n.autoplay.running = !1), clearTimeout(r), cancelAnimationFrame(l), o('autoplayStop');
          },
          S = (e, t) => {
            if (!n.destroyed && n.autoplay.running) {
              clearTimeout(r), e || (h = !0);
              var a = () => {
                o('autoplayPause'),
                  n.params.autoplay.waitForTransition ? n.wrapperEl.addEventListener('transitionend', w) : T();
              };
              if (((n.autoplay.paused = !0), t)) return m && (d = n.params.autoplay.delay), (m = !1), void a();
              var s = d || n.params.autoplay.delay;
              (d = s - (new Date().getTime() - g)), (n.isEnd && d < 0 && !n.params.loop) || (d < 0 && (d = 0), a());
            }
          },
          T = () => {
            (n.isEnd && d < 0 && !n.params.loop) ||
              n.destroyed ||
              !n.autoplay.running ||
              ((g = new Date().getTime()), h ? ((h = !1), y(d)) : y(), (n.autoplay.paused = !1), o('autoplayResume'));
          },
          M = () => {
            var e;
            !n.destroyed &&
              n.autoplay.running &&
              ('hidden' === (e = L()).visibilityState && ((h = !0), S(!0)), 'visible' === e.visibilityState && T());
          },
          C = (e) => {
            'mouse' === e.pointerType && ((h = !0), S(!0));
          },
          P = (e) => {
            'mouse' === e.pointerType && n.autoplay.paused && T();
          };
        a('init', () => {
          n.params.autoplay.enabled &&
            (n.params.autoplay.pauseOnMouseEnter &&
              (n.el.addEventListener('pointerenter', C), n.el.addEventListener('pointerleave', P)),
            L().addEventListener('visibilitychange', M),
            (g = new Date().getTime()),
            x());
        }),
          a('destroy', () => {
            n.el.removeEventListener('pointerenter', C),
              n.el.removeEventListener('pointerleave', P),
              L().removeEventListener('visibilitychange', M),
              n.autoplay.running && E();
          }),
          a('beforeTransitionStart', (e, t, a) => {
            !n.destroyed && n.autoplay.running && (a || !n.params.autoplay.disableOnInteraction ? S(!0, !0) : E());
          }),
          a('sliderFirstMove', () => {
            !n.destroyed &&
              n.autoplay.running &&
              (n.params.autoplay.disableOnInteraction
                ? E()
                : ((p = !0),
                  (c = !1),
                  (h = !1),
                  (u = setTimeout(() => {
                    (h = !0), (c = !0), S(!0);
                  }, 200))));
          }),
          a('touchEnd', () => {
            if (!n.destroyed && n.autoplay.running && p) {
              if ((clearTimeout(u), clearTimeout(r), n.params.autoplay.disableOnInteraction))
                return (c = !1), void (p = !1);
              c && n.params.cssMode && T(), (c = !1), (p = !1);
            }
          }),
          a('slideChange', () => {
            !n.destroyed && n.autoplay.running && (m = !0);
          }),
          Object.assign(n.autoplay, { start: x, stop: E, pause: S, resume: T });
      },
      function (e) {
        let { swiper: d, extendParams: t, on: a } = e,
          s =
            (t({
              thumbs: {
                swiper: null,
                multipleActiveThumbs: !0,
                autoScrollOffset: 0,
                slideThumbActiveClass: 'swiper-slide-thumb-active',
                thumbsContainerClass: 'swiper-thumbs',
              },
            }),
            !1),
          i = !1;
        function r() {
          const e = d.thumbs.swiper;
          if (e && !e.destroyed) {
            const a = e.clickedIndex,
              s = e.clickedSlide;
            var t;
            (s && s.classList.contains(d.params.thumbs.slideThumbActiveClass)) ||
              (null != a &&
                ((t = e.params.loop ? parseInt(e.clickedSlide.getAttribute('data-swiper-slide-index'), 10) : a),
                d.params.loop ? d.slideToLoop(t) : d.slideTo(t)));
          }
        }
        function l() {
          var e = d.params['thumbs'];
          if (s) return !1;
          s = !0;
          const t = d.constructor;
          return (
            e.swiper instanceof t
              ? ((d.thumbs.swiper = e.swiper),
                Object.assign(d.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                Object.assign(d.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                d.thumbs.swiper.update())
              : p(e.swiper) &&
                ((e = Object.assign({}, e.swiper)),
                Object.assign(e, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                (d.thumbs.swiper = new t(e)),
                (i = !0)),
            d.thumbs.swiper.el.classList.add(d.params.thumbs.thumbsContainerClass),
            d.thumbs.swiper.on('tap', r),
            !0
          );
        }
        function n(s) {
          const i = d.thumbs.swiper;
          if (i && !i.destroyed) {
            var r = 'auto' === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView;
            let a = 1;
            const o = d.params.thumbs.slideThumbActiveClass;
            if (
              (1 < d.params.slidesPerView && !d.params.centeredSlides && (a = d.params.slidesPerView),
              d.params.thumbs.multipleActiveThumbs || (a = 1),
              (a = Math.floor(a)),
              i.slides.forEach((e) => e.classList.remove(o)),
              i.params.loop || (i.params.virtual && i.params.virtual.enabled))
            )
              for (let e = 0; e < a; e += 1)
                k(i.slidesEl, `[data-swiper-slide-index="${d.realIndex + e}"]`).forEach((e) => {
                  e.classList.add(o);
                });
            else for (let t = 0; t < a; t += 1) i.slides[d.realIndex + t] && i.slides[d.realIndex + t].classList.add(o);
            var l = d.params.thumbs.autoScrollOffset,
              n = l && !i.params.loop;
            if (d.realIndex !== i.realIndex || n) {
              const e = i.activeIndex;
              let t, a;
              if (i.params.loop) {
                const s = i.slides.filter((e) => e.getAttribute('data-swiper-slide-index') === '' + d.realIndex)[0];
                (t = i.slides.indexOf(s)), (a = d.activeIndex > d.previousIndex ? 'next' : 'prev');
              } else (t = d.realIndex), (a = t > d.previousIndex ? 'next' : 'prev');
              n && (t += 'next' === a ? l : -1 * l),
                i.visibleSlidesIndexes &&
                  i.visibleSlidesIndexes.indexOf(t) < 0 &&
                  (i.params.centeredSlides
                    ? (t = t > e ? t - Math.floor(r / 2) + 1 : t + Math.floor(r / 2) - 1)
                    : t > e && i.params.slidesPerGroup,
                  i.slideTo(t, s ? 0 : void 0));
            }
          }
        }
        (d.thumbs = { swiper: null }),
          a('beforeInit', () => {
            const a = d.params['thumbs'];
            if (a && a.swiper)
              if ('string' == typeof a.swiper || a.swiper instanceof HTMLElement) {
                const s = L(),
                  e = () => {
                    d.destroyed ||
                      (() => {
                        const t = 'string' == typeof a.swiper ? s.querySelector(a.swiper) : a.swiper;
                        if (t && t.swiper) (a.swiper = t.swiper), l(), n(!0);
                        else if (t) {
                          const s = (e) => {
                            (a.swiper = e.detail[0]),
                              t.removeEventListener('init', s),
                              l(),
                              n(!0),
                              a.swiper.update(),
                              d.update();
                          };
                          t.addEventListener('init', s);
                        }
                        return t;
                      })() ||
                      requestAnimationFrame(e);
                  };
                requestAnimationFrame(e);
              } else l(), n(!0);
          }),
          a('slideChange update resize observerUpdate', () => {
            n();
          }),
          a('setTransition', (e, t) => {
            const a = d.thumbs.swiper;
            a && !a.destroyed && a.setTransition(t);
          }),
          a('beforeDestroy', () => {
            const e = d.thumbs.swiper;
            e && !e.destroyed && i && e.destroy();
          }),
          Object.assign(d.thumbs, { init: l, update: n });
      },
      function (e) {
        let { swiper: m, extendParams: t, emit: h, once: f } = e;
        t({
          freeMode: {
            enabled: !1,
            momentum: !0,
            momentumRatio: 1,
            momentumBounce: !0,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: !1,
            minimumVelocity: 0.02,
          },
        }),
          Object.assign(m, {
            freeMode: {
              onTouchStart: function () {
                var e = m.getTranslate();
                m.setTranslate(e),
                  m.setTransition(0),
                  (m.touchEventsData.velocities.length = 0),
                  m.freeMode.onTouchEnd({ currentPos: m.rtl ? m.translate : -m.translate });
              },
              onTouchMove: function () {
                const { touchEventsData: e, touches: t } = m;
                0 === e.velocities.length &&
                  e.velocities.push({ position: t[m.isHorizontal() ? 'startX' : 'startY'], time: e.touchStartTime }),
                  e.velocities.push({ position: t[m.isHorizontal() ? 'currentX' : 'currentY'], time: g() });
              },
              onTouchEnd: function (r) {
                let l = r['currentPos'];
                const { params: n, wrapperEl: o, rtlTranslate: d, snapGrid: p, touchEventsData: c } = m,
                  e = g() - c.touchStartTime;
                if (l < -m.minTranslate()) m.slideTo(m.activeIndex);
                else if (l > -m.maxTranslate())
                  m.slides.length < p.length ? m.slideTo(p.length - 1) : m.slideTo(m.slides.length - 1);
                else {
                  if (n.freeMode.momentum) {
                    if (1 < c.velocities.length) {
                      const r = c.velocities.pop(),
                        l = c.velocities.pop(),
                        h = r.position - l.position,
                        f = r.time - l.time;
                      (m.velocity = h / f),
                        (m.velocity /= 2),
                        Math.abs(m.velocity) < n.freeMode.minimumVelocity && (m.velocity = 0),
                        (150 < f || 300 < g() - r.time) && (m.velocity = 0);
                    } else m.velocity = 0;
                    (m.velocity *= n.freeMode.momentumVelocityRatio), (c.velocities.length = 0);
                    let e = 1e3 * n.freeMode.momentumRatio;
                    const l = m.velocity * e;
                    let a = m.translate + l;
                    d && (a = -a);
                    let t,
                      s = !1;
                    var u = 20 * Math.abs(m.velocity) * n.freeMode.momentumBounceRatio;
                    let i;
                    if (a < m.maxTranslate())
                      n.freeMode.momentumBounce
                        ? (a + m.maxTranslate() < -u && (a = m.maxTranslate() - u),
                          (t = m.maxTranslate()),
                          (s = !0),
                          (c.allowMomentumBounce = !0))
                        : (a = m.maxTranslate()),
                        n.loop && n.centeredSlides && (i = !0);
                    else if (a > m.minTranslate())
                      n.freeMode.momentumBounce
                        ? (a - m.minTranslate() > u && (a = m.minTranslate() + u),
                          (t = m.minTranslate()),
                          (s = !0),
                          (c.allowMomentumBounce = !0))
                        : (a = m.minTranslate()),
                        n.loop && n.centeredSlides && (i = !0);
                    else if (n.freeMode.sticky) {
                      let e;
                      for (let t = 0; t < p.length; t += 1)
                        if (p[t] > -a) {
                          e = t;
                          break;
                        }
                      a = -(a =
                        Math.abs(p[e] - a) < Math.abs(p[e - 1] - a) || 'next' === m.swipeDirection ? p[e] : p[e - 1]);
                    }
                    if (
                      (i &&
                        f('transitionEnd', () => {
                          m.loopFix();
                        }),
                      0 !== m.velocity)
                    ) {
                      if (
                        ((e = d ? Math.abs((-a - m.translate) / m.velocity) : Math.abs((a - m.translate) / m.velocity)),
                        n.freeMode.sticky)
                      ) {
                        const l = Math.abs((d ? -a : a) - m.translate),
                          h = m.slidesSizesGrid[m.activeIndex];
                        e = l < h ? n.speed : l < 2 * h ? 1.5 * n.speed : 2.5 * n.speed;
                      }
                    } else if (n.freeMode.sticky) return void m.slideToClosest();
                    n.freeMode.momentumBounce && s
                      ? (m.updateProgress(t),
                        m.setTransition(e),
                        m.setTranslate(a),
                        m.transitionStart(!0, m.swipeDirection),
                        (m.animating = !0),
                        v(o, () => {
                          m &&
                            !m.destroyed &&
                            c.allowMomentumBounce &&
                            (h('momentumBounce'),
                            m.setTransition(n.speed),
                            setTimeout(() => {
                              m.setTranslate(t),
                                v(o, () => {
                                  m && !m.destroyed && m.transitionEnd();
                                });
                            }, 0));
                        }))
                      : m.velocity
                      ? (h('_freeModeNoMomentumRelease'),
                        m.updateProgress(a),
                        m.setTransition(e),
                        m.setTranslate(a),
                        m.transitionStart(!0, m.swipeDirection),
                        m.animating ||
                          ((m.animating = !0),
                          v(o, () => {
                            m && !m.destroyed && m.transitionEnd();
                          })))
                      : m.updateProgress(a),
                      m.updateActiveIndex(),
                      m.updateSlidesClasses();
                  } else {
                    if (n.freeMode.sticky) return void m.slideToClosest();
                    n.freeMode && h('_freeModeNoMomentumRelease');
                  }
                  (!n.freeMode.momentum || e >= n.longSwipesMs) &&
                    (m.updateProgress(), m.updateActiveIndex(), m.updateSlidesClasses());
                }
              },
            },
          });
      },
      function (e) {
        let c,
          u,
          m,
          { swiper: h, extendParams: t } = e;
        t({ grid: { rows: 1, fill: 'column' } });
        const f = () => {
          let e = h.params.spaceBetween;
          return (
            'string' == typeof e && 0 <= e.indexOf('%')
              ? (e = (parseFloat(e.replace('%', '')) / 100) * h.size)
              : 'string' == typeof e && (e = parseFloat(e)),
            e
          );
        };
        h.grid = {
          initSlides: (e) => {
            var t = h.params['slidesPerView'],
              { rows: a, fill: s } = h.params.grid;
            (u = c / a),
              (m = Math.floor(e / a)),
              (c = Math.floor(e / a) === e / a ? e : Math.ceil(e / a) * a),
              'auto' !== t && 'row' === s && (c = Math.max(c, t * a));
          },
          updateSlide: (e, t, a, s) => {
            var i = h.params['slidesPerGroup'],
              r = f(),
              { rows: l, fill: n } = h.params.grid;
            let o, d, p;
            if ('row' === n && 1 < i) {
              const u = Math.floor(e / (i * l)),
                m = e - l * i * u,
                h = 0 === u ? i : Math.min(Math.ceil((a - u * l * i) / l), i);
              (p = Math.floor(m / h)), (o = (d = m - p * h + u * i) + (p * c) / l), (t.style.order = o);
            } else
              'column' === n
                ? ((d = Math.floor(e / l)),
                  (p = e - d * l),
                  (d > m || (d === m && p === l - 1)) && (p += 1) >= l && ((p = 0), (d += 1)))
                : ((p = Math.floor(e / u)), (d = e - p * u));
            t.style[s('margin-top')] = 0 !== p ? r && r + 'px' : '';
          },
          updateWrapperSize: (a, s, e) => {
            var { centeredSlides: t, roundLengths: i } = h.params,
              r = f(),
              l = h.params.grid['rows'];
            if (
              ((h.virtualSize = (a + r) * c),
              (h.virtualSize = Math.ceil(h.virtualSize / l) - r),
              (h.wrapperEl.style[e('width')] = h.virtualSize + r + 'px'),
              t)
            ) {
              const a = [];
              for (let t = 0; t < s.length; t += 1) {
                let e = s[t];
                i && (e = Math.floor(e)), s[t] < h.virtualSize + s[0] && a.push(e);
              }
              s.splice(0, s.length), s.push(...a);
            }
          },
        };
      },
      function (e) {
        var t = e['swiper'];
        Object.assign(t, {
          appendSlide: function (t) {
            const e = this,
              { params: a, slidesEl: s } = e;
            a.loop && e.loopDestroy();
            var i = (e) => {
              if ('string' == typeof e) {
                const t = document.createElement('div');
                (t.innerHTML = e), s.append(t.children[0]), (t.innerHTML = '');
              } else s.append(e);
            };
            if ('object' == typeof t && 'length' in t) for (let e = 0; e < t.length; e += 1) t[e] && i(t[e]);
            else i(t);
            e.recalcSlides(), a.loop && e.loopCreate(), (a.observer && !e.isElement) || e.update();
          }.bind(t),
          prependSlide: function (t) {
            const e = this,
              { params: a, activeIndex: s, slidesEl: i } = e;
            a.loop && e.loopDestroy();
            let r = s + 1;
            var l = (e) => {
              if ('string' == typeof e) {
                const t = document.createElement('div');
                (t.innerHTML = e), i.prepend(t.children[0]), (t.innerHTML = '');
              } else i.prepend(e);
            };
            if ('object' == typeof t && 'length' in t) {
              for (let e = 0; e < t.length; e += 1) t[e] && l(t[e]);
              r = s + t.length;
            } else l(t);
            e.recalcSlides(), a.loop && e.loopCreate(), (a.observer && !e.isElement) || e.update(), e.slideTo(r, 0, !1);
          }.bind(t),
          addSlide: function (s, i) {
            const r = this,
              { params: l, activeIndex: e, slidesEl: n } = r;
            let o = e;
            l.loop && ((o -= r.loopedSlides), r.loopDestroy(), r.recalcSlides());
            var d = r.slides.length;
            if (s <= 0) r.prependSlide(i);
            else if (d <= s) r.appendSlide(i);
            else {
              let t = o > s ? o + 1 : o;
              const p = [];
              for (let e = d - 1; e >= s; --e) {
                const s = r.slides[e];
                s.remove(), p.unshift(s);
              }
              if ('object' == typeof i && 'length' in i) {
                for (let e = 0; e < i.length; e += 1) i[e] && n.append(i[e]);
                t = o > s ? o + i.length : o;
              } else n.append(i);
              for (let a = 0; a < p.length; a += 1) n.append(p[a]);
              r.recalcSlides(),
                l.loop && r.loopCreate(),
                (l.observer && !r.isElement) || r.update(),
                l.loop ? r.slideTo(t + r.loopedSlides, 0, !1) : r.slideTo(t, 0, !1);
            }
          }.bind(t),
          removeSlide: function (t) {
            var a = this,
              { params: e, activeIndex: s } = a;
            let i = s;
            e.loop && ((i -= a.loopedSlides), a.loopDestroy());
            let r,
              l = i;
            if ('object' == typeof t && 'length' in t) {
              for (let e = 0; e < t.length; e += 1) (r = t[e]), a.slides[r] && a.slides[r].remove(), r < l && --l;
              l = Math.max(l, 0);
            } else (r = t), a.slides[r] && a.slides[r].remove(), r < l && --l, (l = Math.max(l, 0));
            a.recalcSlides(),
              e.loop && a.loopCreate(),
              (e.observer && !a.isElement) || a.update(),
              e.loop ? a.slideTo(l + a.loopedSlides, 0, !1) : a.slideTo(l, 0, !1);
          }.bind(t),
          removeAllSlides: function () {
            const e = [];
            for (let t = 0; t < this.slides.length; t += 1) e.push(t);
            this.removeSlide(e);
          }.bind(t),
        });
      },
      function (e) {
        let { swiper: l, extendParams: t, on: a } = e;
        t({ fadeEffect: { crossFade: !1 } }),
          o({
            effect: 'fade',
            swiper: l,
            on: a,
            setTranslate: () => {
              const a = l['slides'];
              l.params.fadeEffect;
              for (let s = 0; s < a.length; s += 1) {
                const a = l.slides[s];
                let e = -a.swiperSlideOffset,
                  t = (l.params.virtualTranslate || (e -= l.translate), 0);
                l.isHorizontal() || ((t = e), (e = 0));
                const i = l.params.fadeEffect.crossFade
                    ? Math.max(1 - Math.abs(a.progress), 0)
                    : 1 + Math.min(Math.max(a.progress, -1), 0),
                  r = x(0, a);
                (r.style.opacity = i), (r.style.transform = `translate3d(${e}px, ${t}px, 0px)`);
              }
            },
            setTransition: (t) => {
              const e = l.slides.map((e) => n(e));
              e.forEach((e) => {
                e.style.transitionDuration = t + 'ms';
              }),
                m({ swiper: l, duration: t, transformElements: e, allSlides: !0 });
            },
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              spaceBetween: 0,
              virtualTranslate: !l.params.cssMode,
            }),
          });
      },
      function (e) {
        let { swiper: v, extendParams: t, on: a } = e;
        t({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } });
        const g = (e, t, a) => {
          let s = a ? e.querySelector('.swiper-slide-shadow-left') : e.querySelector('.swiper-slide-shadow-top'),
            i = a ? e.querySelector('.swiper-slide-shadow-right') : e.querySelector('.swiper-slide-shadow-bottom');
          s || ((s = O('div', 'swiper-slide-shadow-' + (a ? 'left' : 'top'))), e.append(s)),
            i || ((i = O('div', 'swiper-slide-shadow-' + (a ? 'right' : 'bottom'))), e.append(i)),
            s && (s.style.opacity = Math.max(-t, 0)),
            i && (i.style.opacity = Math.max(t, 0));
        };
        o({
          effect: 'cube',
          swiper: v,
          on: a,
          setTranslate: () => {
            const { el: e, wrapperEl: t, slides: l, width: a, height: s, rtlTranslate: n, size: o, browser: d } = v,
              p = v.params.cubeEffect,
              c = v.isHorizontal(),
              u = v.virtual && v.params.virtual.enabled;
            let i,
              m = 0;
            p.shadow &&
              (c
                ? ((i = v.slidesEl.querySelector('.swiper-cube-shadow')) ||
                    ((i = O('div', 'swiper-cube-shadow')), v.slidesEl.append(i)),
                  (i.style.height = a + 'px'))
                : (i = e.querySelector('.swiper-cube-shadow')) || ((i = O('div', 'swiper-cube-shadow')), e.append(i)));
            for (let f = 0; f < l.length; f += 1) {
              const v = l[f];
              let e = f,
                t = 90 * (e = u ? parseInt(v.getAttribute('data-swiper-slide-index'), 10) : e),
                a = Math.floor(t / 360);
              n && ((t = -t), (a = Math.floor(-t / 360)));
              const d = Math.max(Math.min(v.progress, 1), -1);
              let s = 0,
                i = 0,
                r = 0;
              e % 4 == 0
                ? ((s = 4 * -a * o), (r = 0))
                : (e - 1) % 4 == 0
                ? ((s = 0), (r = 4 * -a * o))
                : (e - 2) % 4 == 0
                ? ((s = o + 4 * a * o), (r = o))
                : (e - 3) % 4 == 0 && ((s = -o), (r = 3 * o + 4 * o * a)),
                n && (s = -s),
                c || ((i = s), (s = 0));
              var h = `rotateX(${c ? 0 : -t}deg) rotateY(${c ? t : 0}deg) translate3d(${s}px, ${i}px, ${r}px)`;
              d <= 1 && -1 < d && ((m = 90 * e + 90 * d), n && (m = 90 * -e - 90 * d)),
                (v.style.transform = h),
                p.slideShadows && g(v, d, c);
            }
            if (
              ((t.style.transformOrigin = `50% 50% -${o / 2}px`),
              (t.style['-webkit-transform-origin'] = `50% 50% -${o / 2}px`),
              p.shadow)
            )
              if (c)
                i.style.transform = `translate3d(0px, ${a / 2 + p.shadowOffset}px, ${
                  -a / 2
                }px) rotateX(90deg) rotateZ(0deg) scale(${p.shadowScale})`;
              else {
                const e = Math.abs(m) - 90 * Math.floor(Math.abs(m) / 90),
                  v = 1.5 - (Math.sin((2 * e * Math.PI) / 360) / 2 + Math.cos((2 * e * Math.PI) / 360) / 2),
                  t = p.shadowScale,
                  l = p.shadowScale / v,
                  g = p.shadowOffset;
                i.style.transform = `scale3d(${t}, 1, ${l}) translate3d(0px, ${s / 2 + g}px, ${
                  -s / 2 / l
                }px) rotateX(-90deg)`;
              }
            var r = (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -o / 2 : 0;
            (t.style.transform = `translate3d(0px,0,${r}px) rotateX(${v.isHorizontal() ? 0 : m}deg) rotateY(${
              v.isHorizontal() ? -m : 0
            }deg)`),
              t.style.setProperty('--swiper-cube-translate-z', r + 'px');
          },
          setTransition: (t) => {
            const { el: e, slides: a } = v;
            if (
              (a.forEach((e) => {
                (e.style.transitionDuration = t + 'ms'),
                  e
                    .querySelectorAll(
                      '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                    )
                    .forEach((e) => {
                      e.style.transitionDuration = t + 'ms';
                    });
              }),
              v.params.cubeEffect.shadow && !v.isHorizontal())
            ) {
              const v = e.querySelector('.swiper-cube-shadow');
              v && (v.style.transitionDuration = t + 'ms');
            }
          },
          recreateShadows: () => {
            const a = v.isHorizontal();
            v.slides.forEach((e) => {
              var t = Math.max(Math.min(e.progress, 1), -1);
              g(e, t, a);
            });
          },
          getEffectParams: () => v.params.cubeEffect,
          perspective: () => !0,
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: !1,
            virtualTranslate: !0,
          }),
        });
      },
      function (e) {
        let { swiper: c, extendParams: t, on: a } = e;
        t({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
        const u = (e, t, a) => {
          let s = c.isHorizontal()
              ? e.querySelector('.swiper-slide-shadow-left')
              : e.querySelector('.swiper-slide-shadow-top'),
            i = c.isHorizontal()
              ? e.querySelector('.swiper-slide-shadow-right')
              : e.querySelector('.swiper-slide-shadow-bottom');
          (s = s || C(0, e, c.isHorizontal() ? 'left' : 'top')),
            (i = i || C(0, e, c.isHorizontal() ? 'right' : 'bottom')),
            s && (s.style.opacity = Math.max(-t, 0)),
            i && (i.style.opacity = Math.max(t, 0));
        };
        o({
          effect: 'flip',
          swiper: c,
          on: a,
          setTranslate: () => {
            var { slides: r, rtlTranslate: l } = c,
              n = c.params.flipEffect;
            for (let d = 0; d < r.length; d += 1) {
              const p = r[d];
              let e = p.progress;
              c.params.flipEffect.limitRotation && (e = Math.max(Math.min(p.progress, 1), -1));
              var o = p.swiperSlideOffset;
              let t = -180 * e,
                a = 0,
                s = c.params.cssMode ? -o - c.translate : -o,
                i = 0;
              c.isHorizontal() ? l && (t = -t) : ((i = s), (s = 0), (a = -t), (t = 0)),
                (p.style.zIndex = -Math.abs(Math.round(e)) + r.length),
                n.slideShadows && u(p, e);
              o = `translate3d(${s}px, ${i}px, 0px) rotateX(${a}deg) rotateY(${t}deg)`;
              x(0, p).style.transform = o;
            }
          },
          setTransition: (t) => {
            const e = c.slides.map((e) => n(e));
            e.forEach((e) => {
              (e.style.transitionDuration = t + 'ms'),
                e
                  .querySelectorAll(
                    '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                  )
                  .forEach((e) => {
                    e.style.transitionDuration = t + 'ms';
                  });
            }),
              m({ swiper: c, duration: t, transformElements: e });
          },
          recreateShadows: () => {
            c.params.flipEffect,
              c.slides.forEach((e) => {
                let t = e.progress;
                c.params.flipEffect.limitRotation && (t = Math.max(Math.min(e.progress, 1), -1)), u(e, t);
              });
          },
          getEffectParams: () => c.params.flipEffect,
          perspective: () => !0,
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !c.params.cssMode,
          }),
        });
      },
      function (e) {
        let { swiper: b, extendParams: t, on: a } = e;
        t({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: !0 } }),
          o({
            effect: 'coverflow',
            swiper: b,
            on: a,
            setTranslate: () => {
              const { width: e, height: n, slides: o, slidesSizesGrid: d } = b,
                p = b.params.coverflowEffect,
                c = b.isHorizontal(),
                u = b.translate,
                m = c ? e / 2 - u : n / 2 - u,
                h = c ? p.rotate : -p.rotate,
                f = p.depth;
              for (let g = 0, t = o.length; g < t; g += 1) {
                const b = o[g],
                  n = d[g],
                  u = (m - b.swiperSlideOffset - n / 2) / n,
                  w = 'function' == typeof p.modifier ? p.modifier(u) : u * p.modifier;
                let e = c ? h * w : 0,
                  t = c ? 0 : h * w,
                  a = -f * Math.abs(w),
                  s = p.stretch,
                  i =
                    ('string' == typeof s && -1 !== s.indexOf('%') && (s = (parseFloat(p.stretch) / 100) * n),
                    c ? 0 : s * w),
                  r = c ? s * w : 0,
                  l = 1 - (1 - p.scale) * Math.abs(w);
                Math.abs(r) < 0.001 && (r = 0),
                  Math.abs(i) < 0.001 && (i = 0),
                  Math.abs(a) < 0.001 && (a = 0),
                  Math.abs(e) < 0.001 && (e = 0),
                  Math.abs(t) < 0.001 && (t = 0),
                  Math.abs(l) < 0.001 && (l = 0);
                var v = `translate3d(${r}px,${i}px,${a}px)  rotateX(${t}deg) rotateY(${e}deg) scale(${l})`;
                if (((x(0, b).style.transform = v), (b.style.zIndex = 1 - Math.abs(Math.round(w))), p.slideShadows)) {
                  let e = c
                      ? b.querySelector('.swiper-slide-shadow-left')
                      : b.querySelector('.swiper-slide-shadow-top'),
                    t = c
                      ? b.querySelector('.swiper-slide-shadow-right')
                      : b.querySelector('.swiper-slide-shadow-bottom');
                  (e = e || C(0, b, c ? 'left' : 'top')),
                    (t = t || C(0, b, c ? 'right' : 'bottom')),
                    e && (e.style.opacity = 0 < w ? w : 0),
                    t && (t.style.opacity = 0 < -w ? -w : 0);
                }
              }
            },
            setTransition: (t) => {
              b.slides
                .map((e) => n(e))
                .forEach((e) => {
                  (e.style.transitionDuration = t + 'ms'),
                    e
                      .querySelectorAll(
                        '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left'
                      )
                      .forEach((e) => {
                        e.style.transitionDuration = t + 'ms';
                      });
                });
            },
            perspective: () => !0,
            overwriteParams: () => ({ watchSlidesProgress: !0 }),
          });
      },
      function (e) {
        let { swiper: b, extendParams: t, on: a } = e;
        t({
          creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: !1,
            progressMultiplier: 1,
            perspective: !0,
            prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
            next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
          },
        });
        o({
          effect: 'creative',
          swiper: b,
          on: a,
          setTranslate: () => {
            const { slides: s, wrapperEl: e, slidesSizesGrid: i } = b,
              r = b.params.creativeEffect,
              l = r['progressMultiplier'],
              n = b.params.centeredSlides;
            if (n) {
              const s = i[0] / 2 - b.params.slidesOffsetBefore || 0;
              e.style.transform = `translateX(calc(50% - ${s}px))`;
            }
            for (let u = 0; u < s.length; u += 1) {
              const i = s[u],
                m = i.progress,
                h = Math.min(Math.max(i.progress, -r.limitProgress), r.limitProgress);
              let e = h;
              n || (e = Math.min(Math.max(i.originalProgress, -r.limitProgress), r.limitProgress));
              const f = i.swiperSlideOffset,
                v = [b.params.cssMode ? -f - b.translate : -f, 0, 0],
                g = [0, 0, 0];
              let t = !1,
                a =
                  (b.isHorizontal() || ((v[1] = v[0]), (v[0] = 0)),
                  { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 });
              h < 0 ? ((a = r.next), (t = !0)) : 0 < h && ((a = r.prev), (t = !0)),
                v.forEach((e, t) => {
                  v[t] = `calc(${e}px + (${((e = a.translate[t]), 'string' == typeof e ? e : e + 'px')} * ${Math.abs(
                    h * l
                  )}))`;
                }),
                g.forEach((e, t) => {
                  g[t] = a.rotate[t] * Math.abs(h * l);
                }),
                (i.style.zIndex = -Math.abs(Math.round(m)) + s.length);
              var o = v.join(', '),
                d = `rotateX(${g[0]}deg) rotateY(${g[1]}deg) rotateZ(${g[2]}deg)`,
                p = e < 0 ? `scale(${1 + (1 - a.scale) * e * l})` : `scale(${1 - (1 - a.scale) * e * l})`,
                c = e < 0 ? 1 + (1 - a.opacity) * e * l : 1 - (1 - a.opacity) * e * l,
                o = `translate3d(${o}) ${d} ` + p;
              if ((t && a.shadow) || !t) {
                let e = i.querySelector('.swiper-slide-shadow');
                if ((e = !e && a.shadow ? C(0, i) : e)) {
                  const b = r.shadowPerProgress ? h * (1 / r.limitProgress) : h;
                  e.style.opacity = Math.min(Math.max(Math.abs(b), 0), 1);
                }
              }
              const w = x(0, i);
              (w.style.transform = o), (w.style.opacity = c), a.origin && (w.style.transformOrigin = a.origin);
            }
          },
          setTransition: (t) => {
            const e = b.slides.map((e) => n(e));
            e.forEach((e) => {
              (e.style.transitionDuration = t + 'ms'),
                e.querySelectorAll('.swiper-slide-shadow').forEach((e) => {
                  e.style.transitionDuration = t + 'ms';
                });
            }),
              m({ swiper: b, duration: t, transformElements: e, allSlides: !0 });
          },
          perspective: () => b.params.creativeEffect.perspective,
          overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !b.params.cssMode }),
        });
      },
      function (e) {
        let { swiper: b, extendParams: t, on: a } = e;
        t({ cardsEffect: { slideShadows: !0, rotate: !0, perSlideRotate: 2, perSlideOffset: 8 } }),
          o({
            effect: 'cards',
            swiper: b,
            on: a,
            setTranslate: () => {
              const { slides: l, activeIndex: n } = b,
                o = b.params.cardsEffect,
                { startTranslate: d, isTouched: p } = b.touchEventsData,
                c = b.translate;
              for (let f = 0; f < l.length; f += 1) {
                const v = l[f],
                  g = v.progress,
                  w = Math.min(Math.max(g, -4), 4);
                let e = v.swiperSlideOffset,
                  t =
                    (b.params.centeredSlides &&
                      !b.params.cssMode &&
                      (b.wrapperEl.style.transform = `translateX(${b.minTranslate()}px)`),
                    b.params.centeredSlides && b.params.cssMode && (e -= l[0].swiperSlideOffset),
                    b.params.cssMode ? -e - b.translate : -e),
                  a = 0;
                var u = -100 * Math.abs(w);
                let s = 1,
                  i = -o.perSlideRotate * w,
                  r = o.perSlideOffset - 0.75 * Math.abs(w);
                var m = b.virtual && b.params.virtual.enabled ? b.virtual.from + f : f,
                  h = (m === n || m === n - 1) && 0 < w && w < 1 && (p || b.params.cssMode) && c < d,
                  m = (m === n || m === n + 1) && w < 0 && -1 < w && (p || b.params.cssMode) && d < c;
                if (h || m) {
                  const l = (1 - Math.abs((Math.abs(w) - 0.5) / 0.5)) ** 0.5;
                  (i += -28 * w * l), (s += -0.5 * l), (r += 96 * l), (a = -25 * l * Math.abs(w) + '%');
                }
                if (
                  ((t =
                    w < 0
                      ? `calc(${t}px + (${r * Math.abs(w)}%))`
                      : 0 < w
                      ? `calc(${t}px + (-${r * Math.abs(w)}%))`
                      : t + 'px'),
                  !b.isHorizontal())
                ) {
                  const l = a;
                  (a = t), (t = l);
                }
                (h = w < 0 ? '' + (1 + (1 - s) * w) : '' + (1 - (1 - s) * w)),
                  (m = `
        translate3d(${t}, ${a}, ${u}px)
        rotateZ(${o.rotate ? i : 0}deg)
        scale(${h})
      `);
                if (o.slideShadows) {
                  let e = v.querySelector('.swiper-slide-shadow');
                  (e = e || C(0, v)) && (e.style.opacity = Math.min(Math.max((Math.abs(w) - 0.5) / 0.5, 0), 1));
                }
                (v.style.zIndex = -Math.abs(Math.round(g)) + l.length), (x(0, v).style.transform = m);
              }
            },
            setTransition: (t) => {
              const e = b.slides.map((e) => n(e));
              e.forEach((e) => {
                (e.style.transitionDuration = t + 'ms'),
                  e.querySelectorAll('.swiper-slide-shadow').forEach((e) => {
                    e.style.transitionDuration = t + 'ms';
                  });
              }),
                m({ swiper: b, duration: t, transformElements: e });
            },
            perspective: () => !0,
            overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !b.params.cssMode }),
          });
      },
    ]),
    y
  );
});
